// Generated by Haxe 4.0.0-rc.3+525b38ca4
(function ($hx_exports, $global) { "use strict";
$hx_exports["promhx"] = $hx_exports["promhx"] || {};
$hx_exports["octane"] = $hx_exports["octane"] || {};
$hx_exports["octane"]["preloader"] = $hx_exports["octane"]["preloader"] || {};
$hx_exports["octane"]["preloader"]["url"] = $hx_exports["octane"]["preloader"]["url"] || {};
$hx_exports["octane"]["preloader"]["url"]["model"] = $hx_exports["octane"]["preloader"]["url"]["model"] || {};
;$hx_exports["octane"]["preloader"]["state"] = $hx_exports["octane"]["preloader"]["state"] || {};
;$hx_exports["octane"]["preloader"]["service"] = $hx_exports["octane"]["preloader"]["service"] || {};
$hx_exports["octane"]["preloader"]["service"]["timer"] = $hx_exports["octane"]["preloader"]["service"]["timer"] || {};
;$hx_exports["octane"]["preloader"]["service"]["platform"] = $hx_exports["octane"]["preloader"]["service"]["platform"] || {};
;$hx_exports["octane"]["preloader"]["service"]["performance"] = $hx_exports["octane"]["preloader"]["service"]["performance"] || {};
;$hx_exports["octane"]["preloader"]["service"]["packaged"] = $hx_exports["octane"]["preloader"]["service"]["packaged"] || {};
;$hx_exports["octane"]["preloader"]["service"]["formfactor"] = $hx_exports["octane"]["preloader"]["service"]["formfactor"] || {};
;$hx_exports["octane"]["preloader"]["service"]["device"] = $hx_exports["octane"]["preloader"]["service"]["device"] || {};
;$hx_exports["octane"]["preloader"]["service"]["bundle"] = $hx_exports["octane"]["preloader"]["service"]["bundle"] || {};
;$hx_exports["octane"]["preloader"]["service"]["asset"] = $hx_exports["octane"]["preloader"]["service"]["asset"] || {};
$hx_exports["octane"]["preloader"]["service"]["asset"]["format"] = $hx_exports["octane"]["preloader"]["service"]["asset"]["format"] || {};
;$hx_exports["octane"]["preloader"]["model"] = $hx_exports["octane"]["preloader"]["model"] || {};
$hx_exports["octane"]["preloader"]["model"]["manifest"] = $hx_exports["octane"]["preloader"]["model"]["manifest"] || {};
;$hx_exports["octane"]["preloader"]["model"]["host"] = $hx_exports["octane"]["preloader"]["model"]["host"] || {};
;$hx_exports["octane"]["preloader"]["model"]["device"] = $hx_exports["octane"]["preloader"]["model"]["device"] || {};
;$hx_exports["octane"]["preloader"]["model"]["asset"] = $hx_exports["octane"]["preloader"]["model"]["asset"] || {};
$hx_exports["octane"]["preloader"]["model"]["asset"]["profile"] = $hx_exports["octane"]["preloader"]["model"]["asset"]["profile"] || {};
;$hx_exports["octane"]["browser"] = $hx_exports["octane"]["browser"] || {};
var $hxClasses = {},$estr = function() { return js_Boot.__string_rec(this,''); },$hxEnums = $hxEnums || {},$_;
function $extend(from, fields) {
	var proto = Object.create(from);
	for (var name in fields) proto[name] = fields[name];
	if( fields.toString !== Object.prototype.toString ) proto.toString = fields.toString;
	return proto;
}
var EReg = function(r,opt) {
	this.r = new RegExp(r,opt.split("u").join(""));
};
$hxClasses["EReg"] = EReg;
EReg.__name__ = "EReg";
EReg.prototype = {
	match: function(s) {
		if(this.r.global) {
			this.r.lastIndex = 0;
		}
		this.r.m = this.r.exec(s);
		this.r.s = s;
		return this.r.m != null;
	}
	,matched: function(n) {
		if(this.r.m != null && n >= 0 && n < this.r.m.length) {
			return this.r.m[n];
		} else {
			throw new js__$Boot_HaxeError("EReg::matched");
		}
	}
	,matchedRight: function() {
		if(this.r.m == null) {
			throw new js__$Boot_HaxeError("No string matched");
		}
		var sz = this.r.m.index + this.r.m[0].length;
		return HxOverrides.substr(this.r.s,sz,this.r.s.length - sz);
	}
	,split: function(s) {
		var d = "#__delim__#";
		return s.replace(this.r,d).split(d);
	}
	,__class__: EReg
};
var FilteredGlobalExceptionHandler = function() { };
$hxClasses["FilteredGlobalExceptionHandler"] = FilteredGlobalExceptionHandler;
FilteredGlobalExceptionHandler.__name__ = "FilteredGlobalExceptionHandler";
FilteredGlobalExceptionHandler.onError = function(event,source,lineno,colno,error) {
	if(FilteredGlobalExceptionHandler.hostOnError != null) {
		var message = event + "";
		if(!FilteredGlobalExceptionHandler.isNonFatalError(message)) {
			if(Object.prototype.hasOwnProperty.call(error,"stack")) {
				message += "\n" + Std.string(error.stack);
			}
			FilteredGlobalExceptionHandler.hostOnError(message,source,lineno,colno,error);
		}
	}
	return false;
};
FilteredGlobalExceptionHandler.invokeHostOnError = function(event,source,lineno,colno,error) {
	if(FilteredGlobalExceptionHandler.hostOnError == null) {
		return;
	}
	var message = event + "";
	if(FilteredGlobalExceptionHandler.isNonFatalError(message)) {
		return;
	}
	if(Object.prototype.hasOwnProperty.call(error,"stack")) {
		message += "\n" + Std.string(error.stack);
	}
	FilteredGlobalExceptionHandler.hostOnError(message,source,lineno,colno,error);
};
FilteredGlobalExceptionHandler.isNonFatalError = function(message) {
	if(FilteredGlobalExceptionHandler.NON_FATAL_BROWSER_ERRORS.match(message)) {
		return true;
	}
	if(FilteredGlobalExceptionHandler.NONFATAL_SERVICES_ERRORS.match(message)) {
		return true;
	}
	var isQQMobile = FilteredGlobalExceptionHandler.QQ_REGEX.match(FilteredGlobalExceptionHandler.userAgent);
	if(isQQMobile && FilteredGlobalExceptionHandler.QQ_NONFATAL_ERRORS.match(message)) {
		return true;
	}
	var isVivo = FilteredGlobalExceptionHandler.VIVO_REGEX.match(FilteredGlobalExceptionHandler.userAgent);
	if(isVivo && FilteredGlobalExceptionHandler.VIVO_NONFATAL_ERRORS.match(message)) {
		return true;
	}
	var isSogou = FilteredGlobalExceptionHandler.SOGOU_REGEX.match(FilteredGlobalExceptionHandler.userAgent);
	if(isSogou && FilteredGlobalExceptionHandler.SOGOU_NONFATAL_ERRORS.match(message)) {
		return true;
	}
	var isHawk = FilteredGlobalExceptionHandler.HAWK_REGEX.match(FilteredGlobalExceptionHandler.userAgent);
	if(isHawk && FilteredGlobalExceptionHandler.HAWK_NONFATAL_ERRORS.match(message)) {
		return true;
	}
	return false;
};
var GlobalExceptionHook = function() {
	this.HOOK_INTERVAL = 10;
	FilteredGlobalExceptionHandler.userAgent = window.navigator.userAgent;
	this.octaneErrorHandlerHookInterval = 0;
};
$hxClasses["GlobalExceptionHook"] = GlobalExceptionHook;
GlobalExceptionHook.__name__ = "GlobalExceptionHook";
GlobalExceptionHook.prototype = {
	hook: function() {
		if(this.octaneErrorHandlerHookInterval != 0) {
			return;
		}
		this.octaneErrorHandlerHookInterval = window.setInterval($bind(this,this.setErrorHandler),this.HOOK_INTERVAL);
	}
	,setErrorHandler: function() {
		if(window.onerror == FilteredGlobalExceptionHandler.onError) {
			return;
		}
		if(window.onerror != null) {
			FilteredGlobalExceptionHandler.hostOnError = window.onerror;
			window.clearInterval(this.octaneErrorHandlerHookInterval);
		}
		window.onerror = FilteredGlobalExceptionHandler.onError;
	}
	,__class__: GlobalExceptionHook
};
var HxOverrides = function() { };
$hxClasses["HxOverrides"] = HxOverrides;
HxOverrides.__name__ = "HxOverrides";
HxOverrides.cca = function(s,index) {
	var x = s.charCodeAt(index);
	if(x != x) {
		return undefined;
	}
	return x;
};
HxOverrides.substr = function(s,pos,len) {
	if(len == null) {
		len = s.length;
	} else if(len < 0) {
		if(pos == 0) {
			len = s.length + len;
		} else {
			return "";
		}
	}
	return s.substr(pos,len);
};
HxOverrides.iter = function(a) {
	return { cur : 0, arr : a, hasNext : function() {
		return this.cur < this.arr.length;
	}, next : function() {
		return this.arr[this.cur++];
	}};
};
var Lambda = function() { };
$hxClasses["Lambda"] = Lambda;
Lambda.__name__ = "Lambda";
Lambda.has = function(it,elt) {
	var x = $getIterator(it);
	while(x.hasNext()) {
		var x1 = x.next();
		if(x1 == elt) {
			return true;
		}
	}
	return false;
};
Math.__name__ = "Math";
var PreloaderMain = $hx_exports["PreloaderMain"] = function() { };
$hxClasses["PreloaderMain"] = PreloaderMain;
PreloaderMain.__name__ = "PreloaderMain";
PreloaderMain.main = function() {
	new GlobalExceptionHook().hook();
	octane_core_debug_Performance.markStart("Preloader");
	PreloaderMain.shell = new octane_preloader_shell_PreloaderShell();
	PreloaderMain.shell.startup();
	octane_core_debug_Performance.markEnd("Preloader");
};
PreloaderMain.getPreloaderInjector = function() {
	if(PreloaderMain.shell == null) {
		return null;
	}
	return PreloaderMain.shell.injector;
};
PreloaderMain.getPreloaderHxEnums = function() {
	var startupStatesEnum = Type.getEnum(octane_preloader_state_StartupStates.EngineInitialized);
	var startupActions = Type.getEnum(octane_preloader_state_StartupActions.DisplayGame);
	var launchType = Type.getEnum(octane_preloader_model_device_LaunchType.WebView);
	return { "octane.preloader.state.StartupStates" : startupStatesEnum, "octane.preloader.state.StartupActions" : startupActions, "octane.preloader.model.device.LaunchType" : launchType};
};
var Reflect = function() { };
$hxClasses["Reflect"] = Reflect;
Reflect.__name__ = "Reflect";
Reflect.field = function(o,field) {
	try {
		return o[field];
	} catch( e ) {
		var e1 = ((e) instanceof js__$Boot_HaxeError) ? e.val : e;
		return null;
	}
};
Reflect.setProperty = function(o,field,value) {
	var tmp;
	var tmp1;
	if(o.__properties__) {
		tmp = o.__properties__["set_" + field];
		tmp1 = tmp;
	} else {
		tmp1 = false;
	}
	if(tmp1) {
		o[tmp](value);
	} else {
		o[field] = value;
	}
};
Reflect.fields = function(o) {
	var a = [];
	if(o != null) {
		var hasOwnProperty = Object.prototype.hasOwnProperty;
		for( var f in o ) {
		if(f != "__id__" && f != "hx__closures__" && hasOwnProperty.call(o,f)) {
			a.push(f);
		}
		}
	}
	return a;
};
Reflect.compare = function(a,b) {
	if(a == b) {
		return 0;
	} else if(a > b) {
		return 1;
	} else {
		return -1;
	}
};
Reflect.isEnumValue = function(v) {
	if(v != null) {
		return v.__enum__ != null;
	} else {
		return false;
	}
};
Reflect.copy = function(o) {
	if(o == null) {
		return null;
	}
	var o2 = { };
	var _g = 0;
	var _g1 = Reflect.fields(o);
	while(_g < _g1.length) {
		var f = _g1[_g];
		++_g;
		o2[f] = Reflect.field(o,f);
	}
	return o2;
};
var Std = function() { };
$hxClasses["Std"] = Std;
Std.__name__ = "Std";
Std.string = function(s) {
	return js_Boot.__string_rec(s,"");
};
Std.parseInt = function(x) {
	var v = parseInt(x, x && x[0]=="0" && (x[1]=="x" || x[1]=="X") ? 16 : 10);
	if(isNaN(v)) {
		return null;
	}
	return v;
};
var StringBuf = function() {
	this.b = "";
};
$hxClasses["StringBuf"] = StringBuf;
StringBuf.__name__ = "StringBuf";
StringBuf.prototype = {
	__class__: StringBuf
};
var StringTools = function() { };
$hxClasses["StringTools"] = StringTools;
StringTools.__name__ = "StringTools";
StringTools.startsWith = function(s,start) {
	if(s.length >= start.length) {
		return s.lastIndexOf(start,0) == 0;
	} else {
		return false;
	}
};
StringTools.isSpace = function(s,pos) {
	var c = HxOverrides.cca(s,pos);
	if(!(c > 8 && c < 14)) {
		return c == 32;
	} else {
		return true;
	}
};
StringTools.ltrim = function(s) {
	var l = s.length;
	var r = 0;
	while(r < l && StringTools.isSpace(s,r)) ++r;
	if(r > 0) {
		return HxOverrides.substr(s,r,l - r);
	} else {
		return s;
	}
};
StringTools.rtrim = function(s) {
	var l = s.length;
	var r = 0;
	while(r < l && StringTools.isSpace(s,l - r - 1)) ++r;
	if(r > 0) {
		return HxOverrides.substr(s,0,l - r);
	} else {
		return s;
	}
};
StringTools.trim = function(s) {
	return StringTools.ltrim(StringTools.rtrim(s));
};
StringTools.replace = function(s,sub,by) {
	return s.split(sub).join(by);
};
var ValueType = $hxEnums["ValueType"] = { __ename__ : "ValueType", __constructs__ : ["TNull","TInt","TFloat","TBool","TObject","TFunction","TClass","TEnum","TUnknown"]
	,TNull: {_hx_index:0,__enum__:"ValueType",toString:$estr}
	,TInt: {_hx_index:1,__enum__:"ValueType",toString:$estr}
	,TFloat: {_hx_index:2,__enum__:"ValueType",toString:$estr}
	,TBool: {_hx_index:3,__enum__:"ValueType",toString:$estr}
	,TObject: {_hx_index:4,__enum__:"ValueType",toString:$estr}
	,TFunction: {_hx_index:5,__enum__:"ValueType",toString:$estr}
	,TClass: ($_=function(c) { return {_hx_index:6,c:c,__enum__:"ValueType",toString:$estr}; },$_.__params__ = ["c"],$_)
	,TEnum: ($_=function(e) { return {_hx_index:7,e:e,__enum__:"ValueType",toString:$estr}; },$_.__params__ = ["e"],$_)
	,TUnknown: {_hx_index:8,__enum__:"ValueType",toString:$estr}
};
var Type = function() { };
$hxClasses["Type"] = Type;
Type.__name__ = "Type";
Type.getEnum = function(o) {
	if(o == null) {
		return null;
	}
	return $hxEnums[o.__enum__];
};
Type.createInstance = function(cl,args) {
	return new (Function.prototype.bind.apply(cl,[null].concat(args)));
};
Type.typeof = function(v) {
	switch(typeof(v)) {
	case "boolean":
		return ValueType.TBool;
	case "function":
		if(v.__name__ || v.__ename__) {
			return ValueType.TObject;
		}
		return ValueType.TFunction;
	case "number":
		if(Math.ceil(v) == v % 2147483648.0) {
			return ValueType.TInt;
		}
		return ValueType.TFloat;
	case "object":
		if(v == null) {
			return ValueType.TNull;
		}
		var e = v.__enum__;
		if(e != null) {
			return ValueType.TEnum($hxEnums[e]);
		}
		var c = js_Boot.getClass(v);
		if(c != null) {
			return ValueType.TClass(c);
		}
		return ValueType.TObject;
	case "string":
		return ValueType.TClass(String);
	case "undefined":
		return ValueType.TNull;
	default:
		return ValueType.TUnknown;
	}
};
Type.enumParameters = function(e) {
	var enm = $hxEnums[e.__enum__];
	var ctorName = enm.__constructs__[e._hx_index];
	var params = enm[ctorName].__params__;
	if(params != null) {
		var _g = [];
		var _g1 = 0;
		while(_g1 < params.length) {
			var p = params[_g1];
			++_g1;
			_g.push(e[p]);
		}
		return _g;
	} else {
		return [];
	}
};
var haxe_StackItem = $hxEnums["haxe.StackItem"] = { __ename__ : "haxe.StackItem", __constructs__ : ["CFunction","Module","FilePos","Method","LocalFunction"]
	,CFunction: {_hx_index:0,__enum__:"haxe.StackItem",toString:$estr}
	,Module: ($_=function(m) { return {_hx_index:1,m:m,__enum__:"haxe.StackItem",toString:$estr}; },$_.__params__ = ["m"],$_)
	,FilePos: ($_=function(s,file,line,column) { return {_hx_index:2,s:s,file:file,line:line,column:column,__enum__:"haxe.StackItem",toString:$estr}; },$_.__params__ = ["s","file","line","column"],$_)
	,Method: ($_=function(classname,method) { return {_hx_index:3,classname:classname,method:method,__enum__:"haxe.StackItem",toString:$estr}; },$_.__params__ = ["classname","method"],$_)
	,LocalFunction: ($_=function(v) { return {_hx_index:4,v:v,__enum__:"haxe.StackItem",toString:$estr}; },$_.__params__ = ["v"],$_)
};
var haxe_CallStack = function() { };
$hxClasses["haxe.CallStack"] = haxe_CallStack;
haxe_CallStack.__name__ = "haxe.CallStack";
haxe_CallStack.getStack = function(e) {
	if(e == null) {
		return [];
	}
	var oldValue = Error.prepareStackTrace;
	Error.prepareStackTrace = function(error,callsites) {
		var stack = [];
		var _g = 0;
		while(_g < callsites.length) {
			var site = callsites[_g];
			++_g;
			if(haxe_CallStack.wrapCallSite != null) {
				site = haxe_CallStack.wrapCallSite(site);
			}
			var method = null;
			var fullName = site.getFunctionName();
			if(fullName != null) {
				var idx = fullName.lastIndexOf(".");
				if(idx >= 0) {
					var className = HxOverrides.substr(fullName,0,idx);
					var methodName = HxOverrides.substr(fullName,idx + 1,null);
					method = haxe_StackItem.Method(className,methodName);
				}
			}
			var fileName = site.getFileName();
			var fileAddr = fileName == null ? -1 : fileName.indexOf("file:");
			if(haxe_CallStack.wrapCallSite != null && fileAddr > 0) {
				fileName = HxOverrides.substr(fileName,fileAddr + 6,null);
			}
			stack.push(haxe_StackItem.FilePos(method,fileName,site.getLineNumber(),site.getColumnNumber()));
		}
		return stack;
	};
	var a = haxe_CallStack.makeStack(e.stack);
	Error.prepareStackTrace = oldValue;
	return a;
};
haxe_CallStack.callStack = function() {
	try {
		throw new Error();
	} catch( e ) {
		var e1 = ((e) instanceof js__$Boot_HaxeError) ? e.val : e;
		var a = haxe_CallStack.getStack(e);
		a.shift();
		return a;
	}
};
haxe_CallStack.toString = function(stack) {
	var b = new StringBuf();
	var _g = 0;
	while(_g < stack.length) {
		var s = stack[_g];
		++_g;
		b.b += "\nCalled from ";
		haxe_CallStack.itemToString(b,s);
	}
	return b.b;
};
haxe_CallStack.itemToString = function(b,s) {
	switch(s._hx_index) {
	case 0:
		b.b += "a C function";
		break;
	case 1:
		var m = s.m;
		b.b += "module ";
		b.b += m == null ? "null" : "" + m;
		break;
	case 2:
		var col = s.column;
		var line = s.line;
		var file = s.file;
		var s1 = s.s;
		if(s1 != null) {
			haxe_CallStack.itemToString(b,s1);
			b.b += " (";
		}
		b.b += file == null ? "null" : "" + file;
		b.b += " line ";
		b.b += line == null ? "null" : "" + line;
		if(col != null) {
			b.b += " column ";
			b.b += col == null ? "null" : "" + col;
		}
		if(s1 != null) {
			b.b += ")";
		}
		break;
	case 3:
		var meth = s.method;
		var cname = s.classname;
		b.b += Std.string(cname == null ? "<unknown>" : cname);
		b.b += ".";
		b.b += meth == null ? "null" : "" + meth;
		break;
	case 4:
		var n = s.v;
		b.b += "local function #";
		b.b += n == null ? "null" : "" + n;
		break;
	}
};
haxe_CallStack.makeStack = function(s) {
	if(s == null) {
		return [];
	} else if(typeof(s) == "string") {
		var stack = s.split("\n");
		if(stack[0] == "Error") {
			stack.shift();
		}
		var m = [];
		var rie10 = new EReg("^   at ([A-Za-z0-9_. ]+) \\(([^)]+):([0-9]+):([0-9]+)\\)$","");
		var _g = 0;
		while(_g < stack.length) {
			var line = stack[_g];
			++_g;
			if(rie10.match(line)) {
				var path = rie10.matched(1).split(".");
				var meth = path.pop();
				var file = rie10.matched(2);
				var line1 = Std.parseInt(rie10.matched(3));
				var column = Std.parseInt(rie10.matched(4));
				m.push(haxe_StackItem.FilePos(meth == "Anonymous function" ? haxe_StackItem.LocalFunction() : meth == "Global code" ? null : haxe_StackItem.Method(path.join("."),meth),file,line1,column));
			} else {
				m.push(haxe_StackItem.Module(StringTools.trim(line)));
			}
		}
		return m;
	} else {
		return s;
	}
};
var haxe_IMap = function() { };
$hxClasses["haxe.IMap"] = haxe_IMap;
haxe_IMap.__name__ = "haxe.IMap";
haxe_IMap.__isInterface__ = true;
var haxe_Timer = function(time_ms) {
	var me = this;
	this.id = setInterval(function() {
		me.run();
	},time_ms);
};
$hxClasses["haxe.Timer"] = haxe_Timer;
haxe_Timer.__name__ = "haxe.Timer";
haxe_Timer.delay = function(f,time_ms) {
	var t = new haxe_Timer(time_ms);
	t.run = function() {
		t.stop();
		f();
	};
	return t;
};
haxe_Timer.prototype = {
	stop: function() {
		if(this.id == null) {
			return;
		}
		clearInterval(this.id);
		this.id = null;
	}
	,run: function() {
	}
	,__class__: haxe_Timer
};
var haxe_ds_ArraySort = function() { };
$hxClasses["haxe.ds.ArraySort"] = haxe_ds_ArraySort;
haxe_ds_ArraySort.__name__ = "haxe.ds.ArraySort";
haxe_ds_ArraySort.sort = function(a,cmp) {
	haxe_ds_ArraySort.rec(a,cmp,0,a.length);
};
haxe_ds_ArraySort.rec = function(a,cmp,from,to) {
	var middle = from + to >> 1;
	if(to - from < 12) {
		if(to <= from) {
			return;
		}
		var _g = from + 1;
		var _g1 = to;
		while(_g < _g1) {
			var i = _g++;
			var j = i;
			while(j > from) {
				if(cmp(a[j],a[j - 1]) < 0) {
					haxe_ds_ArraySort.swap(a,j - 1,j);
				} else {
					break;
				}
				--j;
			}
		}
		return;
	}
	haxe_ds_ArraySort.rec(a,cmp,from,middle);
	haxe_ds_ArraySort.rec(a,cmp,middle,to);
	haxe_ds_ArraySort.doMerge(a,cmp,from,middle,to,middle - from,to - middle);
};
haxe_ds_ArraySort.doMerge = function(a,cmp,from,pivot,to,len1,len2) {
	var first_cut;
	var second_cut;
	var len11;
	var len22;
	if(len1 == 0 || len2 == 0) {
		return;
	}
	if(len1 + len2 == 2) {
		if(cmp(a[pivot],a[from]) < 0) {
			haxe_ds_ArraySort.swap(a,pivot,from);
		}
		return;
	}
	if(len1 > len2) {
		len11 = len1 >> 1;
		first_cut = from + len11;
		second_cut = haxe_ds_ArraySort.lower(a,cmp,pivot,to,first_cut);
		len22 = second_cut - pivot;
	} else {
		len22 = len2 >> 1;
		second_cut = pivot + len22;
		first_cut = haxe_ds_ArraySort.upper(a,cmp,from,pivot,second_cut);
		len11 = first_cut - from;
	}
	haxe_ds_ArraySort.rotate(a,cmp,first_cut,pivot,second_cut);
	var new_mid = first_cut + len22;
	haxe_ds_ArraySort.doMerge(a,cmp,from,first_cut,new_mid,len11,len22);
	haxe_ds_ArraySort.doMerge(a,cmp,new_mid,second_cut,to,len1 - len11,len2 - len22);
};
haxe_ds_ArraySort.rotate = function(a,cmp,from,mid,to) {
	if(from == mid || mid == to) {
		return;
	}
	var n = haxe_ds_ArraySort.gcd(to - from,mid - from);
	while(n-- != 0) {
		var val = a[from + n];
		var shift = mid - from;
		var p1 = from + n;
		var p2 = from + n + shift;
		while(p2 != from + n) {
			a[p1] = a[p2];
			p1 = p2;
			if(to - p2 > shift) {
				p2 += shift;
			} else {
				p2 = from + (shift - (to - p2));
			}
		}
		a[p1] = val;
	}
};
haxe_ds_ArraySort.gcd = function(m,n) {
	while(n != 0) {
		var t = m % n;
		m = n;
		n = t;
	}
	return m;
};
haxe_ds_ArraySort.upper = function(a,cmp,from,to,val) {
	var len = to - from;
	var half;
	var mid;
	while(len > 0) {
		half = len >> 1;
		mid = from + half;
		if(cmp(a[val],a[mid]) < 0) {
			len = half;
		} else {
			from = mid + 1;
			len = len - half - 1;
		}
	}
	return from;
};
haxe_ds_ArraySort.lower = function(a,cmp,from,to,val) {
	var len = to - from;
	var half;
	var mid;
	while(len > 0) {
		half = len >> 1;
		mid = from + half;
		if(cmp(a[mid],a[val]) < 0) {
			from = mid + 1;
			len = len - half - 1;
		} else {
			len = half;
		}
	}
	return from;
};
haxe_ds_ArraySort.swap = function(a,i,j) {
	var tmp = a[i];
	a[i] = a[j];
	a[j] = tmp;
};
var haxe_ds_BalancedTree = function() {
};
$hxClasses["haxe.ds.BalancedTree"] = haxe_ds_BalancedTree;
haxe_ds_BalancedTree.__name__ = "haxe.ds.BalancedTree";
haxe_ds_BalancedTree.__interfaces__ = [haxe_IMap];
haxe_ds_BalancedTree.prototype = {
	set: function(key,value) {
		this.root = this.setLoop(key,value,this.root);
	}
	,get: function(key) {
		var node = this.root;
		while(node != null) {
			var c = this.compare(key,node.key);
			if(c == 0) {
				return node.value;
			}
			if(c < 0) {
				node = node.left;
			} else {
				node = node.right;
			}
		}
		return null;
	}
	,exists: function(key) {
		var node = this.root;
		while(node != null) {
			var c = this.compare(key,node.key);
			if(c == 0) {
				return true;
			} else if(c < 0) {
				node = node.left;
			} else {
				node = node.right;
			}
		}
		return false;
	}
	,setLoop: function(k,v,node) {
		if(node == null) {
			return new haxe_ds_TreeNode(null,k,v,null);
		}
		var c = this.compare(k,node.key);
		if(c == 0) {
			return new haxe_ds_TreeNode(node.left,k,v,node.right,node == null ? 0 : node._height);
		} else if(c < 0) {
			var nl = this.setLoop(k,v,node.left);
			return this.balance(nl,node.key,node.value,node.right);
		} else {
			var nr = this.setLoop(k,v,node.right);
			return this.balance(node.left,node.key,node.value,nr);
		}
	}
	,balance: function(l,k,v,r) {
		var hl = l == null ? 0 : l._height;
		var hr = r == null ? 0 : r._height;
		if(hl > hr + 2) {
			var _this = l.left;
			var _this1 = l.right;
			if((_this == null ? 0 : _this._height) >= (_this1 == null ? 0 : _this1._height)) {
				return new haxe_ds_TreeNode(l.left,l.key,l.value,new haxe_ds_TreeNode(l.right,k,v,r));
			} else {
				return new haxe_ds_TreeNode(new haxe_ds_TreeNode(l.left,l.key,l.value,l.right.left),l.right.key,l.right.value,new haxe_ds_TreeNode(l.right.right,k,v,r));
			}
		} else if(hr > hl + 2) {
			var _this2 = r.right;
			var _this3 = r.left;
			if((_this2 == null ? 0 : _this2._height) > (_this3 == null ? 0 : _this3._height)) {
				return new haxe_ds_TreeNode(new haxe_ds_TreeNode(l,k,v,r.left),r.key,r.value,r.right);
			} else {
				return new haxe_ds_TreeNode(new haxe_ds_TreeNode(l,k,v,r.left.left),r.left.key,r.left.value,new haxe_ds_TreeNode(r.left.right,r.key,r.value,r.right));
			}
		} else {
			return new haxe_ds_TreeNode(l,k,v,r,(hl > hr ? hl : hr) + 1);
		}
	}
	,compare: function(k1,k2) {
		return Reflect.compare(k1,k2);
	}
	,__class__: haxe_ds_BalancedTree
};
var haxe_ds_TreeNode = function(l,k,v,r,h) {
	if(h == null) {
		h = -1;
	}
	this.left = l;
	this.key = k;
	this.value = v;
	this.right = r;
	if(h == -1) {
		var tmp;
		var _this = this.left;
		var _this1 = this.right;
		if((_this == null ? 0 : _this._height) > (_this1 == null ? 0 : _this1._height)) {
			var _this2 = this.left;
			tmp = _this2 == null ? 0 : _this2._height;
		} else {
			var _this3 = this.right;
			tmp = _this3 == null ? 0 : _this3._height;
		}
		this._height = tmp + 1;
	} else {
		this._height = h;
	}
};
$hxClasses["haxe.ds.TreeNode"] = haxe_ds_TreeNode;
haxe_ds_TreeNode.__name__ = "haxe.ds.TreeNode";
haxe_ds_TreeNode.prototype = {
	__class__: haxe_ds_TreeNode
};
var haxe_ds_EnumValueMap = function() {
	haxe_ds_BalancedTree.call(this);
};
$hxClasses["haxe.ds.EnumValueMap"] = haxe_ds_EnumValueMap;
haxe_ds_EnumValueMap.__name__ = "haxe.ds.EnumValueMap";
haxe_ds_EnumValueMap.__interfaces__ = [haxe_IMap];
haxe_ds_EnumValueMap.__super__ = haxe_ds_BalancedTree;
haxe_ds_EnumValueMap.prototype = $extend(haxe_ds_BalancedTree.prototype,{
	compare: function(k1,k2) {
		var d = k1._hx_index - k2._hx_index;
		if(d != 0) {
			return d;
		}
		var p1 = Type.enumParameters(k1);
		var p2 = Type.enumParameters(k2);
		if(p1.length == 0 && p2.length == 0) {
			return 0;
		}
		return this.compareArgs(p1,p2);
	}
	,compareArgs: function(a1,a2) {
		var ld = a1.length - a2.length;
		if(ld != 0) {
			return ld;
		}
		var _g = 0;
		var _g1 = a1.length;
		while(_g < _g1) {
			var i = _g++;
			var d = this.compareArg(a1[i],a2[i]);
			if(d != 0) {
				return d;
			}
		}
		return 0;
	}
	,compareArg: function(v1,v2) {
		if(Reflect.isEnumValue(v1) && Reflect.isEnumValue(v2)) {
			return this.compare(v1,v2);
		} else if(((v1) instanceof Array) && v1.__enum__ == null && (((v2) instanceof Array) && v2.__enum__ == null)) {
			return this.compareArgs(v1,v2);
		} else {
			return Reflect.compare(v1,v2);
		}
	}
	,__class__: haxe_ds_EnumValueMap
});
var haxe_ds_IntMap = function() {
	this.h = { };
};
$hxClasses["haxe.ds.IntMap"] = haxe_ds_IntMap;
haxe_ds_IntMap.__name__ = "haxe.ds.IntMap";
haxe_ds_IntMap.__interfaces__ = [haxe_IMap];
haxe_ds_IntMap.prototype = {
	keys: function() {
		var a = [];
		for( var key in this.h ) this.h.hasOwnProperty(key) ? a.push(key | 0) : null;
		return HxOverrides.iter(a);
	}
	,__class__: haxe_ds_IntMap
};
var haxe_ds_List = function() {
	this.length = 0;
};
$hxClasses["haxe.ds.List"] = haxe_ds_List;
haxe_ds_List.__name__ = "haxe.ds.List";
haxe_ds_List.prototype = {
	add: function(item) {
		var x = new haxe_ds__$List_ListNode(item,null);
		if(this.h == null) {
			this.h = x;
		} else {
			this.q.next = x;
		}
		this.q = x;
		this.length++;
	}
	,pop: function() {
		if(this.h == null) {
			return null;
		}
		var x = this.h.item;
		this.h = this.h.next;
		if(this.h == null) {
			this.q = null;
		}
		this.length--;
		return x;
	}
	,isEmpty: function() {
		return this.h == null;
	}
	,__class__: haxe_ds_List
};
var haxe_ds__$List_ListNode = function(item,next) {
	this.item = item;
	this.next = next;
};
$hxClasses["haxe.ds._List.ListNode"] = haxe_ds__$List_ListNode;
haxe_ds__$List_ListNode.__name__ = "haxe.ds._List.ListNode";
haxe_ds__$List_ListNode.prototype = {
	__class__: haxe_ds__$List_ListNode
};
var haxe_ds_Option = $hxEnums["haxe.ds.Option"] = { __ename__ : "haxe.ds.Option", __constructs__ : ["Some","None"]
	,Some: ($_=function(v) { return {_hx_index:0,v:v,__enum__:"haxe.ds.Option",toString:$estr}; },$_.__params__ = ["v"],$_)
	,None: {_hx_index:1,__enum__:"haxe.ds.Option",toString:$estr}
};
var haxe_ds_StringMap = function() {
	this.h = { };
};
$hxClasses["haxe.ds.StringMap"] = haxe_ds_StringMap;
haxe_ds_StringMap.__name__ = "haxe.ds.StringMap";
haxe_ds_StringMap.__interfaces__ = [haxe_IMap];
haxe_ds_StringMap.prototype = {
	setReserved: function(key,value) {
		if(this.rh == null) {
			this.rh = { };
		}
		this.rh["$" + key] = value;
	}
	,getReserved: function(key) {
		if(this.rh == null) {
			return null;
		} else {
			return this.rh["$" + key];
		}
	}
	,existsReserved: function(key) {
		if(this.rh == null) {
			return false;
		}
		return this.rh.hasOwnProperty("$" + key);
	}
	,remove: function(key) {
		if(__map_reserved[key] != null) {
			key = "$" + key;
			if(this.rh == null || !this.rh.hasOwnProperty(key)) {
				return false;
			}
			delete(this.rh[key]);
			return true;
		} else {
			if(!this.h.hasOwnProperty(key)) {
				return false;
			}
			delete(this.h[key]);
			return true;
		}
	}
	,__class__: haxe_ds_StringMap
};
var haxe_rtti_Meta = function() { };
$hxClasses["haxe.rtti.Meta"] = haxe_rtti_Meta;
haxe_rtti_Meta.__name__ = "haxe.rtti.Meta";
haxe_rtti_Meta.getType = function(t) {
	var meta = haxe_rtti_Meta.getMeta(t);
	if(meta == null || meta.obj == null) {
		return { };
	} else {
		return meta.obj;
	}
};
haxe_rtti_Meta.getMeta = function(t) {
	return t.__meta__;
};
var hx_event_ISignalType = function() { };
$hxClasses["hx.event.ISignalType"] = hx_event_ISignalType;
hx_event_ISignalType.__name__ = "hx.event.ISignalType";
hx_event_ISignalType.__isInterface__ = true;
hx_event_ISignalType.prototype = {
	__class__: hx_event_ISignalType
};
var hx_event_ISignal = function() { };
$hxClasses["hx.event.ISignal"] = hx_event_ISignal;
hx_event_ISignal.__name__ = "hx.event.ISignal";
hx_event_ISignal.__isInterface__ = true;
hx_event_ISignal.__interfaces__ = [hx_event_ISignalType];
hx_event_ISignal.prototype = {
	__class__: hx_event_ISignal
};
var hx_event_BaseSignal = function() {
	this.id = hx_event_BaseSignal.count++;
	this.dispatching = false;
	this.numListeners = 0;
};
$hxClasses["hx.event.BaseSignal"] = hx_event_BaseSignal;
hx_event_BaseSignal.__name__ = "hx.event.BaseSignal";
hx_event_BaseSignal.__interfaces__ = [hx_event_ISignal];
hx_event_BaseSignal.prototype = {
	dispose: function(slots) {
		if(slots == null) {
			slots = true;
		}
		if(slots) {
			this.end();
			var currentSlot = this.head;
			while(currentSlot != null) {
				currentSlot.dispose();
				var nextSlot = currentSlot.next;
				currentSlot.next = null;
				currentSlot = nextSlot;
			}
			var s = this.head;
			if(s != null) {
				s.dispose();
			}
			var s1 = this.tail;
			if(s1 != null) {
				s1.dispose();
			}
			var s2 = this.toAddHead;
			if(s2 != null) {
				s2.dispose();
			}
			var s3 = this.toAddTail;
			if(s3 != null) {
				s3.dispose();
			}
		}
		this.head = this.tail = this.toAddHead = this.toAddTail = null;
		this.numListeners = 0;
	}
	,chain: function(listener,once) {
		if(listener.id == this.id) {
			throw new js__$Boot_HaxeError("Signals cannot be chained to themselves.");
		}
		var dispatchFn = Reflect.field(listener,"dispatch");
		var chainedListener = function(args) {
			dispatchFn.apply(listener,args);
		};
		var baseSignal = js_Boot.__cast(this , hx_event_IBaseSignal);
		return baseSignal.dynamicAdd(chainedListener,once);
	}
	,add: function(listener,once) {
		this.numListeners++;
		var slot = new hx_event_Slot(this,listener,once);
		if(this.dispatching) {
			if(this.toAddHead == null) {
				this.toAddHead = this.toAddTail = slot;
			} else {
				this.toAddTail.next = slot;
				slot.previous = this.toAddTail;
				this.toAddTail = slot;
			}
		} else if(this.head == null) {
			this.head = this.tail = slot;
		} else {
			this.tail.next = slot;
			slot.previous = this.tail;
			this.tail = slot;
		}
		return slot;
	}
	,remove: function(slot,listener) {
		if(slot == null) {
			slot = this.get(listener);
		}
		if(slot == null) {
			return;
		}
		this.numListeners--;
		if(this.head == slot) {
			this.head = this.head.next;
		}
		if(this.tail == slot) {
			this.tail = this.tail.previous;
		}
		if(this.toAddHead == slot) {
			this.toAddHead = this.toAddHead.next;
		}
		if(this.toAddTail == slot) {
			this.toAddTail = this.toAddTail.previous;
		}
		if(slot.previous != null) {
			slot.previous.next = slot.next;
		}
		if(slot.next != null) {
			slot.next.previous = slot.previous;
		}
	}
	,get: function(listener) {
		var slot = this.head;
		while(slot != null) if(slot.listener == listener) {
			return slot;
		} else {
			slot = slot.next;
		}
		var slot1 = this.head;
		if(slot1 != null && slot1.listener == listener) {
			return slot1;
		}
		var slot2 = this.tail;
		if(slot2 != null && slot2.listener == listener) {
			return slot2;
		}
		var slot3 = this.toAddHead;
		if(slot3 != null && slot3.listener == listener) {
			return slot3;
		}
		var slot4 = this.toAddTail;
		if(slot4 != null && slot4.listener == listener) {
			return slot4;
		}
		return null;
	}
	,start: function() {
		this.dispatching = true;
	}
	,end: function() {
		this.dispatching = false;
		if(this.toAddHead != null) {
			if(this.head == null) {
				this.head = this.toAddHead;
				this.tail = this.toAddTail;
			} else {
				this.tail.next = this.toAddHead;
				this.toAddHead.previous = this.tail;
				this.tail = this.toAddTail;
			}
			this.toAddHead = this.toAddTail = null;
		}
	}
	,__class__: hx_event_BaseSignal
};
var hx_event_IBaseSignal = function() { };
$hxClasses["hx.event.IBaseSignal"] = hx_event_IBaseSignal;
hx_event_IBaseSignal.__name__ = "hx.event.IBaseSignal";
hx_event_IBaseSignal.__isInterface__ = true;
hx_event_IBaseSignal.__interfaces__ = [hx_event_ISignalType];
hx_event_IBaseSignal.prototype = {
	__class__: hx_event_IBaseSignal
};
var hx_event_ISlot = function() { };
$hxClasses["hx.event.ISlot"] = hx_event_ISlot;
hx_event_ISlot.__name__ = "hx.event.ISlot";
hx_event_ISlot.__isInterface__ = true;
hx_event_ISlot.prototype = {
	__class__: hx_event_ISlot
};
var hx_event_Signal = function() {
	hx_event_BaseSignal.call(this);
};
$hxClasses["hx.event.Signal"] = hx_event_Signal;
hx_event_Signal.__name__ = "hx.event.Signal";
hx_event_Signal.__interfaces__ = [hx_event_IBaseSignal,hx_event_ISignal];
hx_event_Signal.__super__ = hx_event_BaseSignal;
hx_event_Signal.prototype = $extend(hx_event_BaseSignal.prototype,{
	dispatch: function(rest) {
	}
	,dynamicAdd: function(listener,once) {
		if(once == null) {
			once = false;
		}
		return null;
	}
	,__class__: hx_event_Signal
});
var hx_event_Signal0 = function() {
	hx_event_BaseSignal.call(this);
};
$hxClasses["hx.event.Signal0"] = hx_event_Signal0;
hx_event_Signal0.__name__ = "hx.event.Signal0";
hx_event_Signal0.__interfaces__ = [hx_event_IBaseSignal];
hx_event_Signal0.__super__ = hx_event_BaseSignal;
hx_event_Signal0.prototype = $extend(hx_event_BaseSignal.prototype,{
	dispatch: function() {
		this.dispatching = true;
		var slot = this.head;
		while(slot != null) {
			slot.listener();
			if(slot.once) {
				slot.dispose();
			}
			slot = slot.next;
		}
		this.end();
		return;
	}
	,dynamicAdd: function(listener,once) {
		if(once == null) {
			once = false;
		}
		return this.add(function() {
			listener([]);
			return;
		},once);
	}
	,__class__: hx_event_Signal0
});
var hx_event_Signal1 = function() {
	hx_event_BaseSignal.call(this);
};
$hxClasses["hx.event.Signal1"] = hx_event_Signal1;
hx_event_Signal1.__name__ = "hx.event.Signal1";
hx_event_Signal1.__interfaces__ = [hx_event_IBaseSignal];
hx_event_Signal1.__super__ = hx_event_BaseSignal;
hx_event_Signal1.prototype = $extend(hx_event_BaseSignal.prototype,{
	dispatch: function(arg0) {
		this.dispatching = true;
		var slot = this.head;
		while(slot != null) {
			slot.listener(arg0);
			if(slot.once) {
				slot.dispose();
			}
			slot = slot.next;
		}
		this.end();
		return;
	}
	,dynamicAdd: function(listener,once) {
		if(once == null) {
			once = false;
		}
		return this.add(function(arg0) {
			listener([arg0]);
			return;
		},once);
	}
	,__class__: hx_event_Signal1
});
var hx_event_Signal2 = function() {
	hx_event_BaseSignal.call(this);
};
$hxClasses["hx.event.Signal2"] = hx_event_Signal2;
hx_event_Signal2.__name__ = "hx.event.Signal2";
hx_event_Signal2.__interfaces__ = [hx_event_IBaseSignal];
hx_event_Signal2.__super__ = hx_event_BaseSignal;
hx_event_Signal2.prototype = $extend(hx_event_BaseSignal.prototype,{
	dispatch: function(arg0,arg1) {
		this.dispatching = true;
		var slot = this.head;
		while(slot != null) {
			slot.listener(arg0,arg1);
			if(slot.once) {
				slot.dispose();
			}
			slot = slot.next;
		}
		this.end();
		return;
	}
	,dynamicAdd: function(listener,once) {
		if(once == null) {
			once = false;
		}
		return this.add(function(arg0,arg1) {
			listener([arg0,arg1]);
			return;
		},once);
	}
	,__class__: hx_event_Signal2
});
var hx_event_Slot = function(signal,listener,once) {
	this.signal = signal;
	this.listener = listener;
	this.once = once;
};
$hxClasses["hx.event.Slot"] = hx_event_Slot;
hx_event_Slot.__name__ = "hx.event.Slot";
hx_event_Slot.__interfaces__ = [hx_event_ISlot];
hx_event_Slot.prototype = {
	dispose: function() {
		if(this.signal != null) {
			this.signal.remove(this);
			this.signal = null;
		}
		this.listener = null;
	}
	,get_disposed: function() {
		if(this.listener == null) {
			return this.signal == null;
		} else {
			return false;
		}
	}
	,__class__: hx_event_Slot
	,__properties__: {get_disposed:"get_disposed"}
};
var js__$Boot_HaxeError = function(val) {
	Error.call(this);
	this.val = val;
	if(Error.captureStackTrace) {
		Error.captureStackTrace(this,js__$Boot_HaxeError);
	}
};
$hxClasses["js._Boot.HaxeError"] = js__$Boot_HaxeError;
js__$Boot_HaxeError.__name__ = "js._Boot.HaxeError";
js__$Boot_HaxeError.wrap = function(val) {
	if(((val) instanceof Error)) {
		return val;
	} else {
		return new js__$Boot_HaxeError(val);
	}
};
js__$Boot_HaxeError.__super__ = Error;
js__$Boot_HaxeError.prototype = $extend(Error.prototype,{
	__class__: js__$Boot_HaxeError
});
var js_Boot = function() { };
$hxClasses["js.Boot"] = js_Boot;
js_Boot.__name__ = "js.Boot";
js_Boot.getClass = function(o) {
	if(o == null) {
		return null;
	} else if(((o) instanceof Array) && o.__enum__ == null) {
		return Array;
	} else {
		var cl = o.__class__;
		if(cl != null) {
			return cl;
		}
		var name = js_Boot.__nativeClassName(o);
		if(name != null) {
			return js_Boot.__resolveNativeClass(name);
		}
		return null;
	}
};
js_Boot.__string_rec = function(o,s) {
	if(o == null) {
		return "null";
	}
	if(s.length >= 5) {
		return "<...>";
	}
	var t = typeof(o);
	if(t == "function" && (o.__name__ || o.__ename__)) {
		t = "object";
	}
	switch(t) {
	case "function":
		return "<function>";
	case "object":
		if(o.__enum__) {
			var e = $hxEnums[o.__enum__];
			var n = e.__constructs__[o._hx_index];
			var con = e[n];
			if(con.__params__) {
				s = s + "\t";
				return n + "(" + ((function($this) {
					var $r;
					var _g = [];
					{
						var _g1 = 0;
						var _g2 = con.__params__;
						while(true) {
							if(!(_g1 < _g2.length)) {
								break;
							}
							var p = _g2[_g1];
							_g1 = _g1 + 1;
							_g.push(js_Boot.__string_rec(o[p],s));
						}
					}
					$r = _g;
					return $r;
				}(this))).join(",") + ")";
			} else {
				return n;
			}
		}
		if(((o) instanceof Array)) {
			var str = "[";
			s += "\t";
			var _g3 = 0;
			var _g11 = o.length;
			while(_g3 < _g11) {
				var i = _g3++;
				str += (i > 0 ? "," : "") + js_Boot.__string_rec(o[i],s);
			}
			str += "]";
			return str;
		}
		var tostr;
		try {
			tostr = o.toString;
		} catch( e1 ) {
			var e2 = ((e1) instanceof js__$Boot_HaxeError) ? e1.val : e1;
			return "???";
		}
		if(tostr != null && tostr != Object.toString && typeof(tostr) == "function") {
			var s2 = o.toString();
			if(s2 != "[object Object]") {
				return s2;
			}
		}
		var str1 = "{\n";
		s += "\t";
		var hasp = o.hasOwnProperty != null;
		var k = null;
		for( k in o ) {
		if(hasp && !o.hasOwnProperty(k)) {
			continue;
		}
		if(k == "prototype" || k == "__class__" || k == "__super__" || k == "__interfaces__" || k == "__properties__") {
			continue;
		}
		if(str1.length != 2) {
			str1 += ", \n";
		}
		str1 += s + k + " : " + js_Boot.__string_rec(o[k],s);
		}
		s = s.substring(1);
		str1 += "\n" + s + "}";
		return str1;
	case "string":
		return o;
	default:
		return String(o);
	}
};
js_Boot.__interfLoop = function(cc,cl) {
	if(cc == null) {
		return false;
	}
	if(cc == cl) {
		return true;
	}
	if(Object.prototype.hasOwnProperty.call(cc,"__interfaces__")) {
		var intf = cc.__interfaces__;
		var _g = 0;
		var _g1 = intf.length;
		while(_g < _g1) {
			var i = _g++;
			var i1 = intf[i];
			if(i1 == cl || js_Boot.__interfLoop(i1,cl)) {
				return true;
			}
		}
	}
	return js_Boot.__interfLoop(cc.__super__,cl);
};
js_Boot.__instanceof = function(o,cl) {
	if(cl == null) {
		return false;
	}
	switch(cl) {
	case Array:
		return ((o) instanceof Array);
	case Bool:
		return typeof(o) == "boolean";
	case Dynamic:
		return o != null;
	case Float:
		return typeof(o) == "number";
	case Int:
		if(typeof(o) == "number") {
			return ((o | 0) === o);
		} else {
			return false;
		}
		break;
	case String:
		return typeof(o) == "string";
	default:
		if(o != null) {
			if(typeof(cl) == "function") {
				if(js_Boot.__downcastCheck(o,cl)) {
					return true;
				}
			} else if(typeof(cl) == "object" && js_Boot.__isNativeObj(cl)) {
				if(((o) instanceof cl)) {
					return true;
				}
			}
		} else {
			return false;
		}
		if(cl == Class ? o.__name__ != null : false) {
			return true;
		}
		if(cl == Enum ? o.__ename__ != null : false) {
			return true;
		}
		return o.__enum__ != null ? $hxEnums[o.__enum__] == cl : false;
	}
};
js_Boot.__downcastCheck = function(o,cl) {
	if(!((o) instanceof cl)) {
		if(cl.__isInterface__) {
			return js_Boot.__interfLoop(js_Boot.getClass(o),cl);
		} else {
			return false;
		}
	} else {
		return true;
	}
};
js_Boot.__cast = function(o,t) {
	if(o == null || js_Boot.__instanceof(o,t)) {
		return o;
	} else {
		throw new js__$Boot_HaxeError("Cannot cast " + Std.string(o) + " to " + Std.string(t));
	}
};
js_Boot.__nativeClassName = function(o) {
	var name = js_Boot.__toStr.call(o).slice(8,-1);
	if(name == "Object" || name == "Function" || name == "Math" || name == "JSON") {
		return null;
	}
	return name;
};
js_Boot.__isNativeObj = function(o) {
	return js_Boot.__nativeClassName(o) != null;
};
js_Boot.__resolveNativeClass = function(name) {
	return $global[name];
};
var minject_Injector = function(parent) {
	this.infos = new haxe_ds_StringMap();
	this.mappings = new haxe_ds_StringMap();
	this.parent = parent;
};
$hxClasses["minject.Injector"] = minject_Injector;
minject_Injector.__name__ = "minject.Injector";
minject_Injector.getValueType = function(value) {
	if(typeof(value) == "string") {
		return "String";
	}
	if(js_Boot.__instanceof(value,Class)) {
		return value.__name__;
	}
	if(js_Boot.__instanceof(value,Enum)) {
		return value.__ename__;
	}
	var name;
	var _g = Type.typeof(value);
	switch(_g._hx_index) {
	case 1:
		name = "Int";
		break;
	case 3:
		name = "Bool";
		break;
	case 6:
		var c = _g.c;
		name = c.__name__;
		break;
	case 7:
		var e = _g.e;
		name = e.__ename__;
		break;
	default:
		name = null;
	}
	if(name != null) {
		return name;
	}
	throw new js__$Boot_HaxeError("Could not determine type name of " + Std.string(value));
};
minject_Injector.prototype = {
	mapRuntimeTypeOf: function(value,name) {
		return this.mapType(minject_Injector.getValueType(value),name);
	}
	,mapType: function(type,name,value) {
		var key = this.getMappingKey(type,name);
		var _this = this.mappings;
		if(__map_reserved[key] != null ? _this.existsReserved(key) : _this.h.hasOwnProperty(key)) {
			var _this1 = this.mappings;
			return __map_reserved[key] != null ? _this1.getReserved(key) : _this1.h[key];
		}
		var mapping = new minject_InjectorMapping(type,name);
		var _this2 = this.mappings;
		if(__map_reserved[key] != null) {
			_this2.setReserved(key,mapping);
		} else {
			_this2.h[key] = mapping;
		}
		return mapping;
	}
	,unmapType: function(type,name) {
		this.mappings.remove(this.getMappingKey(type,name));
	}
	,hasMappingForType: function(type,name) {
		return this.findMappingForType(type,name) != null;
	}
	,findMappingForType: function(type,name) {
		var this1 = this.mappings;
		var key = this.getMappingKey(type,name);
		var _this = this1;
		var mapping = __map_reserved[key] != null ? _this.getReserved(key) : _this.h[key];
		if(mapping != null && mapping.provider != null) {
			return mapping;
		}
		if(this.parent != null) {
			return this.parent.findMappingForType(type,name);
		}
		return null;
	}
	,getValueForType: function(type,name) {
		var mapping = this.findMappingForType(type,name);
		if(mapping != null) {
			return mapping.getValue(this);
		}
		var index = type.indexOf("<");
		if(index > -1) {
			mapping = this.findMappingForType(HxOverrides.substr(type,0,index),name);
		}
		if(mapping != null) {
			return mapping.getValue(this);
		}
		return null;
	}
	,injectInto: function(target) {
		var info = this.getInfo(js_Boot.getClass(target));
		if(info == null) {
			return;
		}
		var _g = 0;
		var _g1 = info.fields;
		while(_g < _g1.length) {
			var field = _g1[_g];
			++_g;
			field.applyInjection(target,this);
		}
	}
	,_construct: function(type) {
		var info = this.getInfo(type);
		return info.ctor.createInstance(type,this);
	}
	,_instantiate: function(type) {
		var instance = this._construct(type);
		this.injectInto(instance);
		return instance;
	}
	,getInstance: function(type,name) {
		var type1 = type.__name__;
		var mapping = this.findMappingForType(type1,name);
		if(mapping == null) {
			throw new js__$Boot_HaxeError("Error while getting mapping response: No mapping defined for class \"" + type1 + "\" " + ("name \"" + name + "\""));
		}
		return mapping.getValue(this);
	}
	,createChildInjector: function() {
		return new minject_Injector(this);
	}
	,getInfo: function(forClass) {
		var type = forClass.__name__;
		var _this = this.infos;
		if(__map_reserved[type] != null ? _this.existsReserved(type) : _this.h.hasOwnProperty(type)) {
			var _this1 = this.infos;
			if(__map_reserved[type] != null) {
				return _this1.getReserved(type);
			} else {
				return _this1.h[type];
			}
		}
		var info = this.createInfo(forClass);
		var _this2 = this.infos;
		if(__map_reserved[type] != null) {
			_this2.setReserved(type,info);
		} else {
			_this2.h[type] = info;
		}
		return info;
	}
	,createInfo: function(forClass) {
		var info = new minject_InjectorInfo(null,[]);
		this.addClassToInfo(forClass,info,[]);
		haxe_ds_ArraySort.sort(info.fields,function(p1,p2) {
			var post1 = ((p1) instanceof minject_point_PostInjectionPoint) ? p1 : null;
			var post2 = ((p2) instanceof minject_point_PostInjectionPoint) ? p2 : null;
			if(post1 == null) {
				if(post2 == null) {
					return 0;
				} else {
					return -1;
				}
			} else if(post2 == null) {
				return 1;
			} else {
				return post1.order - post2.order;
			}
		});
		if(info.ctor == null) {
			info.ctor = new minject_point_ConstructorInjectionPoint([]);
		}
		return info;
	}
	,addClassToInfo: function(forClass,info,injected) {
		var meta = haxe_rtti_Meta.getType(forClass);
		var fields = meta.rtti;
		if(fields != null) {
			var _g = 0;
			while(_g < fields.length) {
				var field = fields[_g];
				++_g;
				var name = field[0];
				if(injected.indexOf(name) > -1) {
					continue;
				}
				injected.push(name);
				if(field.length == 3) {
					info.fields.push(new minject_point_PropertyInjectionPoint(name,field[1],field[2]));
				} else if(name == "new") {
					info.ctor = new minject_point_ConstructorInjectionPoint(field.slice(2));
				} else {
					var orderStr = field[1];
					if(orderStr == "") {
						info.fields.push(new minject_point_MethodInjectionPoint(name,field.slice(2)));
					} else {
						var order = Std.parseInt(orderStr);
						info.fields.push(new minject_point_PostInjectionPoint(name,field.slice(2),order));
					}
				}
			}
		}
		var superClass = forClass.__super__;
		if(superClass != null) {
			this.addClassToInfo(superClass,info,injected);
		}
	}
	,getMappingKey: function(type,name) {
		if(name == null) {
			name = "";
		}
		return "" + type + "#" + name;
	}
	,__class__: minject_Injector
};
var minject_InjectorInfo = function(ctor,fields) {
	this.ctor = ctor;
	this.fields = fields;
};
$hxClasses["minject.InjectorInfo"] = minject_InjectorInfo;
minject_InjectorInfo.__name__ = "minject.InjectorInfo";
minject_InjectorInfo.prototype = {
	__class__: minject_InjectorInfo
};
var minject_InjectorMapping = function(type,name) {
	this.type = type;
	this.name = name;
};
$hxClasses["minject.InjectorMapping"] = minject_InjectorMapping;
minject_InjectorMapping.__name__ = "minject.InjectorMapping";
minject_InjectorMapping.prototype = {
	getValue: function(injector) {
		if(this.injector != null) {
			injector = this.injector;
		}
		if(this.provider != null) {
			return this.provider.getValue(injector);
		}
		var parent = injector.findMappingForType(this.type,this.name);
		if(parent != null) {
			return parent.getValue(injector);
		}
		return null;
	}
	,toValue: function(value) {
		return this.toProvider(new minject_provider_ValueProvider(value));
	}
	,_toClass: function(type) {
		return this.toProvider(new minject_provider_ClassProvider(type));
	}
	,_toSingleton: function(type) {
		return this.toProvider(new minject_provider_SingletonProvider(type));
	}
	,asSingleton: function() {
		var name = this.type;
		return this._toSingleton($hxClasses[name]);
	}
	,toMapping: function(mapping) {
		return this.toProvider(new minject_provider_OtherMappingProvider(mapping));
	}
	,toProvider: function(provider) {
		this.provider = provider;
		return this;
	}
	,__class__: minject_InjectorMapping
};
var minject_point_InjectionPoint = function() { };
$hxClasses["minject.point.InjectionPoint"] = minject_point_InjectionPoint;
minject_point_InjectionPoint.__name__ = "minject.point.InjectionPoint";
minject_point_InjectionPoint.__isInterface__ = true;
minject_point_InjectionPoint.prototype = {
	__class__: minject_point_InjectionPoint
};
var minject_point_MethodInjectionPoint = function(field,args) {
	this.field = field;
	this.args = args;
};
$hxClasses["minject.point.MethodInjectionPoint"] = minject_point_MethodInjectionPoint;
minject_point_MethodInjectionPoint.__name__ = "minject.point.MethodInjectionPoint";
minject_point_MethodInjectionPoint.__interfaces__ = [minject_point_InjectionPoint];
minject_point_MethodInjectionPoint.prototype = {
	applyInjection: function(target,injector) {
		Reflect.field(target,this.field).apply(target,this.gatherArgs(target,injector));
		return target;
	}
	,gatherArgs: function(target,injector) {
		var values = [];
		var index = 0;
		while(index < this.args.length) {
			var type = this.args[index++];
			var argName = this.args[index++];
			var opt = this.args[index++] == "o";
			var response = injector.getValueForType(type,argName);
			values.push(response);
		}
		return values;
	}
	,__class__: minject_point_MethodInjectionPoint
};
var minject_point_ConstructorInjectionPoint = function(args) {
	minject_point_MethodInjectionPoint.call(this,"new",args);
};
$hxClasses["minject.point.ConstructorInjectionPoint"] = minject_point_ConstructorInjectionPoint;
minject_point_ConstructorInjectionPoint.__name__ = "minject.point.ConstructorInjectionPoint";
minject_point_ConstructorInjectionPoint.__super__ = minject_point_MethodInjectionPoint;
minject_point_ConstructorInjectionPoint.prototype = $extend(minject_point_MethodInjectionPoint.prototype,{
	createInstance: function(type,injector) {
		return Type.createInstance(type,this.gatherArgs(type,injector));
	}
	,__class__: minject_point_ConstructorInjectionPoint
});
var minject_point_PostInjectionPoint = function(field,args,order) {
	minject_point_MethodInjectionPoint.call(this,field,args);
	this.order = order;
};
$hxClasses["minject.point.PostInjectionPoint"] = minject_point_PostInjectionPoint;
minject_point_PostInjectionPoint.__name__ = "minject.point.PostInjectionPoint";
minject_point_PostInjectionPoint.__super__ = minject_point_MethodInjectionPoint;
minject_point_PostInjectionPoint.prototype = $extend(minject_point_MethodInjectionPoint.prototype,{
	__class__: minject_point_PostInjectionPoint
});
var minject_point_PropertyInjectionPoint = function(field,type,name) {
	this.field = field;
	this.type = type;
	this.name = name;
};
$hxClasses["minject.point.PropertyInjectionPoint"] = minject_point_PropertyInjectionPoint;
minject_point_PropertyInjectionPoint.__name__ = "minject.point.PropertyInjectionPoint";
minject_point_PropertyInjectionPoint.__interfaces__ = [minject_point_InjectionPoint];
minject_point_PropertyInjectionPoint.prototype = {
	applyInjection: function(target,injector) {
		var response = injector.getValueForType(this.type,this.name);
		Reflect.setProperty(target,this.field,response);
		return target;
	}
	,__class__: minject_point_PropertyInjectionPoint
};
var minject_provider_DependencyProvider = function() { };
$hxClasses["minject.provider.DependencyProvider"] = minject_provider_DependencyProvider;
minject_provider_DependencyProvider.__name__ = "minject.provider.DependencyProvider";
minject_provider_DependencyProvider.__isInterface__ = true;
minject_provider_DependencyProvider.prototype = {
	__class__: minject_provider_DependencyProvider
};
var minject_provider_ClassProvider = function(type) {
	this.type = type;
};
$hxClasses["minject.provider.ClassProvider"] = minject_provider_ClassProvider;
minject_provider_ClassProvider.__name__ = "minject.provider.ClassProvider";
minject_provider_ClassProvider.__interfaces__ = [minject_provider_DependencyProvider];
minject_provider_ClassProvider.prototype = {
	getValue: function(injector) {
		return injector._instantiate(this.type);
	}
	,__class__: minject_provider_ClassProvider
};
var minject_provider_OtherMappingProvider = function(mapping) {
	this.mapping = mapping;
};
$hxClasses["minject.provider.OtherMappingProvider"] = minject_provider_OtherMappingProvider;
minject_provider_OtherMappingProvider.__name__ = "minject.provider.OtherMappingProvider";
minject_provider_OtherMappingProvider.__interfaces__ = [minject_provider_DependencyProvider];
minject_provider_OtherMappingProvider.prototype = {
	getValue: function(injector) {
		return this.mapping.getValue(injector);
	}
	,__class__: minject_provider_OtherMappingProvider
};
var minject_provider_SingletonProvider = function(type) {
	this.type = type;
};
$hxClasses["minject.provider.SingletonProvider"] = minject_provider_SingletonProvider;
minject_provider_SingletonProvider.__name__ = "minject.provider.SingletonProvider";
minject_provider_SingletonProvider.__interfaces__ = [minject_provider_DependencyProvider];
minject_provider_SingletonProvider.prototype = {
	getValue: function(injector) {
		if(this.value == null) {
			this.value = injector._construct(this.type);
			injector.injectInto(this.value);
		}
		return this.value;
	}
	,__class__: minject_provider_SingletonProvider
};
var minject_provider_ValueProvider = function(value) {
	this.value = value;
};
$hxClasses["minject.provider.ValueProvider"] = minject_provider_ValueProvider;
minject_provider_ValueProvider.__name__ = "minject.provider.ValueProvider";
minject_provider_ValueProvider.__interfaces__ = [minject_provider_DependencyProvider];
minject_provider_ValueProvider.prototype = {
	getValue: function(injector) {
		return this.value;
	}
	,__class__: minject_provider_ValueProvider
};
var octane_browser_IDocument = $hx_exports["octane"]["browser"]["IDocument"] = function() { };
$hxClasses["octane.browser.IDocument"] = octane_browser_IDocument;
octane_browser_IDocument.__name__ = "octane.browser.IDocument";
octane_browser_IDocument.__isInterface__ = true;
octane_browser_IDocument.prototype = {
	__class__: octane_browser_IDocument
};
var octane_browser_INavigator = $hx_exports["octane"]["browser"]["INavigator"] = function() { };
$hxClasses["octane.browser.INavigator"] = octane_browser_INavigator;
octane_browser_INavigator.__name__ = "octane.browser.INavigator";
octane_browser_INavigator.__isInterface__ = true;
octane_browser_INavigator.prototype = {
	__class__: octane_browser_INavigator
};
var octane_browser_IWindow = $hx_exports["octane"]["browser"]["IWindow"] = function() { };
$hxClasses["octane.browser.IWindow"] = octane_browser_IWindow;
octane_browser_IWindow.__name__ = "octane.browser.IWindow";
octane_browser_IWindow.__isInterface__ = true;
octane_browser_IWindow.prototype = {
	__class__: octane_browser_IWindow
};
var octane_core_debug_Logger = function() { };
$hxClasses["octane.core.debug.Logger"] = octane_core_debug_Logger;
octane_core_debug_Logger.__name__ = "octane.core.debug.Logger";
var octane_core_debug_Performance = function() { };
$hxClasses["octane.core.debug.Performance"] = octane_core_debug_Performance;
octane_core_debug_Performance.__name__ = "octane.core.debug.Performance";
octane_core_debug_Performance.markStart = function(name) {
	try {
		performance.mark(name + ' start');
	} catch( e ) {
		var e1 = ((e) instanceof js__$Boot_HaxeError) ? e.val : e;
		console.warn(octane_core_debug_Logger.indent.join("") + " " + "Performance API is not supported.");
		console.warn(octane_core_debug_Logger.indent.join("") + " " + e1);
	}
};
octane_core_debug_Performance.markEnd = function(name) {
	try {
		performance.mark(name + ' end');
		performance.measure(name, name + ' start', name + ' end');
	} catch( e ) {
		var e1 = ((e) instanceof js__$Boot_HaxeError) ? e.val : e;
		console.warn(octane_core_debug_Logger.indent.join("") + " " + "Performance API is not supported.");
		console.warn(octane_core_debug_Logger.indent.join("") + " " + e1);
	}
};
octane_core_debug_Performance.getAllMeasures = function() {
	try {
		return performance.getEntriesByType('measure');
	} catch( e ) {
		var e1 = ((e) instanceof js__$Boot_HaxeError) ? e.val : e;
		console.warn(octane_core_debug_Logger.indent.join("") + " " + "Performance API is not supported.");
		console.warn(octane_core_debug_Logger.indent.join("") + " " + e1);
		return [];
	}
};
octane_core_debug_Performance.whenDomContentLoaded = function() {
	return window.performance.timing.domContentLoadedEventEnd - window.performance.timing.fetchStart;
};
octane_core_debug_Performance.getTimeSincePageStartedLoading = function() {
	return performance.now();
};
octane_core_debug_Performance.getMeasureByName = function(name) {
	try {
		return window.performance.getEntriesByName(name)[0];
	} catch( e ) {
		var e1 = ((e) instanceof js__$Boot_HaxeError) ? e.val : e;
		console.warn(octane_core_debug_Logger.indent.join("") + " " + "Performance API is not supported.");
		console.warn(octane_core_debug_Logger.indent.join("") + " " + e1);
		return null;
	}
};
octane_core_debug_Performance.getAllResourceTimings = function() {
	try {
		return window.performance.getEntriesByType("resource");
	} catch( e ) {
		var e1 = ((e) instanceof js__$Boot_HaxeError) ? e.val : e;
		console.warn(octane_core_debug_Logger.indent.join("") + " " + "Performance API is not supported.");
		console.warn(octane_core_debug_Logger.indent.join("") + " " + e1);
		return [];
	}
};
var octane_core_macro_AbstractEnumTools = function() { };
$hxClasses["octane.core.macro.AbstractEnumTools"] = octane_core_macro_AbstractEnumTools;
octane_core_macro_AbstractEnumTools.__name__ = "octane.core.macro.AbstractEnumTools";
var octane_core_macro_Defines = function() { };
$hxClasses["octane.core.macro.Defines"] = octane_core_macro_Defines;
octane_core_macro_Defines.__name__ = "octane.core.macro.Defines";
var octane_core_macro_ExpressionHelper = function() { };
$hxClasses["octane.core.macro.ExpressionHelper"] = octane_core_macro_ExpressionHelper;
octane_core_macro_ExpressionHelper.__name__ = "octane.core.macro.ExpressionHelper";
var octane_core_mvc_controller_BaseCommand = function() {
};
$hxClasses["octane.core.mvc.controller.BaseCommand"] = octane_core_mvc_controller_BaseCommand;
octane_core_mvc_controller_BaseCommand.__name__ = "octane.core.mvc.controller.BaseCommand";
octane_core_mvc_controller_BaseCommand.prototype = {
	postConstruct: function() {
		if(this.injector.hasMappingForType("octane.core.mvc.view.ViewMap",null)) {
			this.viewMap = this.injector.getInstance(octane_core_mvc_view_ViewMap);
		}
	}
	,get_viewMap: function() {
		if(this.viewMap == null) {
			console.warn(octane_core_debug_Logger.indent.join("") + " " + "ViewMap is not available.");
		}
		return this.viewMap;
	}
	,__class__: octane_core_mvc_controller_BaseCommand
	,__properties__: {get_viewMap:"get_viewMap"}
};
var octane_core_mvc_controller_ChainableCommand = function() {
	octane_core_mvc_controller_BaseCommand.call(this);
};
$hxClasses["octane.core.mvc.controller.ChainableCommand"] = octane_core_mvc_controller_ChainableCommand;
octane_core_mvc_controller_ChainableCommand.__name__ = "octane.core.mvc.controller.ChainableCommand";
octane_core_mvc_controller_ChainableCommand.__super__ = octane_core_mvc_controller_BaseCommand;
octane_core_mvc_controller_ChainableCommand.prototype = $extend(octane_core_mvc_controller_BaseCommand.prototype,{
	execute: function() {
		return null;
	}
	,__class__: octane_core_mvc_controller_ChainableCommand
});
var octane_core_mvc_controller_Command = function() {
	octane_core_mvc_controller_BaseCommand.call(this);
};
$hxClasses["octane.core.mvc.controller.Command"] = octane_core_mvc_controller_Command;
octane_core_mvc_controller_Command.__name__ = "octane.core.mvc.controller.Command";
octane_core_mvc_controller_Command.__super__ = octane_core_mvc_controller_BaseCommand;
octane_core_mvc_controller_Command.prototype = $extend(octane_core_mvc_controller_BaseCommand.prototype,{
	execute: function() {
	}
	,__class__: octane_core_mvc_controller_Command
});
var octane_core_mvc_controller_CommandMap = function(injector) {
	this.injector = injector;
	this.mappings = new haxe_ds_StringMap();
};
$hxClasses["octane.core.mvc.controller.CommandMap"] = octane_core_mvc_controller_CommandMap;
octane_core_mvc_controller_CommandMap.__name__ = "octane.core.mvc.controller.CommandMap";
octane_core_mvc_controller_CommandMap.prototype = {
	createCommandInstance: function(commandClass,injectorToUse) {
		var command = Type.createInstance(commandClass,[]);
		command.injector = injectorToUse;
		injectorToUse.injectInto(command);
		return command;
	}
	,executeWithInjector: function(commandClass,injectorToUse) {
		var command = this.createCommandInstance(commandClass,injectorToUse);
		command.execute();
	}
	,execute: function(commandClass) {
		this.executeWithInjector(commandClass,this.injector);
	}
	,executeChainable: function(commandClass) {
		return this.executeChainableWithInjector(commandClass,this.injector);
	}
	,executeChainableWithInjector: function(commandClass,injectorToUse) {
		var command = this.createCommandInstance(commandClass,injectorToUse);
		var promise = command.execute();
		return promise;
	}
	,executeChainableWithArgs: function(commandClass,args) {
		if(args.length > 0) {
			return this.executeChainableWithInjector(commandClass,this.getInjectorForArgs(args));
		} else {
			return this.executeChainable(commandClass);
		}
	}
	,map: function(signal,commandClass,once) {
		if(once == null) {
			once = false;
		}
		this.mapSignal(signal,commandClass,once);
	}
	,mapSignal: function(signal,commandClass,once) {
		var _gthis = this;
		var key = "" + commandClass.__name__ + "_" + signal.id + "_" + (once == null ? "null" : "" + once);
		var _this = this.mappings;
		if(__map_reserved[key] != null ? _this.existsReserved(key) : _this.h.hasOwnProperty(key)) {
			return;
		}
		var baseSignal = signal;
		var slot = baseSignal.dynamicAdd(function(args) {
			if(once) {
				_gthis.mappings.remove(key);
			}
			_gthis.executeWithArgs(commandClass,args);
		},once);
		var _this1 = this.mappings;
		if(__map_reserved[key] != null) {
			_this1.setReserved(key,slot);
		} else {
			_this1.h[key] = slot;
		}
	}
	,debugSignalMapping: function(key,commandClass,once) {
		var regex = new EReg("([^.]*)$","im");
		regex.match(commandClass.__name__);
		var onceSuffix = once ? "once" : "";
		var _this = this.mappings;
		if(__map_reserved[key] != null ? _this.existsReserved(key) : _this.h.hasOwnProperty(key)) {
			console.warn(octane_core_debug_Logger.indent.join("") + " " + "Attempted to map " + regex.matched(1) + " multiple times, ignoring.");
		} else {
			console.debug(octane_core_debug_Logger.indent.join("") + " " + "Mapped" + " " + regex.matched(1) + " " + onceSuffix);
		}
	}
	,executeWithArgs: function(commandClass,args) {
		if(args.length > 0) {
			this.executeWithInjector(commandClass,this.getInjectorForArgs(args));
		} else {
			this.execute(commandClass);
		}
	}
	,getInjectorForArgs: function(args) {
		var tmpInjector = this.injector.createChildInjector();
		var _g = 0;
		while(_g < args.length) {
			var arg = args[_g];
			++_g;
			var _g1 = Type.typeof(arg);
			switch(_g1._hx_index) {
			case 0:case 8:
				throw new js__$Boot_HaxeError("Can't determine the type of an arguement to be injected.");
			case 1:case 2:
				tmpInjector.mapType("Int",null,null).toValue(arg);
				tmpInjector.mapType("Float",null,null).toValue(arg);
				break;
			case 3:
				tmpInjector.mapType("Bool",null,null).toValue(arg);
				break;
			case 4:
				tmpInjector.mapType("octane.core.mvc.controller.DynamicWrapper",null,null).toValue(new octane_core_mvc_controller_DynamicWrapper(arg));
				break;
			case 5:
				throw new js__$Boot_HaxeError("Injection of functions into commands has not been implemented yet.");
			case 6:
				var cls = _g1.c;
				tmpInjector.mapType(cls.__name__).toValue(arg);
				break;
			case 7:
				var enm = _g1.e;
				tmpInjector.mapType(enm.__ename__).toValue(arg);
				break;
			}
		}
		return tmpInjector;
	}
	,mapOnce: function(signal,commandClass) {
		this.mapSignal(signal,commandClass,true);
	}
	,unmap: function(signal,commandClass,once) {
		if(once == null) {
			once = false;
		}
		var key = "" + commandClass.__name__ + "_" + signal.id + "_" + (once == null ? "null" : "" + once);
		var _this = this.mappings;
		var slot = __map_reserved[key] != null ? _this.getReserved(key) : _this.h[key];
		if(slot != null) {
			slot.dispose();
		}
	}
	,getMappingKey: function(signal,commandClass,once) {
		return "" + commandClass.__name__ + "_" + signal.id + "_" + (once == null ? "null" : "" + once);
	}
	,__class__: octane_core_mvc_controller_CommandMap
};
var octane_core_mvc_controller_DynamicWrapper = function(dynamicInst) {
	this.value = dynamicInst;
};
$hxClasses["octane.core.mvc.controller.DynamicWrapper"] = octane_core_mvc_controller_DynamicWrapper;
octane_core_mvc_controller_DynamicWrapper.__name__ = "octane.core.mvc.controller.DynamicWrapper";
octane_core_mvc_controller_DynamicWrapper.prototype = {
	__class__: octane_core_mvc_controller_DynamicWrapper
};
var octane_core_mvc_module_IModule = function() { };
$hxClasses["octane.core.mvc.module.IModule"] = octane_core_mvc_module_IModule;
octane_core_mvc_module_IModule.__name__ = "octane.core.mvc.module.IModule";
octane_core_mvc_module_IModule.__isInterface__ = true;
octane_core_mvc_module_IModule.prototype = {
	__class__: octane_core_mvc_module_IModule
};
var octane_core_mvc_module_Module = function(parentInjector) {
	this.onStartupComplete = this._onStartupComplete = new hx_event_Signal0();
	this.onStartupBegun = this._onStartupBegun = new hx_event_Signal0();
	this.onInitComplete = this._onInitComplete = new hx_event_Signal0();
	this.onInitBegun = this._onInitBegun = new hx_event_Signal0();
	if(parentInjector != null) {
		this.injector = parentInjector.createChildInjector();
	} else {
		this.injector = new minject_Injector();
	}
	this.commandMap = new octane_core_mvc_controller_CommandMap(this.injector);
	this.setupDefaultInjections();
};
$hxClasses["octane.core.mvc.module.Module"] = octane_core_mvc_module_Module;
octane_core_mvc_module_Module.__name__ = "octane.core.mvc.module.Module";
octane_core_mvc_module_Module.__interfaces__ = [octane_core_mvc_module_IModule];
octane_core_mvc_module_Module.prototype = {
	setupDefaultInjections: function() {
		this.injector.mapType("octane.core.mvc.controller.CommandMap",null,null).toValue(this.commandMap);
		this.injector.mapType("octane.core.mvc.module.Module",null,null).toValue(this);
		this.injector.mapType("minject.Injector",null,null).toValue(this.injector);
	}
	,init: function() {
		console.debug(octane_core_debug_Logger.indent.join("") + " " + "Initializing " + (function($this) {
			var $r;
			var c = js_Boot.getClass($this);
			$r = c.__name__;
			return $r;
		}(this)));
		octane_core_debug_Logger.indent.unshift(octane_core_debug_Logger.indent.length == 0 ? " ⤷" : "  ");
		this._onInitBegun.dispatch();
		this.onInit();
		octane_core_debug_Logger.indent.shift();
		this._onInitComplete.dispatch();
	}
	,startup: function() {
		console.debug(octane_core_debug_Logger.indent.join("") + " " + "Starting up " + (function($this) {
			var $r;
			var c = js_Boot.getClass($this);
			$r = c.__name__;
			return $r;
		}(this)));
		octane_core_debug_Logger.indent.unshift(octane_core_debug_Logger.indent.length == 0 ? " ⤷" : "  ");
		this._onStartupBegun.dispatch();
		this.onStartup();
		octane_core_debug_Logger.indent.shift();
		this._onStartupComplete.dispatch();
	}
	,onStartup: function() {
	}
	,onInit: function() {
	}
	,__class__: octane_core_mvc_module_Module
};
var octane_core_mvc_view_IDisposable = function() { };
$hxClasses["octane.core.mvc.view.IDisposable"] = octane_core_mvc_view_IDisposable;
octane_core_mvc_view_IDisposable.__name__ = "octane.core.mvc.view.IDisposable";
octane_core_mvc_view_IDisposable.__isInterface__ = true;
octane_core_mvc_view_IDisposable.prototype = {
	__class__: octane_core_mvc_view_IDisposable
};
var octane_core_mvc_view_IViewWithReadySignal = function() { };
$hxClasses["octane.core.mvc.view.IViewWithReadySignal"] = octane_core_mvc_view_IViewWithReadySignal;
octane_core_mvc_view_IViewWithReadySignal.__name__ = "octane.core.mvc.view.IViewWithReadySignal";
octane_core_mvc_view_IViewWithReadySignal.__isInterface__ = true;
octane_core_mvc_view_IViewWithReadySignal.prototype = {
	__class__: octane_core_mvc_view_IViewWithReadySignal
};
var octane_core_mvc_view_Mediator = function() {
	this.toDispose = [];
};
$hxClasses["octane.core.mvc.view.Mediator"] = octane_core_mvc_view_Mediator;
octane_core_mvc_view_Mediator.__name__ = "octane.core.mvc.view.Mediator";
octane_core_mvc_view_Mediator.prototype = {
	onStartup: function() {
	}
	,postConstruct: function() {
		if(this.injector.hasMappingForType(octane_core_mvc_view_IDisposable.__name__)) {
			this.onRemoveSlot = this.injector.getInstance(octane_core_mvc_view_IDisposable).onDisposed.add($bind(this,this.__onRemove));
		}
	}
	,subscribeTo: function(signal,func,once) {
		if(once == null) {
			once = false;
		}
		var dynSig = signal;
		this.toDispose.push(dynSig.add(func,once));
	}
	,__onRemove: function() {
		this.onRemove();
		var _g = 0;
		var _g1 = this.toDispose;
		while(_g < _g1.length) {
			var slot = _g1[_g];
			++_g;
			slot.dispose();
		}
		this.onRemoveSlot.dispose();
	}
	,onRemove: function() {
	}
	,__class__: octane_core_mvc_view_Mediator
};
var octane_core_mvc_view_MediatorMappingProvider = function(mediatorClass,viewClass,asView) {
	this.viewClass = viewClass;
	this.mediatorClass = mediatorClass;
	this.asView = asView;
};
$hxClasses["octane.core.mvc.view.MediatorMappingProvider"] = octane_core_mvc_view_MediatorMappingProvider;
octane_core_mvc_view_MediatorMappingProvider.__name__ = "octane.core.mvc.view.MediatorMappingProvider";
octane_core_mvc_view_MediatorMappingProvider.__interfaces__ = [minject_provider_DependencyProvider];
octane_core_mvc_view_MediatorMappingProvider.prototype = {
	getValue: function(injector) {
		var args = [];
		if(injector.hasMappingForType(octane_core_mvc_controller_DynamicWrapper.__name__)) {
			args = [injector.getInstance(octane_core_mvc_controller_DynamicWrapper).value];
		}
		var viewInstance = Type.createInstance(this.viewClass,args);
		var viewIdentifier = this.getViewIdentifierFromArguments(args);
		injector.injectInto(viewInstance);
		var mediatorInjector = injector.createChildInjector();
		mediatorInjector.mapRuntimeTypeOf(this.asView).toValue(viewInstance);
		mediatorInjector.mapRuntimeTypeOf(octane_core_mvc_view_IDisposable).toValue(viewInstance);
		mediatorInjector.mapRuntimeTypeOf(minject_Injector).toValue(mediatorInjector);
		mediatorInjector.mapRuntimeTypeOf(this.mediatorClass).asSingleton();
		var mediator = mediatorInjector.getInstance(this.mediatorClass);
		mediator.viewIdentifier = viewIdentifier;
		var view = mediatorInjector.getInstance(this.asView);
		this.addMediatorCallbackWhenViewIsReady(view,mediator);
		return view;
	}
	,getViewIdentifierFromArguments: function(args) {
		var viewIdentifier = null;
		if(!octane_core_types_array_ArrayExtensions.isNullOrEmpty(args)) {
			if(Object.prototype.hasOwnProperty.call(args[0],"viewIdentifier")) {
				viewIdentifier = args[0].viewIdentifier;
			}
		}
		return viewIdentifier;
	}
	,addMediatorCallbackWhenViewIsReady: function(view,mediator) {
		if(view.onReady == null) {
			mediator.onStartup();
		} else {
			view.onReady.add($bind(mediator,mediator.onStartup));
		}
	}
	,toString: function() {
		return "";
	}
	,__class__: octane_core_mvc_view_MediatorMappingProvider
};
var octane_core_mvc_view_ViewMap = function(injector) {
	this.injector = injector;
};
$hxClasses["octane.core.mvc.view.ViewMap"] = octane_core_mvc_view_ViewMap;
octane_core_mvc_view_ViewMap.__name__ = "octane.core.mvc.view.ViewMap";
octane_core_mvc_view_ViewMap.prototype = {
	__mapView: function(mediator,view,asView,name) {
		var mappingName = name;
		if(this.injector.hasMappingForType(asView.__name__,mappingName) && mappingName == null) {
			mappingName = view.__name__;
			console.warn(octane_core_debug_Logger.indent.join("") + " " + "Duplicate unnamed mapping of " + asView.__name__ + ", using " + mappingName + " mapping name.\n            You will need to inject with the name " + mappingName + " when injecting an instance of " + asView.__name__ + " outside of a mediator.\n            Provide names for these mappings to remove this warning.");
		}
		if(this.injector.hasMappingForType(view.__name__)) {
			throw new js__$Boot_HaxeError("Duplicate mapping of view class " + view.__name__ + ".");
		}
		var mapping = this.injector.mapRuntimeTypeOf(asView,mappingName).toProvider(new octane_core_mvc_view_MediatorMappingProvider(mediator,view,asView));
		this.injector.mapRuntimeTypeOf(view).toMapping(mapping);
	}
	,__class__: octane_core_mvc_view_ViewMap
};
var octane_core_state_State = function(name) {
	this.name = name;
	this.onExited = new hx_event_Signal0();
	this.onEntered = new hx_event_Signal0();
	this.entryGuards = [];
	this.exitGuards = [];
	this.actionMap = new haxe_ds_EnumValueMap();
};
$hxClasses["octane.core.state.State"] = octane_core_state_State;
octane_core_state_State.__name__ = "octane.core.state.State";
octane_core_state_State.prototype = {
	addEntryGuard: function(func) {
		this.entryGuards.push(func);
		return this;
	}
	,addExitGuard: function(func) {
		this.exitGuards.push(func);
		return this;
	}
	,mapActionToState: function(action,stateName) {
		if(!this.actionMap.exists(action)) {
			this.actionMap.set(action,stateName);
		}
		return this;
	}
	,automaticallyTransitionsToState: function(action,stateName) {
		if(!this.actionMap.exists(action)) {
			this.autoTransitionAction = action;
			this.actionMap.set(action,stateName);
		}
		return this;
	}
	,stateNameForAction: function(action) {
		return this.actionMap.get(action);
	}
	,canDoAction: function(action) {
		return this.actionMap.exists(action);
	}
	,canExit: function() {
		return this.checkGuards(this.exitGuards);
	}
	,canEnter: function() {
		return this.checkGuards(this.entryGuards);
	}
	,checkGuards: function(guards) {
		var _g = 0;
		while(_g < guards.length) {
			var guard = guards[_g];
			++_g;
			if(guard()) {
				continue;
			} else {
				return false;
			}
		}
		return true;
	}
	,is: function(state) {
		return this.name == state;
	}
	,get_hasAutoTransitionAction: function() {
		return this.autoTransitionAction != null;
	}
	,getAutoTransitionAction: function() {
		return this.autoTransitionAction;
	}
	,__class__: octane_core_state_State
	,__properties__: {get_hasAutoTransitionAction:"get_hasAutoTransitionAction"}
};
var octane_core_state_StateMachine = function() {
	this.logPerformance = false;
	this.states = new haxe_ds_EnumValueMap();
	this.pendingRequests = [];
};
$hxClasses["octane.core.state.StateMachine"] = octane_core_state_StateMachine;
octane_core_state_StateMachine.__name__ = "octane.core.state.StateMachine";
octane_core_state_StateMachine.prototype = {
	createState: function(stateName) {
		var state = this.states.get(stateName);
		if(state == null) {
			state = new octane_core_state_State(stateName);
			this.states.set(stateName,state);
		}
		if(this.currentState == null) {
			if(this.logPerformance) {
				octane_core_debug_Performance.markStart(this.getPerformanceLogName(stateName));
			}
			this.currentState = state;
		}
		return state;
	}
	,getPerformanceLogName: function(stateName) {
		var c = js_Boot.getClass(this);
		var longName = "" + c.__name__;
		var shortName = longName.substring(longName.lastIndexOf(".") + 1);
		return "" + shortName + "." + Std.string(stateName);
	}
	,hasState: function(stateName) {
		return this.states.exists(stateName);
	}
	,getState: function(stateName) {
		return this.states.get(stateName);
	}
	,doAction: function(action,pos) {
		var actionInfo = { action : action, pos : pos};
		if(this.busySwitching || this.pendingRequests.length > 0) {
			this.pendingRequests.push(actionInfo);
			return false;
		}
		return this.attemptTransitionTo(actionInfo);
	}
	,attemptTransitionTo: function(actionInfo) {
		if(!this.currentState.canDoAction(actionInfo.action)) {
			return false;
		}
		var nextStateName = this.currentState.stateNameForAction(actionInfo.action);
		var nextState = this.states.get(nextStateName);
		if(this.currentState.canExit() && nextState.canEnter()) {
			this.busySwitching = true;
			var result = this.transitionToNextState(actionInfo,nextStateName,nextState);
			this.busySwitching = false;
			this.processPendingRequests();
			return result;
		}
		return false;
	}
	,transitionToNextState: function(actionInfo,nextStateName,nextState) {
		if(this.logPerformance) {
			octane_core_debug_Performance.markEnd(this.getPerformanceLogName(this.currentState.name));
			octane_core_debug_Performance.markStart(this.getPerformanceLogName(nextStateName));
		}
		this.currentState.onExited.dispatch();
		this.currentState = nextState;
		this.currentState.onEntered.dispatch();
		var result = true;
		if(this.currentState.get_hasAutoTransitionAction()) {
			result = this.attemptTransitionTo({ action : this.currentState.getAutoTransitionAction(), pos : null});
		}
		return result;
	}
	,processPendingRequests: function() {
		if(this.pendingRequests.length > 0) {
			if(this.busySwitching) {
				var _gthis = this;
				haxe_Timer.delay(function() {
					_gthis.processPendingRequests();
				},10);
			} else {
				this.attemptTransitionTo(this.pendingRequests.shift());
			}
		}
	}
	,deferProcessPendingRequests: function() {
		var _gthis = this;
		haxe_Timer.delay(function() {
			_gthis.processPendingRequests();
		},10);
	}
	,__class__: octane_core_state_StateMachine
};
var octane_core_timer_Timer = function(name,timerFactoryFunction) {
	this.timerFactoryFunction = timerFactoryFunction == null ? haxe_Timer.delay : timerFactoryFunction;
	this.name = name;
	this.isRunning = false;
	this.repeatsRemaining = 0;
	this.onComplete = this._onComplete = new hx_event_Signal0();
};
$hxClasses["octane.core.timer.Timer"] = octane_core_timer_Timer;
octane_core_timer_Timer.__name__ = "octane.core.timer.Timer";
octane_core_timer_Timer.prototype = {
	start: function(delayMS,repeat) {
		if(repeat == null) {
			repeat = 1;
		}
		if(delayMS < 0) {
			throw new js__$Boot_HaxeError("Invalid timer duration supplied.");
		}
		if(this.isRunning) {
			return this;
		}
		this.isRunning = true;
		this.isPaused = false;
		this.startTime = new Date().getTime();
		this.currentDelayMS = delayMS;
		this.shouldRepeatIndefinitely = repeat == 0;
		this.repeatsRemaining = repeat;
		if(this.activeTimer != null) {
			this.activeTimer.stop();
			this.activeTimer.run = null;
		}
		this.activeTimer = this.timerFactoryFunction($bind(this,this.timerComplete),delayMS);
		return this;
	}
	,timerComplete: function() {
		this.activeTimer.stop();
		this.isRunning = this.shouldRepeatIndefinitely || --this.repeatsRemaining > 0;
		this._onComplete.dispatch();
		if(this.isRunning) {
			this.isRunning = false;
			this.start(this.currentDelayMS,this.repeatsRemaining);
		}
	}
	,pause: function() {
		if(!this.isRunning) {
			return;
		}
		this.activeTimer.stop();
		var now = new Date().getTime();
		var timeElapsed = now - this.startTime;
		this.pausedTimeRemaining = this.currentDelayMS - timeElapsed;
		this.startTime = now;
		this.isRunning = false;
		this.isPaused = true;
	}
	,stop: function(disposeOnComplete) {
		if(disposeOnComplete == null) {
			disposeOnComplete = false;
		}
		if(this.activeTimer == null) {
			return;
		}
		if(disposeOnComplete) {
			this._onComplete.dispose(true);
		}
		this.activeTimer.stop();
		this.isRunning = false;
		this.isPaused = false;
	}
	,resume: function() {
		if(!this.isPaused) {
			return;
		}
		this.activeTimer = this.timerFactoryFunction($bind(this,this.timerComplete),this.pausedTimeRemaining);
	}
	,reset: function() {
		this.activeTimer.stop();
		this.isRunning = false;
		this.start(this.currentDelayMS,this.repeatsRemaining);
	}
	,__class__: octane_core_timer_Timer
};
var octane_core_types_array_ArrayExtensions = function() { };
$hxClasses["octane.core.types.array.ArrayExtensions"] = octane_core_types_array_ArrayExtensions;
octane_core_types_array_ArrayExtensions.__name__ = "octane.core.types.array.ArrayExtensions";
octane_core_types_array_ArrayExtensions.isNullOrEmpty = function(array) {
	if(array != null) {
		return array.length == 0;
	} else {
		return true;
	}
};
octane_core_types_array_ArrayExtensions.max = function(array) {
	if(octane_core_types_array_ArrayExtensions.isNullOrEmpty(array)) {
		return null;
	}
	var max = array[0];
	var _g = 0;
	while(_g < array.length) {
		var value = array[_g];
		++_g;
		if(value > max) {
			max = value;
		}
	}
	return max;
};
octane_core_types_array_ArrayExtensions.min = function(array) {
	if(octane_core_types_array_ArrayExtensions.isNullOrEmpty(array)) {
		return null;
	}
	var min = array[0];
	var _g = 0;
	while(_g < array.length) {
		var value = array[_g];
		++_g;
		if(value < min) {
			min = value;
		}
	}
	return min;
};
octane_core_types_array_ArrayExtensions.first = function(array) {
	if(octane_core_types_array_ArrayExtensions.isNullOrEmpty(array)) {
		return null;
	}
	return array[0];
};
octane_core_types_array_ArrayExtensions.last = function(array) {
	if(octane_core_types_array_ArrayExtensions.isNullOrEmpty(array)) {
		return null;
	}
	return array[array.length - 1];
};
octane_core_types_array_ArrayExtensions.sortAscending = function(array) {
	if(octane_core_types_array_ArrayExtensions.isNullOrEmpty(array)) {
		return;
	}
	var value = octane_core_types_array_ArrayExtensions.first(array);
	if(octane_core_types_array_ArrayExtensions.isGenericInteger(value)) {
		var integerArray = array;
		integerArray.sort(function(first,second) {
			return first - second;
		});
		return;
	}
	if(octane_core_types_array_ArrayExtensions.isGenericString(value)) {
		var stringArray = array;
		stringArray.sort(function(first1,second1) {
			return first1.length - second1.length;
		});
		return;
	}
	if(!octane_core_types_array_ArrayExtensions.isGenericInteger(value) && !octane_core_types_array_ArrayExtensions.isGenericString(value)) {
		throw new js__$Boot_HaxeError("Arrays of this type are not yet supported");
	}
};
octane_core_types_array_ArrayExtensions.sortDescending = function(array) {
	if(octane_core_types_array_ArrayExtensions.isNullOrEmpty(array)) {
		return;
	}
	var value = octane_core_types_array_ArrayExtensions.first(array);
	if(octane_core_types_array_ArrayExtensions.isGenericInteger(value)) {
		var integerArray = array;
		integerArray.sort(function(first,second) {
			return second - first;
		});
		return;
	}
	if(octane_core_types_array_ArrayExtensions.isGenericString(value)) {
		var stringArray = array;
		stringArray.sort(function(first1,second1) {
			return second1.length - first1.length;
		});
		return;
	}
	if(!octane_core_types_array_ArrayExtensions.isGenericInteger(value) && !octane_core_types_array_ArrayExtensions.isGenericString(value)) {
		throw new js__$Boot_HaxeError("Arrays of this type are not yet supported");
	}
};
octane_core_types_array_ArrayExtensions.isGenericInteger = function(value) {
	return Type.typeof(value) == ValueType.TInt;
};
octane_core_types_array_ArrayExtensions.isGenericString = function(value) {
	var _g = Type.typeof(value);
	if(_g._hx_index == 6) {
		if(_g.c == String) {
			return true;
		} else {
			return false;
		}
	} else {
		return false;
	}
};
octane_core_types_array_ArrayExtensions.removeNullItems = function(array) {
	return array.filter(function(item) {
		return item != null;
	});
};
octane_core_types_array_ArrayExtensions.removeNullOrEmptyItems = function(array) {
	return array.filter(function(item) {
		if(item != null) {
			return item.length > 0;
		} else {
			return false;
		}
	});
};
octane_core_types_array_ArrayExtensions.removeDuplicateItems = function(array) {
	var newArray = [];
	array.map(function(str) {
		if(!octane_core_types_array_ArrayExtensions.has(newArray,str)) {
			return newArray.push(str);
		} else {
			return null;
		}
	});
	return newArray;
};
octane_core_types_array_ArrayExtensions.has = function(array,toFind) {
	return array.indexOf(toFind) > -1;
};
var octane_core_types_geom__$Point_Point_$Impl_$ = {};
$hxClasses["octane.core.types.geom._Point.Point_Impl_"] = octane_core_types_geom__$Point_Point_$Impl_$;
octane_core_types_geom__$Point_Point_$Impl_$.__name__ = "octane.core.types.geom._Point.Point_Impl_";
octane_core_types_geom__$Point_Point_$Impl_$._new = function(x,y) {
	var this1 = { };
	this1.x = x;
	this1.y = y;
	return this1;
};
octane_core_types_geom__$Point_Point_$Impl_$.fromDynamic = function(m) {
	var x = 0.0;
	var y = 0.0;
	var hasX = Object.prototype.hasOwnProperty.call(m,"x");
	var hasY = Object.prototype.hasOwnProperty.call(m,"y");
	if(hasX) {
		x = Reflect.field(m,"x");
	}
	if(hasY) {
		y = Reflect.field(m,"y");
	}
	return octane_core_types_geom__$Point_Point_$Impl_$._new(x,y);
};
octane_core_types_geom__$Point_Point_$Impl_$.toString = function(point) {
	return "" + Std.string(point.x) + " x " + Std.string(point.y);
};
octane_core_types_geom__$Point_Point_$Impl_$.equals = function(this1,comparePoint) {
	if(comparePoint == this1) {
		return true;
	}
	if(comparePoint == null || this1 == null) {
		return false;
	}
	if(this1.x == comparePoint.x) {
		return this1.y == comparePoint.y;
	} else {
		return false;
	}
};
var octane_core_types_json__$JSONMap_JSONMap_$Impl_$ = {};
$hxClasses["octane.core.types.json._JSONMap.JSONMap_Impl_"] = octane_core_types_json__$JSONMap_JSONMap_$Impl_$;
octane_core_types_json__$JSONMap_JSONMap_$Impl_$.__name__ = "octane.core.types.json._JSONMap.JSONMap_Impl_";
octane_core_types_json__$JSONMap_JSONMap_$Impl_$._new = function() {
	var this1 = { };
	return this1;
};
octane_core_types_json__$JSONMap_JSONMap_$Impl_$.set = function(this1,key,value) {
	this1[key] = value;
};
octane_core_types_json__$JSONMap_JSONMap_$Impl_$.get = function(this1,key) {
	return this1[key];
};
octane_core_types_json__$JSONMap_JSONMap_$Impl_$.fromDynamic = function(m) {
	var data = octane_core_types_json__$JSONMap_JSONMap_$Impl_$._new();
	var _g = 0;
	var _g1 = Reflect.fields(m);
	while(_g < _g1.length) {
		var key = _g1[_g];
		++_g;
		data[key] = Reflect.field(m,key);
	}
	return data;
};
octane_core_types_json__$JSONMap_JSONMap_$Impl_$.keys = function(this1) {
	return Reflect.fields(this1);
};
octane_core_types_json__$JSONMap_JSONMap_$Impl_$.iterator = function(this1) {
	return new octane_core_types_json_JSONMapIterator(Reflect.fields(this1),this1);
};
var octane_core_types_json_JSONMapIterator = function(keys,reference) {
	this.jsonMapReference = reference;
	this.jsonMapKeys = keys;
	this.currentIndex = 0;
};
$hxClasses["octane.core.types.json.JSONMapIterator"] = octane_core_types_json_JSONMapIterator;
octane_core_types_json_JSONMapIterator.__name__ = "octane.core.types.json.JSONMapIterator";
octane_core_types_json_JSONMapIterator.prototype = {
	hasNext: function() {
		return this.currentIndex < this.jsonMapKeys.length;
	}
	,next: function() {
		return this.jsonMapReference[this.jsonMapKeys[this.currentIndex++]];
	}
	,__class__: octane_core_types_json_JSONMapIterator
};
var octane_core_types_string_StringExtensions = function() { };
$hxClasses["octane.core.types.string.StringExtensions"] = octane_core_types_string_StringExtensions;
octane_core_types_string_StringExtensions.__name__ = "octane.core.types.string.StringExtensions";
octane_core_types_string_StringExtensions.isNullOrEmpty = function(string) {
	if(string != null) {
		return string.length == 0;
	} else {
		return true;
	}
};
octane_core_types_string_StringExtensions.isNotNullOrEmpty = function(string) {
	return !octane_core_types_string_StringExtensions.isNullOrEmpty(string);
};
octane_core_types_string_StringExtensions.contains = function(string,substring) {
	if(octane_core_types_string_StringExtensions.isNullOrEmpty(string)) {
		return false;
	}
	return string.indexOf(substring) != -1;
};
var octane_preloader_controller_OnHostInitializedCommand = function() {
	octane_core_mvc_controller_Command.call(this);
};
$hxClasses["octane.preloader.controller.OnHostInitializedCommand"] = octane_preloader_controller_OnHostInitializedCommand;
octane_preloader_controller_OnHostInitializedCommand.__name__ = "octane.preloader.controller.OnHostInitializedCommand";
octane_preloader_controller_OnHostInitializedCommand.__super__ = octane_core_mvc_controller_Command;
octane_preloader_controller_OnHostInitializedCommand.prototype = $extend(octane_core_mvc_controller_Command.prototype,{
	execute: function() {
		this.fileLoader.priorityQueueAssets(this.manifest.scripts);
		this.fileLoader.setMaximumParallelLoads(10);
	}
	,__class__: octane_preloader_controller_OnHostInitializedCommand
});
var octane_preloader_model_IAssetLoadingModel = $hx_exports["octane"]["preloader"]["model"]["IAssetLoadingModel"] = function() { };
$hxClasses["octane.preloader.model.IAssetLoadingModel"] = octane_preloader_model_IAssetLoadingModel;
octane_preloader_model_IAssetLoadingModel.__name__ = "octane.preloader.model.IAssetLoadingModel";
octane_preloader_model_IAssetLoadingModel.__isInterface__ = true;
octane_preloader_model_IAssetLoadingModel.prototype = {
	__class__: octane_preloader_model_IAssetLoadingModel
};
var octane_preloader_model_ILanguageCodeModel = $hx_exports["octane"]["preloader"]["model"]["ILanguageCodeModel"] = function() { };
$hxClasses["octane.preloader.model.ILanguageCodeModel"] = octane_preloader_model_ILanguageCodeModel;
octane_preloader_model_ILanguageCodeModel.__name__ = "octane.preloader.model.ILanguageCodeModel";
octane_preloader_model_ILanguageCodeModel.__isInterface__ = true;
octane_preloader_model_ILanguageCodeModel.prototype = {
	__class__: octane_preloader_model_ILanguageCodeModel
};
var octane_preloader_model_IMultipartBundleModel = $hx_exports["octane"]["preloader"]["model"]["IMultipartBundleModel"] = function() { };
$hxClasses["octane.preloader.model.IMultipartBundleModel"] = octane_preloader_model_IMultipartBundleModel;
octane_preloader_model_IMultipartBundleModel.__name__ = "octane.preloader.model.IMultipartBundleModel";
octane_preloader_model_IMultipartBundleModel.__isInterface__ = true;
octane_preloader_model_IMultipartBundleModel.prototype = {
	__class__: octane_preloader_model_IMultipartBundleModel
};
var octane_preloader_model_IPreloadedFilesModel = $hx_exports["octane"]["preloader"]["model"]["IPreloadedFilesModel"] = function() { };
$hxClasses["octane.preloader.model.IPreloadedFilesModel"] = octane_preloader_model_IPreloadedFilesModel;
octane_preloader_model_IPreloadedFilesModel.__name__ = "octane.preloader.model.IPreloadedFilesModel";
octane_preloader_model_IPreloadedFilesModel.__isInterface__ = true;
octane_preloader_model_IPreloadedFilesModel.prototype = {
	__class__: octane_preloader_model_IPreloadedFilesModel
};
var octane_preloader_model_MultipartBundleModel = function() {
	this.onAllBundlePartsLoaded = this._onAllBundlePartsLoaded = new hx_event_Signal2();
	this.bundlePartsRemaining = new haxe_ds_StringMap();
	this.bundleParts = new haxe_ds_StringMap();
	this.totalParts = new haxe_ds_StringMap();
};
$hxClasses["octane.preloader.model.MultipartBundleModel"] = octane_preloader_model_MultipartBundleModel;
octane_preloader_model_MultipartBundleModel.__name__ = "octane.preloader.model.MultipartBundleModel";
octane_preloader_model_MultipartBundleModel.__interfaces__ = [octane_preloader_model_IMultipartBundleModel];
octane_preloader_model_MultipartBundleModel.prototype = {
	registerBundle: function(name,parts) {
		if(name == null) {
			return;
		}
		var _this = this.bundleParts;
		if(__map_reserved[name] != null ? _this.existsReserved(name) : _this.h.hasOwnProperty(name)) {
			return;
		}
		var _this1 = this.bundlePartsRemaining;
		if(__map_reserved[name] != null) {
			_this1.setReserved(name,parts);
		} else {
			_this1.h[name] = parts;
		}
		var _this2 = this.bundleParts;
		var value = new haxe_ds_IntMap();
		if(__map_reserved[name] != null) {
			_this2.setReserved(name,value);
		} else {
			_this2.h[name] = value;
		}
		var _this3 = this.totalParts;
		if(__map_reserved[name] != null) {
			_this3.setReserved(name,parts);
		} else {
			_this3.h[name] = parts;
		}
	}
	,addBundlePart: function(name,part,index) {
		name = name.split("|")[0];
		if(part == null) {
			return;
		}
		var _this = this.bundleParts;
		if(!(__map_reserved[name] != null ? _this.existsReserved(name) : _this.h.hasOwnProperty(name))) {
			return;
		}
		var _this1 = this.bundlePartsRemaining;
		if(!(__map_reserved[name] != null ? _this1.existsReserved(name) : _this1.h.hasOwnProperty(name))) {
			return;
		}
		var isWithinRange;
		if(index >= 0) {
			var _this2 = this.totalParts;
			isWithinRange = index < (__map_reserved[name] != null ? _this2.getReserved(name) : _this2.h[name]);
		} else {
			isWithinRange = false;
		}
		var _this3 = this.bundleParts;
		var hasNotLoadedYet = !(__map_reserved[name] != null ? _this3.getReserved(name) : _this3.h[name]).h.hasOwnProperty(index);
		if(!(isWithinRange && hasNotLoadedYet)) {
			return;
		}
		var _this4 = this.bundleParts;
		(__map_reserved[name] != null ? _this4.getReserved(name) : _this4.h[name]).h[index] = part;
		var _this5 = this.bundlePartsRemaining;
		var partsRemaining = __map_reserved[name] != null ? _this5.getReserved(name) : _this5.h[name];
		var _this6 = this.bundlePartsRemaining;
		var value = --partsRemaining;
		if(__map_reserved[name] != null) {
			_this6.setReserved(name,value);
		} else {
			_this6.h[name] = value;
		}
		console.debug(octane_core_debug_Logger.indent.join("") + " " + "Loaded part " + index + " of " + name + ", " + partsRemaining + " parts remaining");
		if(partsRemaining <= 0) {
			this._onAllBundlePartsLoaded.dispatch(name,this.getConcatenatedBundle(name));
		}
	}
	,partHasLoaded: function(name,part) {
		var _this = this.bundleParts;
		if(__map_reserved[name] != null ? _this.existsReserved(name) : _this.h.hasOwnProperty(name)) {
			var _this1 = this.bundleParts;
			return (__map_reserved[name] != null ? _this1.getReserved(name) : _this1.h[name]).h.hasOwnProperty(part);
		} else {
			return false;
		}
	}
	,getPartsRemaining: function(name) {
		var _this = this.bundlePartsRemaining;
		if(__map_reserved[name] != null) {
			return _this.getReserved(name);
		} else {
			return _this.h[name];
		}
	}
	,hasBundleBeenRegistered: function(name) {
		var _this = this.bundleParts;
		if(__map_reserved[name] != null) {
			return _this.existsReserved(name);
		} else {
			return _this.h.hasOwnProperty(name);
		}
	}
	,hasPartsOutstanding: function(name) {
		var _this = this.bundlePartsRemaining;
		if(__map_reserved[name] != null) {
			return _this.existsReserved(name);
		} else {
			return _this.h.hasOwnProperty(name);
		}
	}
	,indexIsValid: function(name,index) {
		var isWithinRange;
		if(index >= 0) {
			var _this = this.totalParts;
			isWithinRange = index < (__map_reserved[name] != null ? _this.getReserved(name) : _this.h[name]);
		} else {
			isWithinRange = false;
		}
		var _this1 = this.bundleParts;
		var hasNotLoadedYet = !(__map_reserved[name] != null ? _this1.getReserved(name) : _this1.h[name]).h.hasOwnProperty(index);
		if(isWithinRange) {
			return hasNotLoadedYet;
		} else {
			return false;
		}
	}
	,getConcatenatedBundle: function(name) {
		var _this = this.bundleParts;
		var parts = __map_reserved[name] != null ? _this.getReserved(name) : _this.h[name];
		var concat = [];
		var index = parts.keys();
		while(index.hasNext()) {
			var index1 = index.next();
			concat[index1] = parts.h[index1];
			parts.h[index1] = null;
		}
		return JSON.parse(concat.join(""));
	}
	,__class__: octane_preloader_model_MultipartBundleModel
};
var octane_preloader_model_PreloadedFilesModel = function() {
	this.onFileStored = this._onFileStored = new hx_event_Signal2();
	this.loadedFiles = new haxe_ds_StringMap();
};
$hxClasses["octane.preloader.model.PreloadedFilesModel"] = octane_preloader_model_PreloadedFilesModel;
octane_preloader_model_PreloadedFilesModel.__name__ = "octane.preloader.model.PreloadedFilesModel";
octane_preloader_model_PreloadedFilesModel.__interfaces__ = [octane_preloader_model_IPreloadedFilesModel];
octane_preloader_model_PreloadedFilesModel.prototype = {
	store: function(name,result) {
		var _this = this.loadedFiles;
		if(__map_reserved[name] != null) {
			_this.setReserved(name,result);
		} else {
			_this.h[name] = result;
		}
		this._onFileStored.dispatch(name,result);
	}
	,pop: function(name) {
		if(!this.has(name)) {
			throw new js__$Boot_HaxeError("Trying to pop asset \"" + name + "\" that has not been preloaded yet");
		}
		var _this = this.loadedFiles;
		var file = __map_reserved[name] != null ? _this.getReserved(name) : _this.h[name];
		this.loadedFiles.remove(name);
		return file;
	}
	,has: function(name) {
		var _this = this.loadedFiles;
		if(__map_reserved[name] != null) {
			return _this.existsReserved(name);
		} else {
			return _this.h.hasOwnProperty(name);
		}
	}
	,__class__: octane_preloader_model_PreloadedFilesModel
};
var octane_preloader_model_asset_profile_IAssetProfilesModel = $hx_exports["octane"]["preloader"]["model"]["asset"]["profile"]["IAssetProfilesModel"] = function() { };
$hxClasses["octane.preloader.model.asset.profile.IAssetProfilesModel"] = octane_preloader_model_asset_profile_IAssetProfilesModel;
octane_preloader_model_asset_profile_IAssetProfilesModel.__name__ = "octane.preloader.model.asset.profile.IAssetProfilesModel";
octane_preloader_model_asset_profile_IAssetProfilesModel.__isInterface__ = true;
octane_preloader_model_asset_profile_IAssetProfilesModel.prototype = {
	__class__: octane_preloader_model_asset_profile_IAssetProfilesModel
};
var octane_preloader_model_asset_profile_AssetProfilesModel = function() {
};
$hxClasses["octane.preloader.model.asset.profile.AssetProfilesModel"] = octane_preloader_model_asset_profile_AssetProfilesModel;
octane_preloader_model_asset_profile_AssetProfilesModel.__name__ = "octane.preloader.model.asset.profile.AssetProfilesModel";
octane_preloader_model_asset_profile_AssetProfilesModel.__interfaces__ = [octane_preloader_model_asset_profile_IAssetProfilesModel];
octane_preloader_model_asset_profile_AssetProfilesModel.prototype = {
	populate: function(assetProfilesConfig) {
		this.assetProfiles = assetProfilesConfig;
	}
	,getDesignWidth: function() {
		return this.assetProfiles.designWidth;
	}
	,getImageScales: function() {
		return this.assetProfiles.imageScales;
	}
	,getImageScalesDivision: function() {
		return this.assetProfiles.imageScalesDivision;
	}
	,getDefaultDesktopImageScale: function() {
		return this.assetProfiles.imageScaleDesktopDefault;
	}
	,getDefaultMobileImageScale: function() {
		return this.assetProfiles.imageScaleMobileDefault;
	}
	,getDefaultPackageGameImageScale: function() {
		return this.assetProfiles.imageScalePackagedGameDefault;
	}
	,getImageFormats: function() {
		return this.assetProfiles.imageFormats;
	}
	,getDefaultPackagedGameImageFormat: function() {
		return this.assetProfiles.imageFormatPackagedGameDefault;
	}
	,getAudioFormats: function() {
		return this.assetProfiles.audioFormats;
	}
	,getDefaultPackagedGameAudioFormat: function() {
		return this.assetProfiles.audioFormatPackagedGameDefault;
	}
	,__class__: octane_preloader_model_asset_profile_AssetProfilesModel
};
var octane_preloader_model_device_ICrossOriginResourceSharingBlacklistModel = $hx_exports["octane"]["preloader"]["model"]["device"]["ICrossOriginResourceSharingBlacklistModel"] = function() { };
$hxClasses["octane.preloader.model.device.ICrossOriginResourceSharingBlacklistModel"] = octane_preloader_model_device_ICrossOriginResourceSharingBlacklistModel;
octane_preloader_model_device_ICrossOriginResourceSharingBlacklistModel.__name__ = "octane.preloader.model.device.ICrossOriginResourceSharingBlacklistModel";
octane_preloader_model_device_ICrossOriginResourceSharingBlacklistModel.__isInterface__ = true;
octane_preloader_model_device_ICrossOriginResourceSharingBlacklistModel.prototype = {
	__class__: octane_preloader_model_device_ICrossOriginResourceSharingBlacklistModel
};
var octane_preloader_model_device_CrossOriginResourceSharingBlacklistModel = function() {
	this.blacklistedBrowsers = ["MSIE","Trident","QQBrowser","UCBrowser","OppoBrowser","VivoBrowser"];
};
$hxClasses["octane.preloader.model.device.CrossOriginResourceSharingBlacklistModel"] = octane_preloader_model_device_CrossOriginResourceSharingBlacklistModel;
octane_preloader_model_device_CrossOriginResourceSharingBlacklistModel.__name__ = "octane.preloader.model.device.CrossOriginResourceSharingBlacklistModel";
octane_preloader_model_device_CrossOriginResourceSharingBlacklistModel.__interfaces__ = [octane_preloader_model_device_ICrossOriginResourceSharingBlacklistModel];
octane_preloader_model_device_CrossOriginResourceSharingBlacklistModel.prototype = {
	isBlacklistedBrowser: function(userAgentString) {
		var _g = 0;
		var _g1 = this.blacklistedBrowsers;
		while(_g < _g1.length) {
			var blacklistedBrowser = _g1[_g];
			++_g;
			if(userAgentString.indexOf(blacklistedBrowser) != -1) {
				return true;
			}
		}
		return false;
	}
	,__class__: octane_preloader_model_device_CrossOriginResourceSharingBlacklistModel
};
var octane_preloader_model_device_IDeviceInformationModel = $hx_exports["octane"]["preloader"]["model"]["device"]["IDeviceInformationModel"] = function() { };
$hxClasses["octane.preloader.model.device.IDeviceInformationModel"] = octane_preloader_model_device_IDeviceInformationModel;
octane_preloader_model_device_IDeviceInformationModel.__name__ = "octane.preloader.model.device.IDeviceInformationModel";
octane_preloader_model_device_IDeviceInformationModel.__isInterface__ = true;
octane_preloader_model_device_IDeviceInformationModel.prototype = {
	__class__: octane_preloader_model_device_IDeviceInformationModel
	,__properties__: {get_requiresCrossOriginResourceSharing:"get_requiresCrossOriginResourceSharing",get_hasPoorXHRSupport:"get_hasPoorXHRSupport",get_hasPoorOggSupport:"get_hasPoorOggSupport",get_supportsBlendModes:"get_supportsBlendModes",get_maySupportWebGL:"get_maySupportWebGL",get_isLowPerformanceGPU:"get_isLowPerformanceGPU",get_isIPhoneXSeries:"get_isIPhoneXSeries",get_isIOS:"get_isIOS",get_launchType:"get_launchType",get_scaledResolution:"get_scaledResolution",get_cappedScaledResolution:"get_cappedScaledResolution",get_cappedPixelRatio:"get_cappedPixelRatio"}
};
var octane_preloader_model_device_DeviceInformationModel = $hx_exports["octane"]["preloader"]["model"]["device"]["DeviceInformationModel"] = function() {
};
$hxClasses["octane.preloader.model.device.DeviceInformationModel"] = octane_preloader_model_device_DeviceInformationModel;
octane_preloader_model_device_DeviceInformationModel.__name__ = "octane.preloader.model.device.DeviceInformationModel";
octane_preloader_model_device_DeviceInformationModel.__interfaces__ = [octane_preloader_model_device_IDeviceInformationModel];
octane_preloader_model_device_DeviceInformationModel.prototype = {
	get_maySupportWebGL: function() {
		return !this.webGLBlacklistModel.isBlacklistedGPU(this.get_webGlReport().unmaskedRenderer);
	}
	,get_hasPoorOggSupport: function() {
		return this.hasPoorOggSupport;
	}
	,get_hasPoorXHRSupport: function() {
		if(!this.isQQBrowser()) {
			return this.isIE();
		} else {
			return true;
		}
	}
	,get_requiresCrossOriginResourceSharing: function() {
		if(this.crossOriginResourceSharingBlacklistModel.isBlacklistedBrowser(this.navigator.userAgent)) {
			return true;
		}
		return null;
	}
	,get_supportsBlendModes: function() {
		return this.supportsBlendModes;
	}
	,get_cappedPixelRatio: function() {
		return this.cappedPixelRatio;
	}
	,get_cappedScaledResolution: function() {
		var x = window.screen.width * this.get_cappedPixelRatio();
		var y = window.screen.height * this.get_cappedPixelRatio();
		return octane_core_types_geom__$Point_Point_$Impl_$._new(x,y);
	}
	,get_isLowPerformanceGPU: function() {
		return this.isLowPerformanceGPU;
	}
	,get_isIPhoneXSeries: function() {
		return this.isIPhoneXSeries;
	}
	,get_isIOS: function() {
		return this.isIOS;
	}
	,get_scaledResolution: function() {
		return this.scaledResolution;
	}
	,get_launchType: function() {
		return this.launchType;
	}
	,get_webGlReport: function() {
		if(this.webGlReport == null) {
			this.webGlReport = this.webGLReportService.getWebGlReport();
		}
		return this.webGlReport;
	}
	,isQQBrowser: function() {
		return new EReg("MQQ","i").match(this.navigator.userAgent);
	}
	,isIE: function() {
		return new EReg("(MSIE|Trident.*rv:11)","").match(this.navigator.userAgent);
	}
	,__class__: octane_preloader_model_device_DeviceInformationModel
	,__properties__: {get_webGlReport:"get_webGlReport",get_launchType:"get_launchType",get_isLowPerformanceGPU:"get_isLowPerformanceGPU",get_isIPhoneXSeries:"get_isIPhoneXSeries",get_isIOS:"get_isIOS",get_scaledResolution:"get_scaledResolution",get_cappedScaledResolution:"get_cappedScaledResolution",get_cappedPixelRatio:"get_cappedPixelRatio",get_supportsBlendModes:"get_supportsBlendModes",get_hasPoorOggSupport:"get_hasPoorOggSupport",get_requiresCrossOriginResourceSharing:"get_requiresCrossOriginResourceSharing",get_hasPoorXHRSupport:"get_hasPoorXHRSupport",get_maySupportWebGL:"get_maySupportWebGL"}
};
var octane_preloader_model_device_IWebGLBlacklistModel = $hx_exports["octane"]["preloader"]["model"]["device"]["IWebGLBlacklistModel"] = function() { };
$hxClasses["octane.preloader.model.device.IWebGLBlacklistModel"] = octane_preloader_model_device_IWebGLBlacklistModel;
octane_preloader_model_device_IWebGLBlacklistModel.__name__ = "octane.preloader.model.device.IWebGLBlacklistModel";
octane_preloader_model_device_IWebGLBlacklistModel.__isInterface__ = true;
octane_preloader_model_device_IWebGLBlacklistModel.prototype = {
	__class__: octane_preloader_model_device_IWebGLBlacklistModel
};
var octane_preloader_model_device_LaunchType = $hxEnums["octane.preloader.model.device.LaunchType"] = { __ename__ : "octane.preloader.model.device.LaunchType", __constructs__ : ["Standalone","WebPage","WebView"]
	,Standalone: {_hx_index:0,__enum__:"octane.preloader.model.device.LaunchType",toString:$estr}
	,WebPage: {_hx_index:1,__enum__:"octane.preloader.model.device.LaunchType",toString:$estr}
	,WebView: {_hx_index:2,__enum__:"octane.preloader.model.device.LaunchType",toString:$estr}
};
var octane_preloader_model_device_WebGLBlacklistModel = function() {
	this.blacklistedGPUs = ["Mali-T760","Adreno (TM) 330","Adreno (TM) 305"];
};
$hxClasses["octane.preloader.model.device.WebGLBlacklistModel"] = octane_preloader_model_device_WebGLBlacklistModel;
octane_preloader_model_device_WebGLBlacklistModel.__name__ = "octane.preloader.model.device.WebGLBlacklistModel";
octane_preloader_model_device_WebGLBlacklistModel.__interfaces__ = [octane_preloader_model_device_IWebGLBlacklistModel];
octane_preloader_model_device_WebGLBlacklistModel.prototype = {
	isBlacklistedGPU: function(GPU) {
		var unknownRenderer = GPU == null;
		if(unknownRenderer) {
			return true;
		}
		return Lambda.has(this.blacklistedGPUs,GPU);
	}
	,isBlacklistedPlatform: function(userAgentString) {
		return new EReg(".*Crosswalk.*","i").match(userAgentString);
	}
	,isBlacklistedBrowser: function(browser) {
		return browser == "IE";
	}
	,__class__: octane_preloader_model_device_WebGLBlacklistModel
};
var octane_preloader_model_host_IHostTypeModel = $hx_exports["octane"]["preloader"]["model"]["host"]["IHostTypeModel"] = function() { };
$hxClasses["octane.preloader.model.host.IHostTypeModel"] = octane_preloader_model_host_IHostTypeModel;
octane_preloader_model_host_IHostTypeModel.__name__ = "octane.preloader.model.host.IHostTypeModel";
octane_preloader_model_host_IHostTypeModel.__isInterface__ = true;
octane_preloader_model_host_IHostTypeModel.prototype = {
	__class__: octane_preloader_model_host_IHostTypeModel
	,__properties__: {set_current:"set_current",get_current:"get_current"}
};
var octane_preloader_model_host_HostTypeModel = function() {
	this._current = null;
};
$hxClasses["octane.preloader.model.host.HostTypeModel"] = octane_preloader_model_host_HostTypeModel;
octane_preloader_model_host_HostTypeModel.__name__ = "octane.preloader.model.host.HostTypeModel";
octane_preloader_model_host_HostTypeModel.__interfaces__ = [octane_preloader_model_host_IHostTypeModel];
octane_preloader_model_host_HostTypeModel.prototype = {
	get_current: function() {
		return this._current;
	}
	,set_current: function(hostType) {
		return this._current = hostType;
	}
	,__class__: octane_preloader_model_host_HostTypeModel
	,__properties__: {set_current:"set_current",get_current:"get_current"}
};
var octane_preloader_model_manifest_IPreloaderManifestModel = $hx_exports["octane"]["preloader"]["model"]["manifest"]["IPreloaderManifestModel"] = function() { };
$hxClasses["octane.preloader.model.manifest.IPreloaderManifestModel"] = octane_preloader_model_manifest_IPreloaderManifestModel;
octane_preloader_model_manifest_IPreloaderManifestModel.__name__ = "octane.preloader.model.manifest.IPreloaderManifestModel";
octane_preloader_model_manifest_IPreloaderManifestModel.__isInterface__ = true;
octane_preloader_model_manifest_IPreloaderManifestModel.prototype = {
	__class__: octane_preloader_model_manifest_IPreloaderManifestModel
};
var octane_preloader_model_manifest_PreloaderManifestModel = function() {
};
$hxClasses["octane.preloader.model.manifest.PreloaderManifestModel"] = octane_preloader_model_manifest_PreloaderManifestModel;
octane_preloader_model_manifest_PreloaderManifestModel.__name__ = "octane.preloader.model.manifest.PreloaderManifestModel";
octane_preloader_model_manifest_PreloaderManifestModel.__interfaces__ = [octane_preloader_model_manifest_IPreloaderManifestModel];
octane_preloader_model_manifest_PreloaderManifestModel.prototype = {
	populate: function() {
		this.files = JSON.parse("[{\"id\":\"Common\",\"filePath\":\"Common_{language}_948de8.json\",\"gzippedFileSize\":10240}]");
		this.scripts = JSON.parse("[{\"id\":\"Vendor\",\"filePath\":\"Vendor_10d269.js\"},{\"id\":\"Game_mobile\",\"filePath\":\"Game_{formFactor}_24c335.js\"},{\"id\":\"Game_desktop\",\"filePath\":\"Game_{formFactor}_24c335.js\"}]");
	}
	,dispose: function() {
	}
	,__class__: octane_preloader_model_manifest_PreloaderManifestModel
};
var octane_preloader_service_IFileLoadingService = $hx_exports["octane"]["preloader"]["service"]["IFileLoadingService"] = function() { };
$hxClasses["octane.preloader.service.IFileLoadingService"] = octane_preloader_service_IFileLoadingService;
octane_preloader_service_IFileLoadingService.__name__ = "octane.preloader.service.IFileLoadingService";
octane_preloader_service_IFileLoadingService.__isInterface__ = true;
octane_preloader_service_IFileLoadingService.prototype = {
	__class__: octane_preloader_service_IFileLoadingService
};
var octane_preloader_service_FileLoadingService = function() {
	this.onFileLoaded = this._onFileLoaded = new hx_event_Signal2();
	this.onQueueComplete = this._onQueueComplete = new hx_event_Signal0();
	this.onScriptLoaded = this._onScriptLoaded = new hx_event_Signal1();
	this.firstLoadBundlesCompleted = false;
	this.numFilesEnqueued = 0;
	this.numFilesLoaded = 0;
	this.preloaderProgress = 0;
	this.manifest = new haxe_ds_StringMap();
	var _g = new haxe_ds_StringMap();
	if(__map_reserved["Common"] != null) {
		_g.setReserved("Common",4);
	} else {
		_g.h["Common"] = 4;
	}
	if(__map_reserved["Vendor"] != null) {
		_g.setReserved("Vendor",8);
	} else {
		_g.h["Vendor"] = 8;
	}
	if(__map_reserved["Game"] != null) {
		_g.setReserved("Game",8);
	} else {
		_g.h["Game"] = 8;
	}
	this.preloadFileNamesToProgressPercent = _g;
};
$hxClasses["octane.preloader.service.FileLoadingService"] = octane_preloader_service_FileLoadingService;
octane_preloader_service_FileLoadingService.__name__ = "octane.preloader.service.FileLoadingService";
octane_preloader_service_FileLoadingService.__interfaces__ = [octane_preloader_service_IFileLoadingService];
octane_preloader_service_FileLoadingService.prototype = {
	postConstruct: function() {
		var preferXHR = !this.deviceInformationModel.get_hasPoorXHRSupport();
		this.queue = new CustomLoadQueue(preferXHR,null,this.deviceInformationModel.get_requiresCrossOriginResourceSharing());
		this.queue.registerLoader(CustomJSLoader);
		this.queue.registerLoader(CustomJSONLoader);
		this.queue.setMaxConnections(10);
		this.queue.initializeConfig({ maintainScriptOrder : false, scriptsPreferXHR : false, injectScriptsToHead : true, deferScripts : true, asyncScripts : true});
		this.queue.on("fileload",$bind(this,this.onFileLoadHandler));
		this.queue.on("complete",$bind(this,this.onCompleteHandler));
		this.queue.on("error",$bind(this,this.onErrorHandler));
		this.preloaderUpdateService.updateProgressBar(0);
		this.fakeProgressTimer();
	}
	,enqueueAssets: function(assets) {
		if(octane_core_types_array_ArrayExtensions.isNullOrEmpty(assets)) {
			return;
		}
		var _g = 0;
		while(_g < assets.length) {
			var asset = assets[_g];
			++_g;
			var _this = this.manifest;
			var key = asset.id;
			if(__map_reserved[key] != null ? _this.existsReserved(key) : _this.h.hasOwnProperty(key)) {
				continue;
			}
			this.numFilesEnqueued += 1;
			var item = this.createLoadItem(asset);
			var _this1 = this.manifest;
			var key1 = item.id;
			if(__map_reserved[key1] != null) {
				_this1.setReserved(key1,item);
			} else {
				_this1.h[key1] = item;
			}
			this.queue.loadFile(item,false);
		}
		this.queue.load();
	}
	,enqueuePreloadBundles: function(bundles) {
		if(octane_core_types_array_ArrayExtensions.isNullOrEmpty(bundles)) {
			return;
		}
		this.enqueueAssets(bundles);
	}
	,priorityLoadAssets: function(assets) {
		var _gthis = this;
		if(octane_core_types_array_ArrayExtensions.isNullOrEmpty(assets)) {
			return;
		}
		if(!this.isPriorityLoadRequired(assets)) {
			console.debug(octane_core_debug_Logger.indent.join("") + " " + "No change in asset load priority, ignoring.");
			return;
		}
		var priority = assets.map(function(asset) {
			return _gthis.createLoadItem(asset);
		});
		this.queue.reprioritizeLoad(priority);
	}
	,onFileLoadHandler: function(event) {
		this.handleProgress(event.item.id);
		if(event.item.type == "javascript") {
			this._onScriptLoaded.dispatch(event.item.id);
		} else {
			this._onFileLoaded.dispatch(event.item.id,new octane_core_mvc_controller_DynamicWrapper(event.result));
		}
		delete this.queue._loadItemsById[event.item.id];
		delete this.queue._loadItemsBySrc[event.item.src];
		delete this.queue._loadedRawResults[event.item.id];
		delete this.queue._loadedResults[event.item.id];
		delete event.item._loader.destroy();
	}
	,handleProgress: function(fileName) {
		if(this.firstLoadBundlesCompleted) {
			return;
		}
		if(this.shouldReportFilePreloadProgress(fileName)) {
			var _this = this.preloadFileNamesToProgressPercent;
			this.updatePreloaderProgress(__map_reserved[fileName] != null ? _this.getReserved(fileName) : _this.h[fileName]);
		} else if(this.shouldReportBundlePreloadProgress()) {
			var progressAmount = 1 / this.numFilesEnqueued;
			var progressIncrease = Math.floor(progressAmount * 50);
			this.updatePreloaderProgress(progressIncrease);
		}
		this.numFilesLoaded += 1;
	}
	,onCompleteHandler: function() {
		this.firstLoadBundlesCompleted = true;
		this._onQueueComplete.dispatch();
	}
	,onErrorHandler: function(error) {
		var errorDetails = { title : error.title, message : error.message, data : error.data};
		throw new js__$Boot_HaxeError(errorDetails);
	}
	,createLoadItem: function(asset) {
		return new createjs.LoadItem().set({ id : asset.id, src : this.loaderModel.resolveGameUrl(asset.filePath), loadTimeout : 60000});
	}
	,isPriorityLoadRequired: function(assets) {
		var _g = 0;
		while(_g < assets.length) {
			var asset = assets[_g];
			++_g;
			var _this = this.manifest;
			var key = asset.id;
			if(!(__map_reserved[key] != null ? _this.existsReserved(key) : _this.h.hasOwnProperty(key))) {
				return true;
			}
		}
		return false;
	}
	,fakeProgressTimer: function() {
		if(this.progressTimer.get_isRunning()) {
			return;
		}
		var waitMs = 0;
		if(this.firstLoadBundlesCompleted) {
			waitMs = 150 + Math.floor(Math.random() * 600);
		} else {
			waitMs = 1900;
		}
		this.progressTimer.get_onComplete().add($bind(this,this.onFakeProgressTimerTick),true);
		this.progressTimer.start(waitMs);
	}
	,onFakeProgressTimerTick: function() {
		var increment = 0;
		if(this.firstLoadBundlesCompleted) {
			increment = 1 + Math.floor(Math.random() * 4);
		} else {
			increment = 1;
		}
		this.updatePreloaderProgress(increment);
		if(this.preloaderProgress < 100) {
			this.fakeProgressTimer();
		}
	}
	,updatePreloaderProgress: function(value) {
		this.preloaderProgress += value;
		if(this.preloaderProgress > 90) {
			return;
		}
		this.preloaderUpdateService.updateProgressBar(this.preloaderProgress);
	}
	,shouldReportFilePreloadProgress: function(fileName) {
		var _this = this.preloadFileNamesToProgressPercent;
		if(__map_reserved[fileName] != null) {
			return _this.existsReserved(fileName);
		} else {
			return _this.h.hasOwnProperty(fileName);
		}
	}
	,shouldReportBundlePreloadProgress: function() {
		return this.numFilesLoaded != this.numFilesEnqueued;
	}
	,setMaximumParallelLoads: function(value) {
		if(value > 10) {
			console.error(octane_core_debug_Logger.indent.join("") + " " + "Can't set max connections to more than 10");
			return;
		}
		if(value < 1) {
			console.error(octane_core_debug_Logger.indent.join("") + " " + "Can't set max connections to less than 1");
			return;
		}
		this.queue.setMaxConnections(value);
	}
	,priorityQueueAssets: function(assets) {
		var _gthis = this;
		var priority = assets.map(function(asset) {
			return _gthis.createLoadItem(asset);
		});
		this.queue.reprioritizeQueue(priority);
	}
	,__class__: octane_preloader_service_FileLoadingService
};
var octane_preloader_service_IHostPreloaderUpdateService = $hx_exports["octane"]["preloader"]["service"]["IHostPreloaderUpdateService"] = function() { };
$hxClasses["octane.preloader.service.IHostPreloaderUpdateService"] = octane_preloader_service_IHostPreloaderUpdateService;
octane_preloader_service_IHostPreloaderUpdateService.__name__ = "octane.preloader.service.IHostPreloaderUpdateService";
octane_preloader_service_IHostPreloaderUpdateService.__isInterface__ = true;
octane_preloader_service_IHostPreloaderUpdateService.prototype = {
	__class__: octane_preloader_service_IHostPreloaderUpdateService
};
var octane_preloader_service_IPreloaderNotificationService = $hx_exports["octane"]["preloader"]["service"]["IPreloaderNotificationService"] = function() { };
$hxClasses["octane.preloader.service.IPreloaderNotificationService"] = octane_preloader_service_IPreloaderNotificationService;
octane_preloader_service_IPreloaderNotificationService.__name__ = "octane.preloader.service.IPreloaderNotificationService";
octane_preloader_service_IPreloaderNotificationService.__isInterface__ = true;
octane_preloader_service_IPreloaderNotificationService.prototype = {
	__class__: octane_preloader_service_IPreloaderNotificationService
};
var octane_preloader_service_asset_IAssetPathBuilderService = $hx_exports["octane"]["preloader"]["service"]["asset"]["IAssetPathBuilderService"] = function() { };
$hxClasses["octane.preloader.service.asset.IAssetPathBuilderService"] = octane_preloader_service_asset_IAssetPathBuilderService;
octane_preloader_service_asset_IAssetPathBuilderService.__name__ = "octane.preloader.service.asset.IAssetPathBuilderService";
octane_preloader_service_asset_IAssetPathBuilderService.__isInterface__ = true;
octane_preloader_service_asset_IAssetPathBuilderService.prototype = {
	__class__: octane_preloader_service_asset_IAssetPathBuilderService
	,__properties__: {get_bundlePermutationPath:"get_bundlePermutationPath"}
};
var octane_preloader_service_asset_AssetPathBuilderService = function() {
};
$hxClasses["octane.preloader.service.asset.AssetPathBuilderService"] = octane_preloader_service_asset_AssetPathBuilderService;
octane_preloader_service_asset_AssetPathBuilderService.__name__ = "octane.preloader.service.asset.AssetPathBuilderService";
octane_preloader_service_asset_AssetPathBuilderService.__interfaces__ = [octane_preloader_service_asset_IAssetPathBuilderService];
octane_preloader_service_asset_AssetPathBuilderService.prototype = {
	getAssetPath: function(filePath) {
		var permutationPath = this.substituteImageScale(filePath);
		permutationPath = this.substituteImageFormat(permutationPath);
		permutationPath = this.substituteAudioFormat(permutationPath);
		permutationPath = this.substituteFormFactor(permutationPath);
		return permutationPath;
	}
	,substituteImageScale: function(filePath) {
		var _this = octane_preloader_service_asset_AssetPathBuilderService.imageScaleRegex;
		var by = "" + this.imageScaleCalculatorService.get_suitableImageScale();
		return filePath.replace(_this.r,by);
	}
	,substituteImageFormat: function(filePath) {
		var _this = octane_preloader_service_asset_AssetPathBuilderService.imageFormatRegex;
		var by = "" + this.imageFormatSelectionService.getImageFormatToLoad();
		return filePath.replace(_this.r,by);
	}
	,substituteAudioFormat: function(filePath) {
		var _this = octane_preloader_service_asset_AssetPathBuilderService.audioFormatRegex;
		var by = this.audioFormatSelectionService.getAudioFormatToLoad();
		return filePath.replace(_this.r,by);
	}
	,substituteFormFactor: function(filePath) {
		var _this = octane_preloader_service_asset_AssetPathBuilderService.formFactorRegex;
		var by = this.formFactorDetectionService.getCurrentFormFactorType();
		return filePath.replace(_this.r,by);
	}
	,get_bundlePermutationPath: function() {
		return this.getAssetPath("{audioFormat}_{imageFormat}_{imageScale}");
	}
	,__class__: octane_preloader_service_asset_AssetPathBuilderService
	,__properties__: {get_bundlePermutationPath:"get_bundlePermutationPath"}
};
var octane_preloader_service_asset_IImageScaleCalculatorService = $hx_exports["octane"]["preloader"]["service"]["asset"]["IImageScaleCalculatorService"] = function() { };
$hxClasses["octane.preloader.service.asset.IImageScaleCalculatorService"] = octane_preloader_service_asset_IImageScaleCalculatorService;
octane_preloader_service_asset_IImageScaleCalculatorService.__name__ = "octane.preloader.service.asset.IImageScaleCalculatorService";
octane_preloader_service_asset_IImageScaleCalculatorService.__isInterface__ = true;
octane_preloader_service_asset_IImageScaleCalculatorService.prototype = {
	__class__: octane_preloader_service_asset_IImageScaleCalculatorService
	,__properties__: {get_suitableImageScale:"get_suitableImageScale"}
};
var octane_preloader_service_asset_IPerformanceLevelSelectionService = $hx_exports["octane"]["preloader"]["service"]["asset"]["IPerformanceLevelSelectionService"] = function() { };
$hxClasses["octane.preloader.service.asset.IPerformanceLevelSelectionService"] = octane_preloader_service_asset_IPerformanceLevelSelectionService;
octane_preloader_service_asset_IPerformanceLevelSelectionService.__name__ = "octane.preloader.service.asset.IPerformanceLevelSelectionService";
octane_preloader_service_asset_IPerformanceLevelSelectionService.__isInterface__ = true;
octane_preloader_service_asset_IPerformanceLevelSelectionService.prototype = {
	__class__: octane_preloader_service_asset_IPerformanceLevelSelectionService
};
var octane_preloader_service_asset_PerformanceLevelSelectionService = function() {
};
$hxClasses["octane.preloader.service.asset.PerformanceLevelSelectionService"] = octane_preloader_service_asset_PerformanceLevelSelectionService;
octane_preloader_service_asset_PerformanceLevelSelectionService.__name__ = "octane.preloader.service.asset.PerformanceLevelSelectionService";
octane_preloader_service_asset_PerformanceLevelSelectionService.__interfaces__ = [octane_preloader_service_asset_IPerformanceLevelSelectionService];
octane_preloader_service_asset_PerformanceLevelSelectionService.prototype = {
	getPerformanceLevelToLoad: function() {
		return 0;
	}
	,__class__: octane_preloader_service_asset_PerformanceLevelSelectionService
};
var octane_preloader_service_asset_WebImageScaleCalculatorService = function() {
};
$hxClasses["octane.preloader.service.asset.WebImageScaleCalculatorService"] = octane_preloader_service_asset_WebImageScaleCalculatorService;
octane_preloader_service_asset_WebImageScaleCalculatorService.__name__ = "octane.preloader.service.asset.WebImageScaleCalculatorService";
octane_preloader_service_asset_WebImageScaleCalculatorService.__interfaces__ = [octane_preloader_service_asset_IImageScaleCalculatorService];
octane_preloader_service_asset_WebImageScaleCalculatorService.prototype = {
	get_suitableImageScale: function() {
		if(this.suitableImageScale == null) {
			this.suitableImageScale = this.calcSuitableImageScale();
		}
		return this.suitableImageScale;
	}
	,calcSuitableImageScale: function() {
		if(this.preloaderToggles.imageScale != null) {
			return this.preloaderToggles.imageScale;
		}
		var imageScales = this.getSortedImageScales();
		if(this.packagedGameDetectionService.isPackaged()) {
			return this.getPackagedGameScale(imageScales);
		}
		if(imageScales.length == 1 || !this.deviceInformationModel.get_maySupportWebGL()) {
			return octane_core_types_array_ArrayExtensions.first(imageScales);
		}
		if(this.platformType.isDesktop()) {
			return this.getDesktopOrHighestScale(imageScales);
		}
		var deviceResolution = this.deviceSizeService.get_scaledResolution();
		var deviceWidth = Math.max(deviceResolution.x,deviceResolution.y);
		var imageScalesDivision = this.assetProfilesModel.getImageScalesDivision();
		var imageScale = this.assetProfilesModel.getDefaultMobileImageScale();
		var prevMax = 0;
		var _g = 0;
		var _g1 = Reflect.fields(imageScalesDivision);
		while(_g < _g1.length) {
			var scaleDivisionWidth = _g1[_g];
			++_g;
			var divisionWidth = Std.parseInt(scaleDivisionWidth);
			if(deviceWidth >= prevMax && deviceWidth <= divisionWidth) {
				imageScale = imageScalesDivision[scaleDivisionWidth];
				break;
			}
			prevMax = divisionWidth;
		}
		return imageScale;
	}
	,shouldDefaultToLowestImageScale: function(imageScales) {
		if(imageScales.length != 1) {
			return !this.deviceInformationModel.get_maySupportWebGL();
		} else {
			return true;
		}
	}
	,getSortedImageScales: function() {
		var imageScales = this.assetProfilesModel.getImageScales();
		imageScales.sort(function(first,second) {
			return first - second;
		});
		return imageScales;
	}
	,getDesktopOrHighestScale: function(imageScales) {
		var defaultDesktopImageScale = this.assetProfilesModel.getDefaultDesktopImageScale();
		if(octane_core_types_array_ArrayExtensions.has(imageScales,defaultDesktopImageScale)) {
			return defaultDesktopImageScale;
		}
		return octane_core_types_array_ArrayExtensions.last(imageScales);
	}
	,getPackagedGameScale: function(imageScales) {
		return this.assetProfilesModel.getDefaultPackageGameImageScale();
	}
	,__class__: octane_preloader_service_asset_WebImageScaleCalculatorService
	,__properties__: {get_suitableImageScale:"get_suitableImageScale"}
};
var octane_preloader_service_asset_format_IAssetFormatService = $hx_exports["octane"]["preloader"]["service"]["asset"]["format"]["IAssetFormatService"] = function() { };
$hxClasses["octane.preloader.service.asset.format.IAssetFormatService"] = octane_preloader_service_asset_format_IAssetFormatService;
octane_preloader_service_asset_format_IAssetFormatService.__name__ = "octane.preloader.service.asset.format.IAssetFormatService";
octane_preloader_service_asset_format_IAssetFormatService.__isInterface__ = true;
octane_preloader_service_asset_format_IAssetFormatService.prototype = {
	__class__: octane_preloader_service_asset_format_IAssetFormatService
	,__properties__: {get_supportedAudioFormats:"get_supportedAudioFormats",get_supportsWebP:"get_supportsWebP"}
};
var octane_preloader_service_asset_format_AssetFormatService = function() { };
$hxClasses["octane.preloader.service.asset.format.AssetFormatService"] = octane_preloader_service_asset_format_AssetFormatService;
octane_preloader_service_asset_format_AssetFormatService.__name__ = "octane.preloader.service.asset.format.AssetFormatService";
octane_preloader_service_asset_format_AssetFormatService.__interfaces__ = [octane_preloader_service_asset_format_IAssetFormatService];
octane_preloader_service_asset_format_AssetFormatService.prototype = {
	get_supportsWebP: function() {
		if(!this.modernizrService.get_webPSupport()) {
			return Reflect.field(window,"webp");
		} else {
			return true;
		}
	}
	,get_supportedAudioFormats: function() {
		return this.modernizrService.get_audioSupport();
	}
	,__class__: octane_preloader_service_asset_format_AssetFormatService
	,__properties__: {get_supportedAudioFormats:"get_supportedAudioFormats",get_supportsWebP:"get_supportsWebP"}
};
var octane_preloader_service_asset_format_IAudioFormatSelectionService = $hx_exports["octane"]["preloader"]["service"]["asset"]["format"]["IAudioFormatSelectionService"] = function() { };
$hxClasses["octane.preloader.service.asset.format.IAudioFormatSelectionService"] = octane_preloader_service_asset_format_IAudioFormatSelectionService;
octane_preloader_service_asset_format_IAudioFormatSelectionService.__name__ = "octane.preloader.service.asset.format.IAudioFormatSelectionService";
octane_preloader_service_asset_format_IAudioFormatSelectionService.__isInterface__ = true;
octane_preloader_service_asset_format_IAudioFormatSelectionService.prototype = {
	__class__: octane_preloader_service_asset_format_IAudioFormatSelectionService
};
var octane_preloader_service_asset_format_AudioFormatSelectionService = function() {
};
$hxClasses["octane.preloader.service.asset.format.AudioFormatSelectionService"] = octane_preloader_service_asset_format_AudioFormatSelectionService;
octane_preloader_service_asset_format_AudioFormatSelectionService.__name__ = "octane.preloader.service.asset.format.AudioFormatSelectionService";
octane_preloader_service_asset_format_AudioFormatSelectionService.__interfaces__ = [octane_preloader_service_asset_format_IAudioFormatSelectionService];
octane_preloader_service_asset_format_AudioFormatSelectionService.prototype = {
	getAudioFormatToLoad: function() {
		if(this.packagedGameDetectionService.isPackaged()) {
			return this.assetProfilesModel.getDefaultPackagedGameAudioFormat();
		}
		if(this.canUseAudioFormat("ogg")) {
			return "ogg";
		}
		if(this.canUseAudioFormat("aac")) {
			return "aac";
		}
		return "mp3";
	}
	,canUseAudioFormat: function(audioFormat) {
		if(this.audioFormatSupported(audioFormat)) {
			return this.audioFormatAvailable(audioFormat);
		} else {
			return false;
		}
	}
	,audioFormatSupported: function(audioFormat) {
		return Lambda.has(this.assetFormatService.get_supportedAudioFormats(),audioFormat);
	}
	,audioFormatAvailable: function(audioFormat) {
		return Lambda.has(this.assetProfilesModel.getAudioFormats(),audioFormat);
	}
	,__class__: octane_preloader_service_asset_format_AudioFormatSelectionService
};
var octane_preloader_service_asset_format_IImageFormatSelectionService = $hx_exports["octane"]["preloader"]["service"]["asset"]["format"]["IImageFormatSelectionService"] = function() { };
$hxClasses["octane.preloader.service.asset.format.IImageFormatSelectionService"] = octane_preloader_service_asset_format_IImageFormatSelectionService;
octane_preloader_service_asset_format_IImageFormatSelectionService.__name__ = "octane.preloader.service.asset.format.IImageFormatSelectionService";
octane_preloader_service_asset_format_IImageFormatSelectionService.__isInterface__ = true;
octane_preloader_service_asset_format_IImageFormatSelectionService.prototype = {
	__class__: octane_preloader_service_asset_format_IImageFormatSelectionService
};
var octane_preloader_service_asset_format_ImageFormatSelectionService = function() {
};
$hxClasses["octane.preloader.service.asset.format.ImageFormatSelectionService"] = octane_preloader_service_asset_format_ImageFormatSelectionService;
octane_preloader_service_asset_format_ImageFormatSelectionService.__name__ = "octane.preloader.service.asset.format.ImageFormatSelectionService";
octane_preloader_service_asset_format_ImageFormatSelectionService.__interfaces__ = [octane_preloader_service_asset_format_IImageFormatSelectionService];
octane_preloader_service_asset_format_ImageFormatSelectionService.prototype = {
	getImageFormatToLoad: function() {
		if(this.packagedGameDetectionService.isPackaged()) {
			return this.assetProfilesModel.getDefaultPackagedGameImageFormat();
		}
		if(this.canUseWebP()) {
			return "webp";
		}
		return "png";
	}
	,canUseWebP: function() {
		if(this.webPFormatSupported()) {
			return this.imageFormatAvailable("webp");
		} else {
			return false;
		}
	}
	,webPFormatSupported: function() {
		return this.assetFormatService.get_supportsWebP();
	}
	,imageFormatAvailable: function(imageFormat) {
		return Lambda.has(this.assetProfilesModel.getImageFormats(),imageFormat);
	}
	,__class__: octane_preloader_service_asset_format_ImageFormatSelectionService
};
var octane_preloader_service_bundle_IBundleExternalAssetLoadingService = $hx_exports["octane"]["preloader"]["service"]["bundle"]["IBundleExternalAssetLoadingService"] = function() { };
$hxClasses["octane.preloader.service.bundle.IBundleExternalAssetLoadingService"] = octane_preloader_service_bundle_IBundleExternalAssetLoadingService;
octane_preloader_service_bundle_IBundleExternalAssetLoadingService.__name__ = "octane.preloader.service.bundle.IBundleExternalAssetLoadingService";
octane_preloader_service_bundle_IBundleExternalAssetLoadingService.__isInterface__ = true;
octane_preloader_service_bundle_IBundleExternalAssetLoadingService.prototype = {
	__class__: octane_preloader_service_bundle_IBundleExternalAssetLoadingService
};
var octane_preloader_service_bundle_BundleExternalAssetLoadingService = function() {
};
$hxClasses["octane.preloader.service.bundle.BundleExternalAssetLoadingService"] = octane_preloader_service_bundle_BundleExternalAssetLoadingService;
octane_preloader_service_bundle_BundleExternalAssetLoadingService.__name__ = "octane.preloader.service.bundle.BundleExternalAssetLoadingService";
octane_preloader_service_bundle_BundleExternalAssetLoadingService.__interfaces__ = [octane_preloader_service_bundle_IBundleExternalAssetLoadingService];
octane_preloader_service_bundle_BundleExternalAssetLoadingService.prototype = {
	loadExternalAssetsForBundle: function(assets) {
		if(assets == null) {
			return;
		}
		var assetsToLoad = [];
		var _g = 0;
		var _g1 = Reflect.fields(assets);
		while(_g < _g1.length) {
			var assetKey = _g1[_g];
			++_g;
			var assetValue = assets[assetKey];
			var assetValue1 = assets[assetKey];
			var pathRegex = new EReg("^path:","");
			if(pathRegex.match(assetValue1)) {
				assetsToLoad.push({ id : assetKey, filePath : pathRegex.matchedRight()});
			}
		}
		this.fileLoader.enqueueAssets(assetsToLoad);
	}
	,__class__: octane_preloader_service_bundle_BundleExternalAssetLoadingService
};
var octane_preloader_service_device_IDeviceSizeService = $hx_exports["octane"]["preloader"]["service"]["device"]["IDeviceSizeService"] = function() { };
$hxClasses["octane.preloader.service.device.IDeviceSizeService"] = octane_preloader_service_device_IDeviceSizeService;
octane_preloader_service_device_IDeviceSizeService.__name__ = "octane.preloader.service.device.IDeviceSizeService";
octane_preloader_service_device_IDeviceSizeService.__isInterface__ = true;
octane_preloader_service_device_IDeviceSizeService.prototype = {
	__class__: octane_preloader_service_device_IDeviceSizeService
	,__properties__: {get_aspectRatio:"get_aspectRatio",get_scaledResolution:"get_scaledResolution",get_pixelRatio:"get_pixelRatio"}
};
var octane_preloader_service_device_DeviceSizeService = function() { };
$hxClasses["octane.preloader.service.device.DeviceSizeService"] = octane_preloader_service_device_DeviceSizeService;
octane_preloader_service_device_DeviceSizeService.__name__ = "octane.preloader.service.device.DeviceSizeService";
octane_preloader_service_device_DeviceSizeService.__interfaces__ = [octane_preloader_service_device_IDeviceSizeService];
octane_preloader_service_device_DeviceSizeService.prototype = {
	get_pixelRatio: function() {
		return window.devicePixelRatio;
	}
	,get_scaledResolution: function() {
		var x = this.get_pixelRatio() * window.screen.width;
		var y = this.get_pixelRatio() * window.screen.height;
		return octane_core_types_geom__$Point_Point_$Impl_$._new(x,y);
	}
	,get_aspectRatio: function() {
		return window.screen.width / window.screen.height;
	}
	,__class__: octane_preloader_service_device_DeviceSizeService
	,__properties__: {get_aspectRatio:"get_aspectRatio",get_scaledResolution:"get_scaledResolution",get_pixelRatio:"get_pixelRatio"}
};
var octane_preloader_service_device_ISoundCapabilityService = $hx_exports["octane"]["preloader"]["service"]["device"]["ISoundCapabilityService"] = function() { };
$hxClasses["octane.preloader.service.device.ISoundCapabilityService"] = octane_preloader_service_device_ISoundCapabilityService;
octane_preloader_service_device_ISoundCapabilityService.__name__ = "octane.preloader.service.device.ISoundCapabilityService";
octane_preloader_service_device_ISoundCapabilityService.__isInterface__ = true;
octane_preloader_service_device_ISoundCapabilityService.prototype = {
	__class__: octane_preloader_service_device_ISoundCapabilityService
	,__properties__: {get_supportsSoundPlayback:"get_supportsSoundPlayback"}
};
var octane_preloader_service_device_IWebGLReportService = $hx_exports["octane"]["preloader"]["service"]["device"]["IWebGLReportService"] = function() { };
$hxClasses["octane.preloader.service.device.IWebGLReportService"] = octane_preloader_service_device_IWebGLReportService;
octane_preloader_service_device_IWebGLReportService.__name__ = "octane.preloader.service.device.IWebGLReportService";
octane_preloader_service_device_IWebGLReportService.__isInterface__ = true;
octane_preloader_service_device_IWebGLReportService.prototype = {
	__class__: octane_preloader_service_device_IWebGLReportService
};
var octane_preloader_service_device_ModernizrService = function() {
};
$hxClasses["octane.preloader.service.device.ModernizrService"] = octane_preloader_service_device_ModernizrService;
octane_preloader_service_device_ModernizrService.__name__ = "octane.preloader.service.device.ModernizrService";
octane_preloader_service_device_ModernizrService.prototype = {
	get_webAudioSupport: function() {
		return Modernizr.webaudio;
	}
	,get_webPSupport: function() {
		var webPResults = Modernizr.webp;
		if(webPResults != null && webPResults.lossless) {
			return webPResults.alpha;
		} else {
			return false;
		}
	}
	,get_audioSupport: function() {
		if(this.deviceInfo.get_hasPoorOggSupport()) {
			return ["mp3"];
		}
		var audioResults = Modernizr.audio;
		if(audioResults == null) {
			return ["mp3"];
		}
		var list = ["mp3"];
		if(audioResults.ogg != "") {
			list.push("ogg");
		}
		if(audioResults.m4a != "") {
			list.push("aac");
		}
		return list;
	}
	,__class__: octane_preloader_service_device_ModernizrService
	,__properties__: {get_audioSupport:"get_audioSupport",get_webAudioSupport:"get_webAudioSupport",get_webPSupport:"get_webPSupport"}
};
var octane_preloader_service_device_SoundCapabilityService = function() { };
$hxClasses["octane.preloader.service.device.SoundCapabilityService"] = octane_preloader_service_device_SoundCapabilityService;
octane_preloader_service_device_SoundCapabilityService.__name__ = "octane.preloader.service.device.SoundCapabilityService";
octane_preloader_service_device_SoundCapabilityService.__interfaces__ = [octane_preloader_service_device_ISoundCapabilityService];
octane_preloader_service_device_SoundCapabilityService.prototype = {
	get_supportsSoundPlayback: function() {
		return this.modernizrService.get_webAudioSupport();
	}
	,__class__: octane_preloader_service_device_SoundCapabilityService
	,__properties__: {get_supportsSoundPlayback:"get_supportsSoundPlayback"}
};
var octane_preloader_service_device_WebGLReportService = function() {
};
$hxClasses["octane.preloader.service.device.WebGLReportService"] = octane_preloader_service_device_WebGLReportService;
octane_preloader_service_device_WebGLReportService.__name__ = "octane.preloader.service.device.WebGLReportService";
octane_preloader_service_device_WebGLReportService.__interfaces__ = [octane_preloader_service_device_IWebGLReportService];
octane_preloader_service_device_WebGLReportService.prototype = {
	getWebGlReport: function() {
		var canvas = window.document.createElement("canvas");
		window.document.body.appendChild(canvas);
		var gl = canvas.getContext("webgl");
		if(gl == null) {
			gl = canvas.getContext("experimental-webgl");
		}
		canvas.remove();
		if(gl == null) {
			console.error(octane_core_debug_Logger.indent.join("") + " " + "Unable to get WebGL context");
			return { };
		}
		gl.getExtension("WEBGL_debug_renderer_info");
		var vendor;
		var renderer;
		try {
			vendor = gl.getParameter(37445);
			renderer = gl.getParameter(37446);
			if(vendor == null) {
				vendor = "Unknown";
			}
			if(renderer == null) {
				renderer = "Unknown";
			}
		} catch( e ) {
			var e1 = ((e) instanceof js__$Boot_HaxeError) ? e.val : e;
			vendor = "Unknown";
			renderer = vendor;
		}
		return { unmaskedVendor : vendor, unmaskedRenderer : renderer};
	}
	,readWebGLParameters: function(gl) {
		gl.getExtension("WEBGL_debug_renderer_info");
		var vendor;
		var renderer;
		try {
			vendor = gl.getParameter(37445);
			renderer = gl.getParameter(37446);
			if(vendor == null) {
				vendor = "Unknown";
			}
			if(renderer == null) {
				renderer = "Unknown";
			}
		} catch( e ) {
			var e1 = ((e) instanceof js__$Boot_HaxeError) ? e.val : e;
			vendor = "Unknown";
			renderer = vendor;
		}
		return { unmaskedVendor : vendor, unmaskedRenderer : renderer};
	}
	,__class__: octane_preloader_service_device_WebGLReportService
};
var octane_preloader_service_formfactor_IFormFactorDetectionService = $hx_exports["octane"]["preloader"]["service"]["formfactor"]["IFormFactorDetectionService"] = function() { };
$hxClasses["octane.preloader.service.formfactor.IFormFactorDetectionService"] = octane_preloader_service_formfactor_IFormFactorDetectionService;
octane_preloader_service_formfactor_IFormFactorDetectionService.__name__ = "octane.preloader.service.formfactor.IFormFactorDetectionService";
octane_preloader_service_formfactor_IFormFactorDetectionService.__isInterface__ = true;
octane_preloader_service_formfactor_IFormFactorDetectionService.prototype = {
	__class__: octane_preloader_service_formfactor_IFormFactorDetectionService
};
var octane_preloader_service_formfactor_FormFactorDetectionService = function() {
};
$hxClasses["octane.preloader.service.formfactor.FormFactorDetectionService"] = octane_preloader_service_formfactor_FormFactorDetectionService;
octane_preloader_service_formfactor_FormFactorDetectionService.__name__ = "octane.preloader.service.formfactor.FormFactorDetectionService";
octane_preloader_service_formfactor_FormFactorDetectionService.__interfaces__ = [octane_preloader_service_formfactor_IFormFactorDetectionService];
octane_preloader_service_formfactor_FormFactorDetectionService.prototype = {
	getCurrentFormFactorType: function() {
		if(this.platformDetectionService.isDesktop()) {
			return "desktop";
		}
		return octane_preloader_service_formfactor_FormFactorDetectionService.DEFAULT_FORM_FACTOR;
	}
	,debugFormFactorType: function() {
		var urlParameter = this.preloaderToggleModel.formFactor;
		if(urlParameter == null || urlParameter.length == 0) {
			console.warn(octane_core_debug_Logger.indent.join("") + " " + "Form factor has been defaulted to " + octane_preloader_service_formfactor_FormFactorDetectionService.DEFAULT_FORM_FACTOR);
			return octane_preloader_service_formfactor_FormFactorDetectionService.DEFAULT_FORM_FACTOR;
		}
		urlParameter = urlParameter.toLowerCase();
		if(Lambda.has(["desktop","mobile"],urlParameter)) {
			console.info(octane_core_debug_Logger.indent.join("") + " " + "Form factor has been launched as " + urlParameter);
			return urlParameter;
		}
		console.warn(octane_core_debug_Logger.indent.join("") + " " + "Unknown Form factor specified. Form Factor has been defaulted to " + octane_preloader_service_formfactor_FormFactorDetectionService.DEFAULT_FORM_FACTOR);
		return octane_preloader_service_formfactor_FormFactorDetectionService.DEFAULT_FORM_FACTOR;
	}
	,__class__: octane_preloader_service_formfactor_FormFactorDetectionService
};
var octane_preloader_service_packaged_IPackagedGameDetectionService = $hx_exports["octane"]["preloader"]["service"]["packaged"]["IPackagedGameDetectionService"] = function() { };
$hxClasses["octane.preloader.service.packaged.IPackagedGameDetectionService"] = octane_preloader_service_packaged_IPackagedGameDetectionService;
octane_preloader_service_packaged_IPackagedGameDetectionService.__name__ = "octane.preloader.service.packaged.IPackagedGameDetectionService";
octane_preloader_service_packaged_IPackagedGameDetectionService.__isInterface__ = true;
octane_preloader_service_packaged_IPackagedGameDetectionService.prototype = {
	__class__: octane_preloader_service_packaged_IPackagedGameDetectionService
};
var octane_preloader_service_packaged_PackagedGameDetectionService = function() {
};
$hxClasses["octane.preloader.service.packaged.PackagedGameDetectionService"] = octane_preloader_service_packaged_PackagedGameDetectionService;
octane_preloader_service_packaged_PackagedGameDetectionService.__name__ = "octane.preloader.service.packaged.PackagedGameDetectionService";
octane_preloader_service_packaged_PackagedGameDetectionService.__interfaces__ = [octane_preloader_service_packaged_IPackagedGameDetectionService];
octane_preloader_service_packaged_PackagedGameDetectionService.prototype = {
	postConstruct: function() {
		this.packagedGame = this.preloaderToggleModel.packagedGame == null ? false : this.preloaderToggleModel.packagedGame;
		if(this.packagedGame) {
			console.info(octane_core_debug_Logger.indent.join("") + " " + "Running as a packaged game");
		}
	}
	,isPackaged: function() {
		return this.packagedGame;
	}
	,__class__: octane_preloader_service_packaged_PackagedGameDetectionService
};
var octane_preloader_service_performance_IPerformanceTimingService = $hx_exports["octane"]["preloader"]["service"]["performance"]["IPerformanceTimingService"] = function() { };
$hxClasses["octane.preloader.service.performance.IPerformanceTimingService"] = octane_preloader_service_performance_IPerformanceTimingService;
octane_preloader_service_performance_IPerformanceTimingService.__name__ = "octane.preloader.service.performance.IPerformanceTimingService";
octane_preloader_service_performance_IPerformanceTimingService.__isInterface__ = true;
octane_preloader_service_performance_IPerformanceTimingService.prototype = {
	__class__: octane_preloader_service_performance_IPerformanceTimingService
};
var octane_preloader_service_performance_PerformanceTimingService = function() {
};
$hxClasses["octane.preloader.service.performance.PerformanceTimingService"] = octane_preloader_service_performance_PerformanceTimingService;
octane_preloader_service_performance_PerformanceTimingService.__name__ = "octane.preloader.service.performance.PerformanceTimingService";
octane_preloader_service_performance_PerformanceTimingService.__interfaces__ = [octane_preloader_service_performance_IPerformanceTimingService];
octane_preloader_service_performance_PerformanceTimingService.prototype = {
	markStart: function(name) {
		octane_core_debug_Performance.markStart(name);
	}
	,markEnd: function(name) {
		octane_core_debug_Performance.markEnd(name);
	}
	,getTimeSincePageStartedLoading: function() {
		return Math.round(octane_core_debug_Performance.getTimeSincePageStartedLoading());
	}
	,whenDomContentLoaded: function() {
		return octane_core_debug_Performance.whenDomContentLoaded();
	}
	,getAllMeasures: function() {
		return octane_core_debug_Performance.getAllMeasures().map(function(measure) {
			return { name : measure.name, startTime : measure.startTime, duration : measure.duration};
		});
	}
	,getMeasureByName: function(name) {
		return this.getAllMeasures().filter(function(measure) {
			return measure.name == name;
		})[0];
	}
	,getResourceTimings: function() {
		return octane_core_debug_Performance.getAllResourceTimings().map(function(measure) {
			return { name : measure.name, startTime : measure.startTime, duration : measure.duration, transferSize : measure.transferSize};
		});
	}
	,__class__: octane_preloader_service_performance_PerformanceTimingService
};
var octane_preloader_service_platform_IPlatformDetectionService = $hx_exports["octane"]["preloader"]["service"]["platform"]["IPlatformDetectionService"] = function() { };
$hxClasses["octane.preloader.service.platform.IPlatformDetectionService"] = octane_preloader_service_platform_IPlatformDetectionService;
octane_preloader_service_platform_IPlatformDetectionService.__name__ = "octane.preloader.service.platform.IPlatformDetectionService";
octane_preloader_service_platform_IPlatformDetectionService.__isInterface__ = true;
octane_preloader_service_platform_IPlatformDetectionService.prototype = {
	__class__: octane_preloader_service_platform_IPlatformDetectionService
};
var octane_preloader_service_platform_PlatformDetectionService = function() {
	this.mobileUserAgent = new EReg("Mobi","");
	this.desktopUserAgents = [new EReg("Windows\\s+NT",""),new EReg("Macintosh",""),new EReg("CrOS",""),new EReg("Linux\\s+x86_64","")];
};
$hxClasses["octane.preloader.service.platform.PlatformDetectionService"] = octane_preloader_service_platform_PlatformDetectionService;
octane_preloader_service_platform_PlatformDetectionService.__name__ = "octane.preloader.service.platform.PlatformDetectionService";
octane_preloader_service_platform_PlatformDetectionService.__interfaces__ = [octane_preloader_service_platform_IPlatformDetectionService];
octane_preloader_service_platform_PlatformDetectionService.prototype = {
	isDesktop: function() {
		if(octane_core_types_string_StringExtensions.isNullOrEmpty(this.navigator.userAgent)) {
			return false;
		}
		if(this.mobileUserAgent.match(this.navigator.userAgent)) {
			return false;
		}
		var _g = 0;
		var _g1 = this.desktopUserAgents;
		while(_g < _g1.length) {
			var desktopUserAgent = _g1[_g];
			++_g;
			if(desktopUserAgent.match(this.navigator.userAgent)) {
				return true;
			}
		}
		return false;
	}
	,__class__: octane_preloader_service_platform_PlatformDetectionService
};
var octane_preloader_service_preloader_PreloaderUpdateService = function() {
	this.lastProgress = 0;
};
$hxClasses["octane.preloader.service.preloader.PreloaderUpdateService"] = octane_preloader_service_preloader_PreloaderUpdateService;
octane_preloader_service_preloader_PreloaderUpdateService.__name__ = "octane.preloader.service.preloader.PreloaderUpdateService";
octane_preloader_service_preloader_PreloaderUpdateService.__interfaces__ = [octane_preloader_service_IHostPreloaderUpdateService];
octane_preloader_service_preloader_PreloaderUpdateService.prototype = {
	updateProgressBar: function(percentage) {
		if(percentage > 100) {
			percentage = 100;
		}
		if(percentage > this.lastProgress) {
			this.lastProgress = percentage;
			var barElement = this.document.getElementById("octanePreloaderProgress");
			var textElement = this.document.getElementById("octanePreloaderPercent");
			var barElements = this.document.getElementsByClassName("octanePreloaderProgressClass");
			if(barElement != null) {
				barElement.style.width = "" + percentage + "%";
			}
			if(textElement != null) {
				textElement.innerHTML = "" + percentage + "%";
			}
			if(barElements != null) {
				var _g = 0;
				var _g1 = barElements.length;
				while(_g < _g1) {
					var element = _g++;
					barElements[element].style.width = "" + percentage + "%";
				}
			}
		}
	}
	,__class__: octane_preloader_service_preloader_PreloaderUpdateService
};
var octane_preloader_service_timer_ILoadingProgressTimerService = $hx_exports["octane"]["preloader"]["service"]["timer"]["ILoadingProgressTimerService"] = function() { };
$hxClasses["octane.preloader.service.timer.ILoadingProgressTimerService"] = octane_preloader_service_timer_ILoadingProgressTimerService;
octane_preloader_service_timer_ILoadingProgressTimerService.__name__ = "octane.preloader.service.timer.ILoadingProgressTimerService";
octane_preloader_service_timer_ILoadingProgressTimerService.__isInterface__ = true;
octane_preloader_service_timer_ILoadingProgressTimerService.prototype = {
	__class__: octane_preloader_service_timer_ILoadingProgressTimerService
	,__properties__: {get_onComplete:"get_onComplete",get_isRunning:"get_isRunning"}
};
var octane_preloader_service_timer_LoadingProgressTimerService = function() {
	this.progressTimer = new octane_core_timer_Timer("WebAssetLoadingServiceTimer");
};
$hxClasses["octane.preloader.service.timer.LoadingProgressTimerService"] = octane_preloader_service_timer_LoadingProgressTimerService;
octane_preloader_service_timer_LoadingProgressTimerService.__name__ = "octane.preloader.service.timer.LoadingProgressTimerService";
octane_preloader_service_timer_LoadingProgressTimerService.__interfaces__ = [octane_preloader_service_timer_ILoadingProgressTimerService];
octane_preloader_service_timer_LoadingProgressTimerService.prototype = {
	start: function(delayMS,repeat) {
		return this.progressTimer.start(delayMS,repeat);
	}
	,dispose: function() {
		this.progressTimer.stop(true);
	}
	,get_isRunning: function() {
		return this.progressTimer.isRunning;
	}
	,get_onComplete: function() {
		return this.progressTimer.onComplete;
	}
	,__class__: octane_preloader_service_timer_LoadingProgressTimerService
	,__properties__: {get_onComplete:"get_onComplete",get_isRunning:"get_isRunning"}
};
var octane_preloader_shell_PreloaderShell = function(parentInjector) {
	octane_core_mvc_module_Module.call(this,parentInjector);
};
$hxClasses["octane.preloader.shell.PreloaderShell"] = octane_preloader_shell_PreloaderShell;
octane_preloader_shell_PreloaderShell.__name__ = "octane.preloader.shell.PreloaderShell";
octane_preloader_shell_PreloaderShell.__super__ = octane_core_mvc_module_Module;
octane_preloader_shell_PreloaderShell.prototype = $extend(octane_core_mvc_module_Module.prototype,{
	onStartup: function() {
		if(this.hasPoorSupportForDocumentReady()) {
			this.waitForDocumentReadyState();
		} else {
			this.commandMap.execute(octane_preloader_shell_controller_StartupCommand);
		}
	}
	,hasPoorSupportForDocumentReady: function() {
		var userAgentString = window.navigator.userAgent;
		return new EReg("(MQQ|MSIE|Trident.*rv:11|OppoBrowser)","").match(userAgentString);
	}
	,waitForDocumentReadyState: function() {
		var _gthis = this;
		window.document.onreadystatechange = function() {
			if(window.document.readyState == "interactive") {
				_gthis.commandMap.execute(octane_preloader_shell_controller_StartupCommand);
				window.document.onreadystatechange = null;
			}
			return;
		};
	}
	,__class__: octane_preloader_shell_PreloaderShell
});
var octane_preloader_shell_controller_OnHostAPIAvailableCommand = function() {
	octane_core_mvc_controller_Command.call(this);
};
$hxClasses["octane.preloader.shell.controller.OnHostAPIAvailableCommand"] = octane_preloader_shell_controller_OnHostAPIAvailableCommand;
octane_preloader_shell_controller_OnHostAPIAvailableCommand.__name__ = "octane.preloader.shell.controller.OnHostAPIAvailableCommand";
octane_preloader_shell_controller_OnHostAPIAvailableCommand.__super__ = octane_core_mvc_controller_Command;
octane_preloader_shell_controller_OnHostAPIAvailableCommand.prototype = $extend(octane_core_mvc_controller_Command.prototype,{
	execute: function() {
		var hostMapAPICommand;
		switch(this.hostType.get_current()) {
		case "Titan":
			hostMapAPICommand = octane_preloader_shell_controller_mapping_titan_MapTitanAPICommand;
			break;
		case "V":
			hostMapAPICommand = octane_preloader_shell_controller_mapping_v_MapVAPICommand;
			break;
		default:
			throw new js__$Boot_HaxeError("Unsupported host: " + this.hostType.get_current());
		}
		this.commandMap.execute(hostMapAPICommand);
		this.commandMap.execute(octane_preloader_shell_controller_PopulatePreloaderManifestModelCommand);
		this.commandMap.execute(octane_preloader_shell_controller_StartPreloadingFilesCommand);
		this.commandMap.execute(octane_preloader_shell_controller_StartPreloadingScriptsCommand);
		this.commandMap.execute(octane_preloader_shell_scripts_WaitForVendorAvailableCommand);
	}
	,__class__: octane_preloader_shell_controller_OnHostAPIAvailableCommand
});
var octane_preloader_shell_controller_PopulateAssetProfilesCommand = function() {
	octane_core_mvc_controller_Command.call(this);
};
$hxClasses["octane.preloader.shell.controller.PopulateAssetProfilesCommand"] = octane_preloader_shell_controller_PopulateAssetProfilesCommand;
octane_preloader_shell_controller_PopulateAssetProfilesCommand.__name__ = "octane.preloader.shell.controller.PopulateAssetProfilesCommand";
octane_preloader_shell_controller_PopulateAssetProfilesCommand.__super__ = octane_core_mvc_controller_Command;
octane_preloader_shell_controller_PopulateAssetProfilesCommand.prototype = $extend(octane_core_mvc_controller_Command.prototype,{
	execute: function() {
		var assetProfiles = this.preloadedFiles.common["assetProfiles"];
		this.assetProfilesModel.populate(assetProfiles);
	}
	,__class__: octane_preloader_shell_controller_PopulateAssetProfilesCommand
});
var octane_preloader_shell_controller_PopulatePreloaderManifestModelCommand = function() {
	octane_core_mvc_controller_Command.call(this);
};
$hxClasses["octane.preloader.shell.controller.PopulatePreloaderManifestModelCommand"] = octane_preloader_shell_controller_PopulatePreloaderManifestModelCommand;
octane_preloader_shell_controller_PopulatePreloaderManifestModelCommand.__name__ = "octane.preloader.shell.controller.PopulatePreloaderManifestModelCommand";
octane_preloader_shell_controller_PopulatePreloaderManifestModelCommand.__super__ = octane_core_mvc_controller_Command;
octane_preloader_shell_controller_PopulatePreloaderManifestModelCommand.prototype = $extend(octane_core_mvc_controller_Command.prototype,{
	execute: function() {
		this.preloaderManifest.populate();
	}
	,__class__: octane_preloader_shell_controller_PopulatePreloaderManifestModelCommand
});
var octane_preloader_shell_controller_StartPreloadingBundlesCommand = function() {
	octane_core_mvc_controller_Command.call(this);
};
$hxClasses["octane.preloader.shell.controller.StartPreloadingBundlesCommand"] = octane_preloader_shell_controller_StartPreloadingBundlesCommand;
octane_preloader_shell_controller_StartPreloadingBundlesCommand.__name__ = "octane.preloader.shell.controller.StartPreloadingBundlesCommand";
octane_preloader_shell_controller_StartPreloadingBundlesCommand.__super__ = octane_core_mvc_controller_Command;
octane_preloader_shell_controller_StartPreloadingBundlesCommand.prototype = $extend(octane_core_mvc_controller_Command.prototype,{
	execute: function() {
		this.expandedBundles = [];
		this.bundlePermutation = this.assetPathBuilder.get_bundlePermutationPath();
		var bundles = this.preloadedFilesModel.common["PreloadManifests"];
		var _g = 0;
		while(_g < bundles.length) {
			var bundle = bundles[_g];
			++_g;
			bundle.filePath = this.assetPathBuilder.getAssetPath(bundle.filePath);
			if(this.shouldBuildBundleParts(bundle)) {
				this.multipartBundleModel.registerBundle(bundle.id,bundle.parts[this.bundlePermutation]);
				this.buildBundleParts(bundle);
			} else {
				this.expandedBundles.push(bundle);
			}
		}
		this.assetLoader.enqueuePreloadBundles(this.expandedBundles);
	}
	,shouldBuildBundleParts: function(bundle) {
		if(bundle.parts != null) {
			return Object.prototype.hasOwnProperty.call(bundle.parts,this.bundlePermutation);
		} else {
			return false;
		}
	}
	,buildBundleParts: function(bundle) {
		var partsLength = bundle.parts[this.bundlePermutation];
		var _g = 0;
		var _g1 = partsLength;
		while(_g < _g1) {
			var index = _g++;
			var bundleForPart = Reflect.copy(bundle);
			bundleForPart.id += "|" + index;
			var _this_r = new RegExp("\\.json$","".split("u").join(""));
			bundleForPart.filePath = bundleForPart.filePath.replace(_this_r,"_part" + index + ".json");
			this.expandedBundles.push(bundleForPart);
		}
	}
	,__class__: octane_preloader_shell_controller_StartPreloadingBundlesCommand
});
var octane_preloader_shell_controller_StartPreloadingFilesCommand = function() {
	octane_core_mvc_controller_Command.call(this);
};
$hxClasses["octane.preloader.shell.controller.StartPreloadingFilesCommand"] = octane_preloader_shell_controller_StartPreloadingFilesCommand;
octane_preloader_shell_controller_StartPreloadingFilesCommand.__name__ = "octane.preloader.shell.controller.StartPreloadingFilesCommand";
octane_preloader_shell_controller_StartPreloadingFilesCommand.__super__ = octane_core_mvc_controller_Command;
octane_preloader_shell_controller_StartPreloadingFilesCommand.prototype = $extend(octane_core_mvc_controller_Command.prototype,{
	execute: function() {
		if(this.toggles.maximumParallelLoads != null) {
			this.fileLoader.setMaximumParallelLoads(this.toggles.maximumParallelLoads);
		}
		var assets = this.manifest.files.map($bind(this,this.replaceLanguageCode));
		this.performanceTiming.markStart("CommonFileLoading");
		this.fileLoader.enqueueAssets(assets);
	}
	,replaceLanguageCode: function(asset) {
		var filePathWithLanguage = StringTools.replace(asset.filePath,"{language}",this.languagesModel.languageCode);
		return { id : asset.id, filePath : filePathWithLanguage};
	}
	,__class__: octane_preloader_shell_controller_StartPreloadingFilesCommand
});
var octane_preloader_shell_controller_StartPreloadingScriptsCommand = function() {
	octane_core_mvc_controller_Command.call(this);
};
$hxClasses["octane.preloader.shell.controller.StartPreloadingScriptsCommand"] = octane_preloader_shell_controller_StartPreloadingScriptsCommand;
octane_preloader_shell_controller_StartPreloadingScriptsCommand.__name__ = "octane.preloader.shell.controller.StartPreloadingScriptsCommand";
octane_preloader_shell_controller_StartPreloadingScriptsCommand.__super__ = octane_core_mvc_controller_Command;
octane_preloader_shell_controller_StartPreloadingScriptsCommand.prototype = $extend(octane_core_mvc_controller_Command.prototype,{
	execute: function() {
		var assets = octane_core_types_array_ArrayExtensions.removeNullItems(this.manifest.scripts.map($bind(this,this.replaceFormFactorCode)));
		this.fileLoader.enqueueAssets(assets);
	}
	,replaceFormFactorCode: function(asset) {
		var formFactor = this.formFactorDetectionService.getCurrentFormFactorType();
		if(this.isGameScript(asset) && this.isNotCurrentFormFactor(asset,formFactor)) {
			return null;
		}
		var filePathWithFormFactor = StringTools.replace(asset.filePath,"{formFactor}",formFactor);
		return { id : "" + asset.id, filePath : filePathWithFormFactor};
	}
	,isNotCurrentFormFactor: function(asset,currentFormFactor) {
		if(new EReg("\\{formFactor}","").match(asset.filePath)) {
			return asset.id.indexOf(currentFormFactor) == -1;
		} else {
			return false;
		}
	}
	,isGameScript: function(asset) {
		return new EReg("Game","").match(asset.id);
	}
	,__class__: octane_preloader_shell_controller_StartPreloadingScriptsCommand
});
var octane_preloader_shell_controller_StartupCommand = function() {
	octane_core_mvc_controller_Command.call(this);
};
$hxClasses["octane.preloader.shell.controller.StartupCommand"] = octane_preloader_shell_controller_StartupCommand;
octane_preloader_shell_controller_StartupCommand.__name__ = "octane.preloader.shell.controller.StartupCommand";
octane_preloader_shell_controller_StartupCommand.__super__ = octane_core_mvc_controller_Command;
octane_preloader_shell_controller_StartupCommand.prototype = $extend(octane_core_mvc_controller_Command.prototype,{
	execute: function() {
		this.commandMap.execute(octane_preloader_shell_controller_mapping_MapBrowserInterfacesCommand);
		this.injector.mapType("octane.preloader.state.StartupStateMachine",null,null)._toSingleton(octane_preloader_state_StartupStateMachine);
		this.commandMap.execute(octane_preloader_shell_controller_mapping_MapServicesCommand);
		this.commandMap.execute(octane_preloader_shell_controller_mapping_MapModelsCommand);
		this.commandMap.execute(octane_preloader_shell_controller_WaitForHostInitCommand);
		this.commandMap.execute(octane_preloader_shell_controller_mapping_DetermineHostTypeCommand);
	}
	,__class__: octane_preloader_shell_controller_StartupCommand
});
var octane_preloader_shell_controller_StoreCoalescedMultipartBundleCommand = function() {
	octane_core_mvc_controller_Command.call(this);
};
$hxClasses["octane.preloader.shell.controller.StoreCoalescedMultipartBundleCommand"] = octane_preloader_shell_controller_StoreCoalescedMultipartBundleCommand;
octane_preloader_shell_controller_StoreCoalescedMultipartBundleCommand.__name__ = "octane.preloader.shell.controller.StoreCoalescedMultipartBundleCommand";
octane_preloader_shell_controller_StoreCoalescedMultipartBundleCommand.__super__ = octane_core_mvc_controller_Command;
octane_preloader_shell_controller_StoreCoalescedMultipartBundleCommand.prototype = $extend(octane_core_mvc_controller_Command.prototype,{
	execute: function() {
		var index = 0;
		var name = "" + this.bundleName + "|" + index;
		while(this.files.has(name)) {
			this.files.pop(name);
			++index;
			name = "" + this.bundleName + "|" + index;
		}
		this.commandMap.executeWithArgs(octane_preloader_shell_controller_StorePreloadedFilesCommand,[this.bundleName,this.bundle]);
	}
	,__class__: octane_preloader_shell_controller_StoreCoalescedMultipartBundleCommand
});
var octane_preloader_shell_controller_StorePreloadedFilesCommand = function() {
	octane_core_mvc_controller_Command.call(this);
};
$hxClasses["octane.preloader.shell.controller.StorePreloadedFilesCommand"] = octane_preloader_shell_controller_StorePreloadedFilesCommand;
octane_preloader_shell_controller_StorePreloadedFilesCommand.__name__ = "octane.preloader.shell.controller.StorePreloadedFilesCommand";
octane_preloader_shell_controller_StorePreloadedFilesCommand.__super__ = octane_core_mvc_controller_Command;
octane_preloader_shell_controller_StorePreloadedFilesCommand.prototype = $extend(octane_core_mvc_controller_Command.prototype,{
	execute: function() {
		if(this.assetName.toLowerCase().indexOf("common") != -1) {
			this.performanceTiming.markEnd("CommonFileLoading");
			var m = this.asset.value;
			var data = octane_core_types_json__$JSONMap_JSONMap_$Impl_$._new();
			var _g = 0;
			var _g1 = Reflect.fields(m);
			while(_g < _g1.length) {
				var key = _g1[_g];
				++_g;
				data[key] = Reflect.field(m,key);
			}
			this.preloadedFiles.common = data;
			this.commandMap.execute(octane_preloader_shell_controller_PopulateAssetProfilesCommand);
			this.commandMap.execute(octane_preloader_shell_controller_StartPreloadingBundlesCommand);
		} else if(StringTools.startsWith(this.assetName,"Preload")) {
			this.handlePreloadManifest();
		} else {
			this.preloadedFiles.store(this.assetName,this.asset);
		}
	}
	,handlePreloadManifest: function() {
		if(Object.prototype.hasOwnProperty.call(this.asset.value,"part")) {
			this.multipartBundleModel.addBundlePart(this.assetName,this.asset.value.part,this.asset.value.index);
		} else if(Object.prototype.hasOwnProperty.call(this.asset.value,"payload")) {
			var manifestPayload = this.asset.value.payload;
			var manifestContainedBundles = [];
			var _g = 0;
			while(_g < manifestPayload.length) {
				var containedBundle = manifestPayload[_g];
				++_g;
				manifestContainedBundles.push(containedBundle.name);
				this.preloadedFiles.store(containedBundle.name,new octane_core_mvc_controller_DynamicWrapper(containedBundle.bundle));
				this.externalAssetLoader.loadExternalAssetsForBundle(containedBundle.bundle.assets);
			}
		} else {
			throw new js__$Boot_HaxeError("Preload manifest " + this.assetName + " contains invalid data.");
		}
	}
	,__class__: octane_preloader_shell_controller_StorePreloadedFilesCommand
});
var octane_preloader_shell_controller_WaitForHostInitCommand = function() {
	octane_core_mvc_controller_Command.call(this);
};
$hxClasses["octane.preloader.shell.controller.WaitForHostInitCommand"] = octane_preloader_shell_controller_WaitForHostInitCommand;
octane_preloader_shell_controller_WaitForHostInitCommand.__name__ = "octane.preloader.shell.controller.WaitForHostInitCommand";
octane_preloader_shell_controller_WaitForHostInitCommand.__super__ = octane_core_mvc_controller_Command;
octane_preloader_shell_controller_WaitForHostInitCommand.prototype = $extend(octane_core_mvc_controller_Command.prototype,{
	execute: function() {
		this.commandMap.map(this.startupStateMachine.getState(octane_preloader_state_StartupStates.APIAvailable).onEntered,octane_preloader_shell_controller_OnHostAPIAvailableCommand,true);
		this.commandMap.map(this.startupStateMachine.getState(octane_preloader_state_StartupStates.APIAvailable).onEntered,octane_preloader_shell_controller_mapping_MapCommandsCommand,true);
		this.commandMap.execute(octane_preloader_v_controller_WaitForVCommand);
		this.commandMap.execute(octane_preloader_titan_controller_WaitForTitanCommand);
	}
	,__class__: octane_preloader_shell_controller_WaitForHostInitCommand
});
var octane_preloader_shell_controller_mapping_DetermineHostTypeCommand = function() {
	octane_core_mvc_controller_Command.call(this);
};
$hxClasses["octane.preloader.shell.controller.mapping.DetermineHostTypeCommand"] = octane_preloader_shell_controller_mapping_DetermineHostTypeCommand;
octane_preloader_shell_controller_mapping_DetermineHostTypeCommand.__name__ = "octane.preloader.shell.controller.mapping.DetermineHostTypeCommand";
octane_preloader_shell_controller_mapping_DetermineHostTypeCommand.__super__ = octane_core_mvc_controller_Command;
octane_preloader_shell_controller_mapping_DetermineHostTypeCommand.prototype = $extend(octane_core_mvc_controller_Command.prototype,{
	execute: function() {
		this.hostType.set_current("Unknown");
		if(window.V != null) {
			this.hostType.set_current("V");
		} else if(window.titanStartupInfo != null) {
			this.hostType.set_current("Titan");
		}
		if(this.hostType.get_current() != "Unknown") {
			this.startupStateMachine.doAction(octane_preloader_state_StartupActions.PrepareAPI,{ fileName : "octane/preloader/shell/controller/mapping/DetermineHostTypeCommand.hx", lineNumber : 35, className : "octane.preloader.shell.controller.mapping.DetermineHostTypeCommand", methodName : "execute"});
		} else {
			console.warn(octane_core_debug_Logger.indent.join("") + " " + "Unsupported host type found while starting up");
		}
	}
	,__class__: octane_preloader_shell_controller_mapping_DetermineHostTypeCommand
});
var octane_preloader_shell_controller_mapping_MapBrowserInterfacesCommand = function() {
	octane_core_mvc_controller_Command.call(this);
};
$hxClasses["octane.preloader.shell.controller.mapping.MapBrowserInterfacesCommand"] = octane_preloader_shell_controller_mapping_MapBrowserInterfacesCommand;
octane_preloader_shell_controller_mapping_MapBrowserInterfacesCommand.__name__ = "octane.preloader.shell.controller.mapping.MapBrowserInterfacesCommand";
octane_preloader_shell_controller_mapping_MapBrowserInterfacesCommand.__super__ = octane_core_mvc_controller_Command;
octane_preloader_shell_controller_mapping_MapBrowserInterfacesCommand.prototype = $extend(octane_core_mvc_controller_Command.prototype,{
	execute: function() {
		this.injector.mapType("octane.browser.IDocument",null,null).toValue(window.document);
		this.injector.mapType("octane.browser.INavigator",null,null).toValue(window.navigator);
		this.injector.mapType("octane.browser.IWindow",null,null).toValue(window);
	}
	,__class__: octane_preloader_shell_controller_mapping_MapBrowserInterfacesCommand
});
var octane_preloader_shell_controller_mapping_MapCommandsCommand = function() {
	octane_core_mvc_controller_Command.call(this);
};
$hxClasses["octane.preloader.shell.controller.mapping.MapCommandsCommand"] = octane_preloader_shell_controller_mapping_MapCommandsCommand;
octane_preloader_shell_controller_mapping_MapCommandsCommand.__name__ = "octane.preloader.shell.controller.mapping.MapCommandsCommand";
octane_preloader_shell_controller_mapping_MapCommandsCommand.__super__ = octane_core_mvc_controller_Command;
octane_preloader_shell_controller_mapping_MapCommandsCommand.prototype = $extend(octane_core_mvc_controller_Command.prototype,{
	execute: function() {
		this.commandMap.map(this.fileLoader.onFileLoaded,octane_preloader_shell_controller_StorePreloadedFilesCommand);
		this.commandMap.map(this.fileLoader.onScriptLoaded,octane_preloader_shell_scripts_StorePreloadedScriptsCommand);
		this.commandMap.map(this.multipartBundleModel.onAllBundlePartsLoaded,octane_preloader_shell_controller_StoreCoalescedMultipartBundleCommand);
	}
	,__class__: octane_preloader_shell_controller_mapping_MapCommandsCommand
});
var octane_preloader_shell_controller_mapping_MapModelsCommand = function() {
	octane_core_mvc_controller_Command.call(this);
};
$hxClasses["octane.preloader.shell.controller.mapping.MapModelsCommand"] = octane_preloader_shell_controller_mapping_MapModelsCommand;
octane_preloader_shell_controller_mapping_MapModelsCommand.__name__ = "octane.preloader.shell.controller.mapping.MapModelsCommand";
octane_preloader_shell_controller_mapping_MapModelsCommand.__super__ = octane_core_mvc_controller_Command;
octane_preloader_shell_controller_mapping_MapModelsCommand.prototype = $extend(octane_core_mvc_controller_Command.prototype,{
	execute: function() {
		this.injector.mapType("octane.preloader.model.manifest.IPreloaderManifestModel",null,null)._toSingleton(octane_preloader_model_manifest_PreloaderManifestModel);
		this.injector.mapType("octane.preloader.model.IPreloadedFilesModel",null,null)._toSingleton(octane_preloader_model_PreloadedFilesModel);
		this.injector.mapType("octane.preloader.model.host.IHostTypeModel",null,null)._toSingleton(octane_preloader_model_host_HostTypeModel);
		this.injector.mapType("octane.preloader.model.asset.profile.IAssetProfilesModel",null,null)._toSingleton(octane_preloader_model_asset_profile_AssetProfilesModel);
		this.injector.mapType("octane.preloader.model.IMultipartBundleModel",null,null)._toSingleton(octane_preloader_model_MultipartBundleModel);
		this.injector.mapType("octane.preloader.model.device.ICrossOriginResourceSharingBlacklistModel",null,null)._toSingleton(octane_preloader_model_device_CrossOriginResourceSharingBlacklistModel);
		this.injector.mapType("octane.preloader.model.device.IWebGLBlacklistModel",null,null)._toSingleton(octane_preloader_model_device_WebGLBlacklistModel);
		this.injector.mapType("octane.preloader.model.device.IDeviceInformationModel",null,null)._toSingleton(octane_preloader_model_device_DeviceInformationModel);
		this.injector.mapType("octane.preloader.shell.scripts.PreloadedScriptsModel",null,null).asSingleton();
		this.injector.mapType("octane.preloader.url.model.URLParametersModel",null,null).asSingleton();
		this.injector.mapType("octane.preloader.toggle.PreloaderToggleModel",null,null).asSingleton();
	}
	,__class__: octane_preloader_shell_controller_mapping_MapModelsCommand
});
var octane_preloader_shell_controller_mapping_MapServicesCommand = function() {
	octane_core_mvc_controller_Command.call(this);
};
$hxClasses["octane.preloader.shell.controller.mapping.MapServicesCommand"] = octane_preloader_shell_controller_mapping_MapServicesCommand;
octane_preloader_shell_controller_mapping_MapServicesCommand.__name__ = "octane.preloader.shell.controller.mapping.MapServicesCommand";
octane_preloader_shell_controller_mapping_MapServicesCommand.__super__ = octane_core_mvc_controller_Command;
octane_preloader_shell_controller_mapping_MapServicesCommand.prototype = $extend(octane_core_mvc_controller_Command.prototype,{
	execute: function() {
		this.injector.mapType("octane.preloader.service.performance.IPerformanceTimingService",null,null)._toSingleton(octane_preloader_service_performance_PerformanceTimingService);
		this.injector.mapType("octane.preloader.service.IFileLoadingService",null,null)._toSingleton(octane_preloader_service_FileLoadingService);
		this.injector.mapType("octane.preloader.service.bundle.IBundleExternalAssetLoadingService",null,null)._toSingleton(octane_preloader_service_bundle_BundleExternalAssetLoadingService);
		this.injector.mapType("octane.preloader.service.timer.ILoadingProgressTimerService",null,null)._toSingleton(octane_preloader_service_timer_LoadingProgressTimerService);
		this.injector.mapType("octane.preloader.service.platform.IPlatformDetectionService",null,null)._toSingleton(octane_preloader_service_platform_PlatformDetectionService);
		this.injector.mapType("octane.preloader.service.device.IDeviceSizeService",null,null)._toSingleton(octane_preloader_service_device_DeviceSizeService);
		this.injector.mapType("octane.preloader.service.device.ISoundCapabilityService",null,null)._toSingleton(octane_preloader_service_device_SoundCapabilityService);
		this.injector.mapType("octane.preloader.service.asset.IImageScaleCalculatorService",null,null)._toSingleton(octane_preloader_service_asset_WebImageScaleCalculatorService);
		this.injector.mapType("octane.preloader.service.asset.format.IImageFormatSelectionService",null,null)._toSingleton(octane_preloader_service_asset_format_ImageFormatSelectionService);
		this.injector.mapType("octane.preloader.service.asset.format.IAudioFormatSelectionService",null,null)._toSingleton(octane_preloader_service_asset_format_AudioFormatSelectionService);
		this.injector.mapType("octane.preloader.service.asset.IPerformanceLevelSelectionService",null,null)._toSingleton(octane_preloader_service_asset_PerformanceLevelSelectionService);
		this.injector.mapType("octane.preloader.service.asset.format.IAssetFormatService",null,null)._toSingleton(octane_preloader_service_asset_format_AssetFormatService);
		this.injector.mapType("octane.preloader.service.asset.IAssetPathBuilderService",null,null)._toSingleton(octane_preloader_service_asset_AssetPathBuilderService);
		this.injector.mapType("octane.preloader.service.formfactor.IFormFactorDetectionService",null,null)._toSingleton(octane_preloader_service_formfactor_FormFactorDetectionService);
		this.injector.mapType("octane.preloader.service.packaged.IPackagedGameDetectionService",null,null)._toSingleton(octane_preloader_service_packaged_PackagedGameDetectionService);
		this.injector.mapType("octane.preloader.service.device.ModernizrService",null,null).asSingleton();
		this.injector.mapType("octane.preloader.service.device.IWebGLReportService",null,null)._toSingleton(octane_preloader_service_device_WebGLReportService);
		this.injector.mapType("octane.preloader.service.IHostPreloaderUpdateService",null,null)._toSingleton(octane_preloader_service_preloader_PreloaderUpdateService);
		this.injector.mapType("octane.preloader.service.IPreloaderNotificationService",null,null)._toSingleton(octane_preloader_v_service_VPreloaderNotificationService);
		this.injector.mapType("octane.preloader.service.IPreloaderNotificationService",null,null)._toSingleton(octane_preloader_titan_service_TitanPreloaderNotificationService);
	}
	,__class__: octane_preloader_shell_controller_mapping_MapServicesCommand
});
var octane_preloader_shell_controller_mapping_titan_MapTitanAPICommand = function() {
	octane_core_mvc_controller_Command.call(this);
};
$hxClasses["octane.preloader.shell.controller.mapping.titan.MapTitanAPICommand"] = octane_preloader_shell_controller_mapping_titan_MapTitanAPICommand;
octane_preloader_shell_controller_mapping_titan_MapTitanAPICommand.__name__ = "octane.preloader.shell.controller.mapping.titan.MapTitanAPICommand";
octane_preloader_shell_controller_mapping_titan_MapTitanAPICommand.__super__ = octane_core_mvc_controller_Command;
octane_preloader_shell_controller_mapping_titan_MapTitanAPICommand.prototype = $extend(octane_core_mvc_controller_Command.prototype,{
	execute: function() {
		this.injector.mapType("octane.preloader.model.IAssetLoadingModel",null,null)._toSingleton(octane_preloader_titan_model_TitanAssetLoadingModel);
		this.injector.mapType("octane.preloader.model.ILanguageCodeModel",null,null)._toSingleton(octane_preloader_titan_model_TitanLanguageCodeModel);
	}
	,__class__: octane_preloader_shell_controller_mapping_titan_MapTitanAPICommand
});
var octane_preloader_shell_controller_mapping_v_MapVAPICommand = function() {
	octane_core_mvc_controller_Command.call(this);
};
$hxClasses["octane.preloader.shell.controller.mapping.v.MapVAPICommand"] = octane_preloader_shell_controller_mapping_v_MapVAPICommand;
octane_preloader_shell_controller_mapping_v_MapVAPICommand.__name__ = "octane.preloader.shell.controller.mapping.v.MapVAPICommand";
octane_preloader_shell_controller_mapping_v_MapVAPICommand.__super__ = octane_core_mvc_controller_Command;
octane_preloader_shell_controller_mapping_v_MapVAPICommand.prototype = $extend(octane_core_mvc_controller_Command.prototype,{
	execute: function() {
		this.injector.mapType("octane.preloader.model.IAssetLoadingModel",null,null)._toSingleton(octane_preloader_v_model_VAssetLoadingModel);
		this.injector.mapType("octane.preloader.model.ILanguageCodeModel",null,null)._toSingleton(octane_preloader_v_model_VLanguageCodeModel);
	}
	,__class__: octane_preloader_shell_controller_mapping_v_MapVAPICommand
});
var octane_preloader_shell_scripts_PreloadedScriptsModel = function() {
	this.onScriptLoaded = this._onScriptLoaded = new hx_event_Signal1();
	this.loadedScripts = [];
};
$hxClasses["octane.preloader.shell.scripts.PreloadedScriptsModel"] = octane_preloader_shell_scripts_PreloadedScriptsModel;
octane_preloader_shell_scripts_PreloadedScriptsModel.__name__ = "octane.preloader.shell.scripts.PreloadedScriptsModel";
octane_preloader_shell_scripts_PreloadedScriptsModel.prototype = {
	store: function(name) {
		this.loadedScripts.push(name);
		this._onScriptLoaded.dispatch(name);
	}
	,has: function(name) {
		return Lambda.has(this.loadedScripts,name);
	}
	,__class__: octane_preloader_shell_scripts_PreloadedScriptsModel
};
var octane_preloader_shell_scripts_StorePreloadedScriptsCommand = function() {
	octane_core_mvc_controller_Command.call(this);
};
$hxClasses["octane.preloader.shell.scripts.StorePreloadedScriptsCommand"] = octane_preloader_shell_scripts_StorePreloadedScriptsCommand;
octane_preloader_shell_scripts_StorePreloadedScriptsCommand.__name__ = "octane.preloader.shell.scripts.StorePreloadedScriptsCommand";
octane_preloader_shell_scripts_StorePreloadedScriptsCommand.__super__ = octane_core_mvc_controller_Command;
octane_preloader_shell_scripts_StorePreloadedScriptsCommand.prototype = $extend(octane_core_mvc_controller_Command.prototype,{
	execute: function() {
		this.preloadedScripts.store(this.scriptName);
	}
	,__class__: octane_preloader_shell_scripts_StorePreloadedScriptsCommand
});
var octane_preloader_shell_scripts_WaitForVendorAvailableCommand = function() {
	octane_core_mvc_controller_Command.call(this);
};
$hxClasses["octane.preloader.shell.scripts.WaitForVendorAvailableCommand"] = octane_preloader_shell_scripts_WaitForVendorAvailableCommand;
octane_preloader_shell_scripts_WaitForVendorAvailableCommand.__name__ = "octane.preloader.shell.scripts.WaitForVendorAvailableCommand";
octane_preloader_shell_scripts_WaitForVendorAvailableCommand.__super__ = octane_core_mvc_controller_Command;
octane_preloader_shell_scripts_WaitForVendorAvailableCommand.prototype = $extend(octane_core_mvc_controller_Command.prototype,{
	execute: function() {
		var _gthis = this;
		if(this.preloadedScripts.has("Vendor")) {
			this.startupStateMachine.doAction(octane_preloader_state_StartupActions.Initialize,{ fileName : "octane/preloader/shell/scripts/WaitForVendorAvailableCommand.hx", lineNumber : 19, className : "octane.preloader.shell.scripts.WaitForVendorAvailableCommand", methodName : "execute"});
		} else {
			this.slot = this.preloadedScripts.onScriptLoaded.add(function(name) {
				if(name == "Vendor") {
					_gthis.startupStateMachine.doAction(octane_preloader_state_StartupActions.Initialize,{ fileName : "octane/preloader/shell/scripts/WaitForVendorAvailableCommand.hx", lineNumber : 28, className : "octane.preloader.shell.scripts.WaitForVendorAvailableCommand", methodName : "execute"});
					_gthis.slot.dispose();
				}
			});
		}
	}
	,__class__: octane_preloader_shell_scripts_WaitForVendorAvailableCommand
});
var octane_preloader_state_StartupActions = $hxEnums["octane.preloader.state.StartupActions"] = { __ename__ : "octane.preloader.state.StartupActions", __constructs__ : ["PrepareAPI","Initialize","PrepareEngine","InitializeEngine","DisplayGame"]
	,PrepareAPI: {_hx_index:0,__enum__:"octane.preloader.state.StartupActions",toString:$estr}
	,Initialize: {_hx_index:1,__enum__:"octane.preloader.state.StartupActions",toString:$estr}
	,PrepareEngine: {_hx_index:2,__enum__:"octane.preloader.state.StartupActions",toString:$estr}
	,InitializeEngine: {_hx_index:3,__enum__:"octane.preloader.state.StartupActions",toString:$estr}
	,DisplayGame: {_hx_index:4,__enum__:"octane.preloader.state.StartupActions",toString:$estr}
};
var octane_preloader_state_StartupStateMachine = $hx_exports["octane"]["preloader"]["state"]["StartupStateMachine"] = function() {
	octane_core_state_StateMachine.call(this);
	this.logPerformance = true;
	this.createState(octane_preloader_state_StartupStates.WaitingForHostAPI).mapActionToState(octane_preloader_state_StartupActions.PrepareAPI,octane_preloader_state_StartupStates.APIAvailable);
	this.createState(octane_preloader_state_StartupStates.APIAvailable).mapActionToState(octane_preloader_state_StartupActions.Initialize,octane_preloader_state_StartupStates.Initialized).mapActionToState(octane_preloader_state_StartupActions.PrepareEngine,octane_preloader_state_StartupStates.EngineWaiting);
	this.createState(octane_preloader_state_StartupStates.EngineWaiting).mapActionToState(octane_preloader_state_StartupActions.Initialize,octane_preloader_state_StartupStates.EngineReady);
	this.createState(octane_preloader_state_StartupStates.Initialized).mapActionToState(octane_preloader_state_StartupActions.PrepareEngine,octane_preloader_state_StartupStates.EngineReady);
	this.createState(octane_preloader_state_StartupStates.EngineReady).mapActionToState(octane_preloader_state_StartupActions.InitializeEngine,octane_preloader_state_StartupStates.EngineInitialized);
	this.createState(octane_preloader_state_StartupStates.EngineInitialized).mapActionToState(octane_preloader_state_StartupActions.DisplayGame,octane_preloader_state_StartupStates.GameDisplayed);
	this.createState(octane_preloader_state_StartupStates.GameDisplayed);
};
$hxClasses["octane.preloader.state.StartupStateMachine"] = octane_preloader_state_StartupStateMachine;
octane_preloader_state_StartupStateMachine.__name__ = "octane.preloader.state.StartupStateMachine";
octane_preloader_state_StartupStateMachine.__super__ = octane_core_state_StateMachine;
octane_preloader_state_StartupStateMachine.prototype = $extend(octane_core_state_StateMachine.prototype,{
	__class__: octane_preloader_state_StartupStateMachine
});
var octane_preloader_state_StartupStates = $hxEnums["octane.preloader.state.StartupStates"] = { __ename__ : "octane.preloader.state.StartupStates", __constructs__ : ["WaitingForHostAPI","APIAvailable","Initialized","EngineWaiting","EngineReady","EngineInitialized","GameDisplayed"]
	,WaitingForHostAPI: {_hx_index:0,__enum__:"octane.preloader.state.StartupStates",toString:$estr}
	,APIAvailable: {_hx_index:1,__enum__:"octane.preloader.state.StartupStates",toString:$estr}
	,Initialized: {_hx_index:2,__enum__:"octane.preloader.state.StartupStates",toString:$estr}
	,EngineWaiting: {_hx_index:3,__enum__:"octane.preloader.state.StartupStates",toString:$estr}
	,EngineReady: {_hx_index:4,__enum__:"octane.preloader.state.StartupStates",toString:$estr}
	,EngineInitialized: {_hx_index:5,__enum__:"octane.preloader.state.StartupStates",toString:$estr}
	,GameDisplayed: {_hx_index:6,__enum__:"octane.preloader.state.StartupStates",toString:$estr}
};
var octane_preloader_titan_controller_WaitForTitanCommand = function() {
	octane_core_mvc_controller_Command.call(this);
};
$hxClasses["octane.preloader.titan.controller.WaitForTitanCommand"] = octane_preloader_titan_controller_WaitForTitanCommand;
octane_preloader_titan_controller_WaitForTitanCommand.__name__ = "octane.preloader.titan.controller.WaitForTitanCommand";
octane_preloader_titan_controller_WaitForTitanCommand.__super__ = octane_core_mvc_controller_Command;
octane_preloader_titan_controller_WaitForTitanCommand.prototype = $extend(octane_core_mvc_controller_Command.prototype,{
	execute: function() {
		window.start = $bind(this,this.gameStart);
		window.ready = $bind(this,this.gameReady);
	}
	,gameStart: function(api) {
		this.injector.mapType("titan.api.ITitanAPI",null,null).toValue(api);
		return Promise.resolve();
	}
	,gameReady: function(api) {
		var _gthis = this;
		return new Promise(function(resolve,_) {
			_gthis.preloaderNotificationService.storeCallback(resolve,null);
			_gthis.hostType.set_current("Titan");
			_gthis.commandMap.execute(octane_preloader_controller_OnHostInitializedCommand);
			if(_gthis.startupStateMachine.currentState.is(octane_preloader_state_StartupStates.EngineReady)) {
				_gthis.transitionToEngineInitialized();
			} else {
				_gthis.startupStateMachine.getState(octane_preloader_state_StartupStates.EngineReady).onEntered.add($bind(_gthis,_gthis.transitionToEngineInitialized));
			}
		}).then(function(value) {
			window.removePreloader();
		});
	}
	,transitionToEngineInitialized: function() {
		this.startupStateMachine.doAction(octane_preloader_state_StartupActions.InitializeEngine,{ fileName : "octane/preloader/titan/controller/WaitForTitanCommand.hx", lineNumber : 59, className : "octane.preloader.titan.controller.WaitForTitanCommand", methodName : "transitionToEngineInitialized"});
	}
	,__class__: octane_preloader_titan_controller_WaitForTitanCommand
});
var octane_preloader_titan_model_TitanAssetLoadingModel = function() {
};
$hxClasses["octane.preloader.titan.model.TitanAssetLoadingModel"] = octane_preloader_titan_model_TitanAssetLoadingModel;
octane_preloader_titan_model_TitanAssetLoadingModel.__name__ = "octane.preloader.titan.model.TitanAssetLoadingModel";
octane_preloader_titan_model_TitanAssetLoadingModel.__interfaces__ = [octane_preloader_model_IAssetLoadingModel];
octane_preloader_titan_model_TitanAssetLoadingModel.prototype = {
	postConstruct: function() {
		this.gamesPath = "" + this.resolveGameUrl() + "/";
	}
	,resolveContentUrl: function(path) {
		return window.resolveContentUrl(path);
	}
	,resolveGameUrl: function(path) {
		return window.resolveGameUrl(path);
	}
	,__class__: octane_preloader_titan_model_TitanAssetLoadingModel
};
var octane_preloader_titan_model_TitanLanguageCodeModel = function() {
	this.languageCode = this.queryLanguageCode();
};
$hxClasses["octane.preloader.titan.model.TitanLanguageCodeModel"] = octane_preloader_titan_model_TitanLanguageCodeModel;
octane_preloader_titan_model_TitanLanguageCodeModel.__name__ = "octane.preloader.titan.model.TitanLanguageCodeModel";
octane_preloader_titan_model_TitanLanguageCodeModel.__interfaces__ = [octane_preloader_model_ILanguageCodeModel];
octane_preloader_titan_model_TitanLanguageCodeModel.prototype = {
	queryLanguageCode: function() {
		return window.titanStartupInfo.languageCode;
	}
	,__class__: octane_preloader_titan_model_TitanLanguageCodeModel
};
var octane_preloader_titan_service_TitanPreloaderNotificationService = function() {
};
$hxClasses["octane.preloader.titan.service.TitanPreloaderNotificationService"] = octane_preloader_titan_service_TitanPreloaderNotificationService;
octane_preloader_titan_service_TitanPreloaderNotificationService.__name__ = "octane.preloader.titan.service.TitanPreloaderNotificationService";
octane_preloader_titan_service_TitanPreloaderNotificationService.__interfaces__ = [octane_preloader_service_IPreloaderNotificationService];
octane_preloader_titan_service_TitanPreloaderNotificationService.prototype = {
	storeCallback: function(callback,scope) {
		var f = callback;
		var a1 = scope;
		this.donePreloadingCallback = function() {
			f(a1);
		};
	}
	,donePreloading: function() {
		this.donePreloadingCallback();
	}
	,__class__: octane_preloader_titan_service_TitanPreloaderNotificationService
};
var octane_preloader_toggle_PreloaderToggleModel = function() {
};
$hxClasses["octane.preloader.toggle.PreloaderToggleModel"] = octane_preloader_toggle_PreloaderToggleModel;
octane_preloader_toggle_PreloaderToggleModel.__name__ = "octane.preloader.toggle.PreloaderToggleModel";
octane_preloader_toggle_PreloaderToggleModel.prototype = {
	postConstruct: function() {
		var parsedMaximumParallelLoads = Std.parseInt(this.urlParameters.get("maximumParallelLoads"));
		if(parsedMaximumParallelLoads != null) {
			this.maximumParallelLoads = parsedMaximumParallelLoads;
		}
		var parsedImageScale = Std.parseInt(this.urlParameters.get("imageScale"));
		if(parsedImageScale != null) {
			this.imageScale = parsedImageScale;
		}
		var parsedPackagedGame = this.urlParameters.get("proxiedHost");
		if(parsedPackagedGame != null) {
			this.packagedGame = parsedPackagedGame == "true";
		}
		this.formFactor = this.urlParameters.get("formFactor");
	}
	,__class__: octane_preloader_toggle_PreloaderToggleModel
};
var octane_preloader_url_model_URLParametersModel = $hx_exports["octane"]["preloader"]["url"]["model"]["URLParametersModel"] = function() {
	this.searchParameters = this.getParams();
};
$hxClasses["octane.preloader.url.model.URLParametersModel"] = octane_preloader_url_model_URLParametersModel;
octane_preloader_url_model_URLParametersModel.__name__ = "octane.preloader.url.model.URLParametersModel";
octane_preloader_url_model_URLParametersModel.prototype = {
	getParams: function() {
		var searchString = HxOverrides.substr(window.location.search,1,null);
		var searchParams = new haxe_ds_StringMap();
		var _g = 0;
		var _g1 = new EReg("[&;]","g").split(searchString);
		while(_g < _g1.length) {
			var keyValuePair = _g1[_g];
			++_g;
			var keyValuePairParts = keyValuePair.split("=");
			if(keyValuePairParts.length < 2) {
				continue;
			}
			var key = keyValuePairParts.shift();
			var key1 = decodeURIComponent(key.split("+").join(" "));
			var s = keyValuePairParts.join("=");
			var value = decodeURIComponent(s.split("+").join(" "));
			if(__map_reserved[key1] != null) {
				searchParams.setReserved(key1,value);
			} else {
				searchParams.h[key1] = value;
			}
		}
		return searchParams;
	}
	,get: function(key) {
		var _this = this.searchParameters;
		if(__map_reserved[key] != null) {
			return _this.getReserved(key);
		} else {
			return _this.h[key];
		}
	}
	,__class__: octane_preloader_url_model_URLParametersModel
};
var octane_preloader_v_controller_WaitForVCommand = function() {
	octane_core_mvc_controller_Command.call(this);
};
$hxClasses["octane.preloader.v.controller.WaitForVCommand"] = octane_preloader_v_controller_WaitForVCommand;
octane_preloader_v_controller_WaitForVCommand.__name__ = "octane.preloader.v.controller.WaitForVCommand";
octane_preloader_v_controller_WaitForVCommand.__super__ = octane_core_mvc_controller_Command;
octane_preloader_v_controller_WaitForVCommand.prototype = $extend(octane_core_mvc_controller_Command.prototype,{
	execute: function() {
		window.initGame = $bind(this,this.initGame);
	}
	,initGame: function(baseConf,assets,deviceProperties,startupCompleteCallback,automationConfig,callbackScope,gameSettingsConfig) {
		this.preloaderNotificationService.storeCallback(startupCompleteCallback,callbackScope);
		this.hostType.set_current("V");
		this.commandMap.execute(octane_preloader_controller_OnHostInitializedCommand);
		if(this.startupStateMachine.currentState.is(octane_preloader_state_StartupStates.EngineReady)) {
			this.transitionToEngineInitialized();
		} else {
			this.startupStateMachine.getState(octane_preloader_state_StartupStates.EngineReady).onEntered.add($bind(this,this.transitionToEngineInitialized));
		}
	}
	,transitionToEngineInitialized: function() {
		this.startupStateMachine.doAction(octane_preloader_state_StartupActions.InitializeEngine,{ fileName : "octane/preloader/v/controller/WaitForVCommand.hx", lineNumber : 46, className : "octane.preloader.v.controller.WaitForVCommand", methodName : "transitionToEngineInitialized"});
	}
	,__class__: octane_preloader_v_controller_WaitForVCommand
});
var octane_preloader_v_model_VAssetLoadingModel = function() {
	this.gamesPath = this.resolveGameUrl();
};
$hxClasses["octane.preloader.v.model.VAssetLoadingModel"] = octane_preloader_v_model_VAssetLoadingModel;
octane_preloader_v_model_VAssetLoadingModel.__name__ = "octane.preloader.v.model.VAssetLoadingModel";
octane_preloader_v_model_VAssetLoadingModel.__interfaces__ = [octane_preloader_model_IAssetLoadingModel];
octane_preloader_v_model_VAssetLoadingModel.prototype = {
	resolveContentUrl: function(path) {
		return V.API.UrlHelper.getContentUrl(path);
	}
	,resolveGameUrl: function(path) {
		return V.API.UrlHelper.getGameUrl(path);
	}
	,__class__: octane_preloader_v_model_VAssetLoadingModel
};
var octane_preloader_v_model_VLanguageCodeModel = function() {
	this.languageCode = this.queryLanguageCode();
};
$hxClasses["octane.preloader.v.model.VLanguageCodeModel"] = octane_preloader_v_model_VLanguageCodeModel;
octane_preloader_v_model_VLanguageCodeModel.__name__ = "octane.preloader.v.model.VLanguageCodeModel";
octane_preloader_v_model_VLanguageCodeModel.__interfaces__ = [octane_preloader_model_ILanguageCodeModel];
octane_preloader_v_model_VLanguageCodeModel.prototype = {
	queryLanguageCode: function() {
		if(window.mgsCasinoParams == null) {
			console.warn(octane_core_debug_Logger.indent.join("") + " " + "Could not read mgsCasinoParams, defaulting language code to " + "en");
			return "en";
		}
		var languageCodeFromParams = window.mgsCasinoParams.languageCode.toLowerCase();
		if(octane_core_types_string_StringExtensions.isNullOrEmpty(languageCodeFromParams)) {
			return this.logWarningAndReturnDefault(languageCodeFromParams);
		}
		return this.validateAgainstSupportedLanguages(languageCodeFromParams);
	}
	,toLowerCase: function(s) {
		return s.toLowerCase();
	}
	,validateAgainstSupportedLanguages: function(languageCodeFromParams) {
		if(window.gameOverridesConfig == null) {
			return this.logWarningAndReturnDefault(languageCodeFromParams);
		}
		var supportedLangs = window.gameOverridesConfig.supportedAssetLangs;
		if(octane_core_types_array_ArrayExtensions.isNullOrEmpty(supportedLangs)) {
			return this.logWarningAndReturnDefault(languageCodeFromParams);
		}
		if(Lambda.has(supportedLangs.map($bind(this,this.toLowerCase)),languageCodeFromParams)) {
			return languageCodeFromParams;
		}
		return this.logWarningAndReturnDefault(languageCodeFromParams);
	}
	,logWarningAndReturnDefault: function(languageCodeFromParams) {
		console.warn(octane_core_debug_Logger.indent.join("") + " " + "Could not load language code \"" + languageCodeFromParams + "\". Defaulting to \"" + "en" + "\".");
		return "en";
	}
	,__class__: octane_preloader_v_model_VLanguageCodeModel
};
var octane_preloader_v_service_VPreloaderNotificationService = function() {
};
$hxClasses["octane.preloader.v.service.VPreloaderNotificationService"] = octane_preloader_v_service_VPreloaderNotificationService;
octane_preloader_v_service_VPreloaderNotificationService.__name__ = "octane.preloader.v.service.VPreloaderNotificationService";
octane_preloader_v_service_VPreloaderNotificationService.__interfaces__ = [octane_preloader_service_IPreloaderNotificationService];
octane_preloader_v_service_VPreloaderNotificationService.prototype = {
	storeCallback: function(callback,scope) {
		var f = callback;
		var a1 = scope;
		this.donePreloadingCallback = function() {
			f(a1);
		};
	}
	,donePreloading: function() {
		this.donePreloadingCallback();
	}
	,__class__: octane_preloader_v_service_VPreloaderNotificationService
};
var promhx_base_AsyncBase = function(d) {
	this._resolved = false;
	this._pending = false;
	this._errorPending = false;
	this._fulfilled = false;
	this._update = [];
	this._error = [];
	this._errored = false;
	if(d != null) {
		var next = this;
		var f = function(x) {
			return x;
		};
		d._update.push({ async : next, linkf : function(x1) {
			var tmp = f(x1);
			next.handleResolve(tmp);
		}});
		promhx_base_AsyncBase.immediateLinkUpdate(d,next,f);
	}
};
$hxClasses["promhx.base.AsyncBase"] = promhx_base_AsyncBase;
promhx_base_AsyncBase.__name__ = "promhx.base.AsyncBase";
promhx_base_AsyncBase.link = function(current,next,f) {
	current._update.push({ async : next, linkf : function(x) {
		var tmp = f(x);
		next.handleResolve(tmp);
	}});
	promhx_base_AsyncBase.immediateLinkUpdate(current,next,f);
};
promhx_base_AsyncBase.immediateLinkUpdate = function(current,next,f) {
	if(current._errored && !current._errorPending && current._error.length <= 0) {
		next.handleError(current._errorVal);
	}
	if(current._resolved && !current._pending) {
		try {
			next.handleResolve(f(current._val));
		} catch( e ) {
			next.handleError(((e) instanceof js__$Boot_HaxeError) ? e.val : e);
		}
	}
};
promhx_base_AsyncBase.linkAll = function(all,next) {
	var cthen = function(arr,current,v) {
		if(arr.length == 0 || promhx_base_AsyncBase.allFulfilled(arr)) {
			var _g = [];
			var a = $getIterator(all);
			while(a.hasNext()) {
				var a1 = a.next();
				_g.push(a1 == current ? v : a1._val);
			}
			var vals = _g;
			next.handleResolve(vals);
		}
		return;
	};
	var a2 = $getIterator(all);
	while(a2.hasNext()) {
		var a3 = a2.next();
		var a4 = a3._update;
		var f = [cthen];
		var _g1 = [];
		var a21 = $getIterator(all);
		while(a21.hasNext()) {
			var a22 = a21.next();
			if(a22 != a3) {
				_g1.push(a22);
			}
		}
		var tmp = (function(current1,arr1,f1) {
			return function(v1) {
				f1[0](arr1[0],current1[0],v1);
				return;
			};
		})([a3],[_g1],f);
		a4.push({ async : next, linkf : tmp});
	}
	if(promhx_base_AsyncBase.allFulfilled(all)) {
		var _g2 = [];
		var a5 = $getIterator(all);
		while(a5.hasNext()) {
			var a6 = a5.next();
			_g2.push(a6._val);
		}
		next.handleResolve(_g2);
	}
};
promhx_base_AsyncBase.pipeLink = function(current,ret,f) {
	var linked = false;
	var linkf = function(x) {
		if(!linked) {
			linked = true;
			var pipe_ret = f(x);
			pipe_ret._update.push({ async : ret, linkf : $bind(ret,ret.handleResolve)});
			promhx_base_AsyncBase.immediateLinkUpdate(pipe_ret,ret,function(x1) {
				return x1;
			});
		}
	};
	current._update.push({ async : ret, linkf : linkf});
	if(current._resolved && !current._pending) {
		try {
			linkf(current._val);
		} catch( e ) {
			ret.handleError(((e) instanceof js__$Boot_HaxeError) ? e.val : e);
		}
	}
};
promhx_base_AsyncBase.allResolved = function(as) {
	var a = $getIterator(as);
	while(a.hasNext()) {
		var a1 = a.next();
		if(!a1._resolved) {
			return false;
		}
	}
	return true;
};
promhx_base_AsyncBase.allFulfilled = function(as) {
	var a = $getIterator(as);
	while(a.hasNext()) {
		var a1 = a.next();
		if(!a1._fulfilled) {
			return false;
		}
	}
	return true;
};
promhx_base_AsyncBase.prototype = {
	catchError: function(f) {
		this._error.push(f);
		return this;
	}
	,errorThen: function(f) {
		this._errorMap = f;
		return this;
	}
	,isResolved: function() {
		return this._resolved;
	}
	,isErrored: function() {
		return this._errored;
	}
	,isErrorHandled: function() {
		return this._error.length > 0;
	}
	,isErrorPending: function() {
		return this._errorPending;
	}
	,isFulfilled: function() {
		return this._fulfilled;
	}
	,isPending: function() {
		return this._pending;
	}
	,handleResolve: function(val) {
		this._resolve(val);
	}
	,_resolve: function(val) {
		var _gthis = this;
		if(this._pending) {
			var f = $bind(this,this._resolve);
			var val1 = val;
			var tmp = function() {
				f(val1);
			};
			promhx_base_EventLoop.queue.add(tmp);
			promhx_base_EventLoop.continueOnNextLoop();
		} else {
			this._resolved = true;
			this._pending = true;
			promhx_base_EventLoop.queue.add(function() {
				_gthis._val = val;
				var _g = 0;
				var _g1 = _gthis._update;
				while(_g < _g1.length) {
					var up = _g1[_g];
					++_g;
					try {
						up.linkf(val);
					} catch( e ) {
						up.async.handleError(((e) instanceof js__$Boot_HaxeError) ? e.val : e);
					}
				}
				_gthis._fulfilled = true;
				_gthis._pending = false;
			});
			promhx_base_EventLoop.continueOnNextLoop();
		}
	}
	,handleError: function(error) {
		this._handleError(error);
	}
	,_handleError: function(error) {
		var _gthis = this;
		var update_errors = function(e) {
			if(_gthis._error.length > 0) {
				var _g = 0;
				var _g1 = _gthis._error;
				while(_g < _g1.length) {
					var ef = _g1[_g];
					++_g;
					ef(e);
				}
			} else if(_gthis._update.length > 0) {
				var _g2 = 0;
				var _g11 = _gthis._update;
				while(_g2 < _g11.length) {
					var up = _g11[_g2];
					++_g2;
					up.async.handleError(e);
				}
			} else {
				console.log("/data/twrk/1e7c828fa4a6cdda/.haxelib/promhx/1,1,0/src/main/promhx/base/AsyncBase.hx:192:","Call Stack: " + haxe_CallStack.toString(haxe_CallStack.callStack()));
				throw js__$Boot_HaxeError.wrap(e);
			}
			_gthis._errorPending = false;
		};
		if(!this._errorPending) {
			this._errorPending = true;
			this._errored = true;
			this._errorVal = error;
			promhx_base_EventLoop.queue.add(function() {
				if(_gthis._errorMap != null) {
					try {
						var tmp = _gthis._errorMap(error);
						_gthis._resolve(tmp);
					} catch( e1 ) {
						update_errors(((e1) instanceof js__$Boot_HaxeError) ? e1.val : e1);
					}
				} else {
					update_errors(error);
				}
			});
			promhx_base_EventLoop.continueOnNextLoop();
		}
	}
	,then: function(f) {
		var ret = new promhx_base_AsyncBase(null);
		var next = ret;
		var f1 = f;
		this._update.push({ async : next, linkf : function(x) {
			var tmp = f1(x);
			next.handleResolve(tmp);
		}});
		promhx_base_AsyncBase.immediateLinkUpdate(this,next,f1);
		return ret;
	}
	,unlink: function(to) {
		var _gthis = this;
		promhx_base_EventLoop.queue.add(function() {
			_gthis._update = _gthis._update.filter(function(x) {
				return x.async != to;
			});
		});
		promhx_base_EventLoop.continueOnNextLoop();
	}
	,isLinked: function(to) {
		var updated = false;
		var _g = 0;
		var _g1 = this._update;
		while(_g < _g1.length) {
			var u = _g1[_g];
			++_g;
			if(u.async == to) {
				return true;
			}
		}
		return updated;
	}
	,__class__: promhx_base_AsyncBase
};
var promhx_Deferred = $hx_exports["promhx"]["Deferred"] = function() {
	promhx_base_AsyncBase.call(this);
};
$hxClasses["promhx.Deferred"] = promhx_Deferred;
promhx_Deferred.__name__ = "promhx.Deferred";
promhx_Deferred.__super__ = promhx_base_AsyncBase;
promhx_Deferred.prototype = $extend(promhx_base_AsyncBase.prototype,{
	resolve: function(val) {
		this.handleResolve(val);
	}
	,throwError: function(e) {
		this.handleError(e);
	}
	,promise: function() {
		return new promhx_Promise(this);
	}
	,stream: function() {
		return new promhx_Stream(this);
	}
	,publicStream: function() {
		return new promhx_PublicStream(this);
	}
	,__class__: promhx_Deferred
});
var promhx_Promise = $hx_exports["promhx"]["Promise"] = function(d) {
	promhx_base_AsyncBase.call(this,d);
	this._rejected = false;
};
$hxClasses["promhx.Promise"] = promhx_Promise;
promhx_Promise.__name__ = "promhx.Promise";
promhx_Promise.whenAll = function(itb) {
	var ret = new promhx_Promise(null);
	var all = itb;
	var next = ret;
	var cthen = function(arr,current,v) {
		if(arr.length == 0 || promhx_base_AsyncBase.allFulfilled(arr)) {
			var _g = [];
			var a = $getIterator(all);
			while(a.hasNext()) {
				var a1 = a.next();
				_g.push(a1 == current ? v : a1._val);
			}
			var vals = _g;
			next.handleResolve(vals);
		}
		return;
	};
	var a2 = $getIterator(all);
	while(a2.hasNext()) {
		var a3 = a2.next();
		var a4 = a3._update;
		var f = [cthen];
		var _g1 = [];
		var a21 = $getIterator(all);
		while(a21.hasNext()) {
			var a22 = a21.next();
			if(a22 != a3) {
				_g1.push(a22);
			}
		}
		var tmp = (function(current1,arr1,f1) {
			return function(v1) {
				f1[0](arr1[0],current1[0],v1);
				return;
			};
		})([a3],[_g1],f);
		a4.push({ async : next, linkf : tmp});
	}
	if(promhx_base_AsyncBase.allFulfilled(all)) {
		var _g2 = [];
		var a5 = $getIterator(all);
		while(a5.hasNext()) {
			var a6 = a5.next();
			_g2.push(a6._val);
		}
		next.handleResolve(_g2);
	}
	return ret;
};
promhx_Promise.promise = function(_val) {
	var ret = new promhx_Promise();
	ret.handleResolve(_val);
	return ret;
};
promhx_Promise.__super__ = promhx_base_AsyncBase;
promhx_Promise.prototype = $extend(promhx_base_AsyncBase.prototype,{
	isRejected: function() {
		return this._rejected;
	}
	,reject: function(e) {
		this._rejected = true;
		this.handleError(e);
	}
	,handleResolve: function(val) {
		if(this._resolved) {
			var msg = "Promise has already been resolved";
			throw new js__$Boot_HaxeError(promhx_error_PromiseError.AlreadyResolved(msg));
		}
		this._resolve(val);
	}
	,then: function(f) {
		var ret = new promhx_Promise(null);
		var next = ret;
		var f1 = f;
		this._update.push({ async : next, linkf : function(x) {
			var tmp = f1(x);
			next.handleResolve(tmp);
		}});
		promhx_base_AsyncBase.immediateLinkUpdate(this,next,f1);
		return ret;
	}
	,unlink: function(to) {
		var _gthis = this;
		promhx_base_EventLoop.queue.add(function() {
			if(!_gthis._fulfilled) {
				var msg = "Downstream Promise is not fullfilled";
				_gthis.handleError(promhx_error_PromiseError.DownstreamNotFullfilled(msg));
			} else {
				_gthis._update = _gthis._update.filter(function(x) {
					return x.async != to;
				});
			}
		});
		promhx_base_EventLoop.continueOnNextLoop();
	}
	,handleError: function(error) {
		this._rejected = true;
		this._handleError(error);
	}
	,pipe: function(f) {
		var ret = new promhx_Promise(null);
		var ret1 = ret;
		var f1 = f;
		var linked = false;
		var linkf = function(x) {
			if(!linked) {
				linked = true;
				var pipe_ret = f1(x);
				pipe_ret._update.push({ async : ret1, linkf : $bind(ret1,ret1.handleResolve)});
				promhx_base_AsyncBase.immediateLinkUpdate(pipe_ret,ret1,function(x1) {
					return x1;
				});
			}
		};
		this._update.push({ async : ret1, linkf : linkf});
		if(this._resolved && !this._pending) {
			try {
				linkf(this._val);
			} catch( e ) {
				ret1.handleError(((e) instanceof js__$Boot_HaxeError) ? e.val : e);
			}
		}
		return ret;
	}
	,errorPipe: function(f) {
		var ret = new promhx_Promise();
		this.catchError(function(e) {
			var piped = f(e);
			piped.then($bind(ret,ret._resolve));
		});
		this.then($bind(ret,ret._resolve));
		return ret;
	}
	,__class__: promhx_Promise
});
var promhx_Stream = $hx_exports["promhx"]["Stream"] = function(d) {
	promhx_base_AsyncBase.call(this,d);
	this._end_promise = new promhx_Promise();
};
$hxClasses["promhx.Stream"] = promhx_Stream;
promhx_Stream.__name__ = "promhx.Stream";
promhx_Stream.foreach = function(itb) {
	var s = new promhx_Stream(null);
	var i = $getIterator(itb);
	while(i.hasNext()) {
		var i1 = i.next();
		s.handleResolve(i1);
	}
	s.end();
	return s;
};
promhx_Stream.wheneverAll = function(itb) {
	var ret = new promhx_Stream(null);
	var all = itb;
	var next = ret;
	var cthen = function(arr,current,v) {
		if(arr.length == 0 || promhx_base_AsyncBase.allFulfilled(arr)) {
			var _g = [];
			var a = $getIterator(all);
			while(a.hasNext()) {
				var a1 = a.next();
				_g.push(a1 == current ? v : a1._val);
			}
			var vals = _g;
			next.handleResolve(vals);
		}
		return;
	};
	var a2 = $getIterator(all);
	while(a2.hasNext()) {
		var a3 = a2.next();
		var a4 = a3._update;
		var f = [cthen];
		var _g1 = [];
		var a21 = $getIterator(all);
		while(a21.hasNext()) {
			var a22 = a21.next();
			if(a22 != a3) {
				_g1.push(a22);
			}
		}
		var tmp = (function(current1,arr1,f1) {
			return function(v1) {
				f1[0](arr1[0],current1[0],v1);
				return;
			};
		})([a3],[_g1],f);
		a4.push({ async : next, linkf : tmp});
	}
	if(promhx_base_AsyncBase.allFulfilled(all)) {
		var _g2 = [];
		var a5 = $getIterator(all);
		while(a5.hasNext()) {
			var a6 = a5.next();
			_g2.push(a6._val);
		}
		next.handleResolve(_g2);
	}
	return ret;
};
promhx_Stream.concatAll = function(itb) {
	var ret = new promhx_Stream(null);
	var i = $getIterator(itb);
	while(i.hasNext()) {
		var i1 = i.next();
		ret.concat(i1);
	}
	return ret;
};
promhx_Stream.mergeAll = function(itb) {
	var ret = new promhx_Stream(null);
	var i = $getIterator(itb);
	while(i.hasNext()) {
		var i1 = i.next();
		ret.merge(i1);
	}
	return ret;
};
promhx_Stream.stream = function(_val) {
	var ret = new promhx_Stream(null);
	ret.handleResolve(_val);
	return ret;
};
promhx_Stream.__super__ = promhx_base_AsyncBase;
promhx_Stream.prototype = $extend(promhx_base_AsyncBase.prototype,{
	then: function(f) {
		var ret = new promhx_Stream(null);
		var next = ret;
		var f1 = f;
		this._update.push({ async : next, linkf : function(x) {
			var tmp = f1(x);
			next.handleResolve(tmp);
		}});
		promhx_base_AsyncBase.immediateLinkUpdate(this,next,f1);
		this._end_promise._update.push({ async : ret._end_promise, linkf : function(x1) {
			ret.end();
		}});
		return ret;
	}
	,detachStream: function(str) {
		var filtered = [];
		var removed = false;
		var _g = 0;
		var _g1 = this._update;
		while(_g < _g1.length) {
			var u = _g1[_g];
			++_g;
			if(u.async == str) {
				this._end_promise._update = this._end_promise._update.filter(function(x) {
					return x.async != str._end_promise;
				});
				removed = true;
			} else {
				filtered.push(u);
			}
		}
		this._update = filtered;
		return removed;
	}
	,first: function() {
		var s = new promhx_Promise(null);
		this.then(function(x) {
			if(!s._resolved) {
				s.handleResolve(x);
			}
		});
		return s;
	}
	,handleResolve: function(val) {
		if(!this._end && !this._pause) {
			this._resolve(val);
		}
	}
	,pause: function(set) {
		if(set == null) {
			set = !this._pause;
		}
		this._pause = set;
	}
	,pipe: function(f) {
		var ret = new promhx_Stream(null);
		var ret1 = ret;
		var f1 = f;
		var linked = false;
		var linkf = function(x) {
			if(!linked) {
				linked = true;
				var pipe_ret = f1(x);
				pipe_ret._update.push({ async : ret1, linkf : $bind(ret1,ret1.handleResolve)});
				promhx_base_AsyncBase.immediateLinkUpdate(pipe_ret,ret1,function(x1) {
					return x1;
				});
			}
		};
		this._update.push({ async : ret1, linkf : linkf});
		if(this._resolved && !this._pending) {
			try {
				linkf(this._val);
			} catch( e ) {
				ret1.handleError(((e) instanceof js__$Boot_HaxeError) ? e.val : e);
			}
		}
		this._end_promise.then(function(x2) {
			ret.end();
		});
		return ret;
	}
	,errorPipe: function(f) {
		var ret = new promhx_Stream(null);
		this.catchError(function(e) {
			var piped = f(e);
			piped.then($bind(ret,ret._resolve));
			piped._end_promise.then(($_=ret._end_promise,$bind($_,$_._resolve)));
		});
		this.then($bind(ret,ret._resolve));
		this._end_promise.then(function(x) {
			ret.end();
		});
		return ret;
	}
	,handleEnd: function() {
		if(this._pending) {
			promhx_base_EventLoop.queue.add($bind(this,this.handleEnd));
			promhx_base_EventLoop.continueOnNextLoop();
		} else if(this._end_promise._resolved) {
			return;
		} else {
			this._end = true;
			var o = this._resolved ? haxe_ds_Option.Some(this._val) : haxe_ds_Option.None;
			this._end_promise.handleResolve(o);
			this._update = [];
			this._error = [];
		}
	}
	,end: function() {
		promhx_base_EventLoop.queue.add($bind(this,this.handleEnd));
		promhx_base_EventLoop.continueOnNextLoop();
		return this;
	}
	,endThen: function(f) {
		return this._end_promise.then(f);
	}
	,filter: function(f) {
		var ret = new promhx_Stream(null);
		this._update.push({ async : ret, linkf : function(x) {
			if(f(x)) {
				ret.handleResolve(x);
			}
		}});
		promhx_base_AsyncBase.immediateLinkUpdate(this,ret,function(x1) {
			return x1;
		});
		return ret;
	}
	,concat: function(s) {
		var ret = new promhx_Stream(null);
		this._update.push({ async : ret, linkf : $bind(ret,ret.handleResolve)});
		promhx_base_AsyncBase.immediateLinkUpdate(this,ret,function(x) {
			return x;
		});
		this._end_promise.then(function(_) {
			s.pipe(function(x1) {
				ret.handleResolve(x1);
				return ret;
			});
			s._end_promise.then(function(_1) {
				ret.end();
			});
		});
		return ret;
	}
	,merge: function(s) {
		var ret = new promhx_Stream(null);
		this._update.push({ async : ret, linkf : $bind(ret,ret.handleResolve)});
		s._update.push({ async : ret, linkf : $bind(ret,ret.handleResolve)});
		promhx_base_AsyncBase.immediateLinkUpdate(this,ret,function(x) {
			return x;
		});
		promhx_base_AsyncBase.immediateLinkUpdate(s,ret,function(x1) {
			return x1;
		});
		return ret;
	}
	,__class__: promhx_Stream
});
var promhx_PublicStream = $hx_exports["promhx"]["PublicStream"] = function(def) {
	promhx_Stream.call(this,def);
};
$hxClasses["promhx.PublicStream"] = promhx_PublicStream;
promhx_PublicStream.__name__ = "promhx.PublicStream";
promhx_PublicStream.publicstream = function(val) {
	var ps = new promhx_PublicStream(null);
	ps.handleResolve(val);
	return ps;
};
promhx_PublicStream.__super__ = promhx_Stream;
promhx_PublicStream.prototype = $extend(promhx_Stream.prototype,{
	resolve: function(val) {
		this.handleResolve(val);
	}
	,throwError: function(e) {
		this.handleError(e);
	}
	,update: function(val) {
		this.handleResolve(val);
	}
	,__class__: promhx_PublicStream
});
var promhx_base_EventLoop = function() { };
$hxClasses["promhx.base.EventLoop"] = promhx_base_EventLoop;
promhx_base_EventLoop.__name__ = "promhx.base.EventLoop";
promhx_base_EventLoop.enqueue = function(eqf) {
	promhx_base_EventLoop.queue.add(eqf);
	promhx_base_EventLoop.continueOnNextLoop();
};
promhx_base_EventLoop.set_nextLoop = function(f) {
	if(promhx_base_EventLoop.nextLoop != null) {
		throw new js__$Boot_HaxeError("nextLoop has already been set");
	} else {
		promhx_base_EventLoop.nextLoop = f;
	}
	return promhx_base_EventLoop.nextLoop;
};
promhx_base_EventLoop.queueEmpty = function() {
	return promhx_base_EventLoop.queue.isEmpty();
};
promhx_base_EventLoop.finish = function(max_iterations) {
	if(max_iterations == null) {
		max_iterations = 1000;
	}
	var fn = null;
	while(true) {
		var tmp;
		if(max_iterations-- > 0) {
			fn = promhx_base_EventLoop.queue.pop();
			tmp = fn != null;
		} else {
			tmp = false;
		}
		if(!tmp) {
			break;
		}
		fn();
	}
	return promhx_base_EventLoop.queue.isEmpty();
};
promhx_base_EventLoop.clear = function() {
	promhx_base_EventLoop.queue = new haxe_ds_List();
};
promhx_base_EventLoop.f = function() {
	var fn = promhx_base_EventLoop.queue.pop();
	if(fn != null) {
		fn();
	}
	if(!promhx_base_EventLoop.queue.isEmpty()) {
		promhx_base_EventLoop.continueOnNextLoop();
	}
};
promhx_base_EventLoop.continueOnNextLoop = function() {
	if(promhx_base_EventLoop.nextLoop != null) {
		promhx_base_EventLoop.nextLoop(promhx_base_EventLoop.f);
	} else {
		setImmediate(promhx_base_EventLoop.f);
	}
};
var promhx_error_PromiseError = $hxEnums["promhx.error.PromiseError"] = { __ename__ : "promhx.error.PromiseError", __constructs__ : ["AlreadyResolved","DownstreamNotFullfilled"]
	,AlreadyResolved: ($_=function(message) { return {_hx_index:0,message:message,__enum__:"promhx.error.PromiseError",toString:$estr}; },$_.__params__ = ["message"],$_)
	,DownstreamNotFullfilled: ($_=function(message) { return {_hx_index:1,message:message,__enum__:"promhx.error.PromiseError",toString:$estr}; },$_.__params__ = ["message"],$_)
};
var titan_api_ITitanAPI = function() { };
$hxClasses["titan.api.ITitanAPI"] = titan_api_ITitanAPI;
titan_api_ITitanAPI.__name__ = "titan.api.ITitanAPI";
titan_api_ITitanAPI.__isInterface__ = true;
titan_api_ITitanAPI.prototype = {
	__class__: titan_api_ITitanAPI
};
var titan_api_analytics_IGameAnalytics = function() { };
$hxClasses["titan.api.analytics.IGameAnalytics"] = titan_api_analytics_IGameAnalytics;
titan_api_analytics_IGameAnalytics.__name__ = "titan.api.analytics.IGameAnalytics";
titan_api_analytics_IGameAnalytics.__isInterface__ = true;
titan_api_analytics_IGameAnalytics.prototype = {
	__class__: titan_api_analytics_IGameAnalytics
};
var titan_api_communication_ICommunication = function() { };
$hxClasses["titan.api.communication.ICommunication"] = titan_api_communication_ICommunication;
titan_api_communication_ICommunication.__name__ = "titan.api.communication.ICommunication";
titan_api_communication_ICommunication.__isInterface__ = true;
titan_api_communication_ICommunication.prototype = {
	__class__: titan_api_communication_ICommunication
};
var titan_api_config_IConfig = function() { };
$hxClasses["titan.api.config.IConfig"] = titan_api_config_IConfig;
titan_api_config_IConfig.__name__ = "titan.api.config.IConfig";
titan_api_config_IConfig.__isInterface__ = true;
titan_api_config_IConfig.prototype = {
	__class__: titan_api_config_IConfig
};
var titan_api_conversion_IConversion = function() { };
$hxClasses["titan.api.conversion.IConversion"] = titan_api_conversion_IConversion;
titan_api_conversion_IConversion.__name__ = "titan.api.conversion.IConversion";
titan_api_conversion_IConversion.__isInterface__ = true;
titan_api_conversion_IConversion.prototype = {
	__class__: titan_api_conversion_IConversion
};
var titan_api_navigation_INavigation = function() { };
$hxClasses["titan.api.navigation.INavigation"] = titan_api_navigation_INavigation;
titan_api_navigation_INavigation.__name__ = "titan.api.navigation.INavigation";
titan_api_navigation_INavigation.__isInterface__ = true;
titan_api_navigation_INavigation.prototype = {
	__class__: titan_api_navigation_INavigation
};
var titan_api_progress_IProgress = function() { };
$hxClasses["titan.api.progress.IProgress"] = titan_api_progress_IProgress;
titan_api_progress_IProgress.__name__ = "titan.api.progress.IProgress";
titan_api_progress_IProgress.__isInterface__ = true;
titan_api_progress_IProgress.prototype = {
	__class__: titan_api_progress_IProgress
};
var titan_api_sound_ISound = function() { };
$hxClasses["titan.api.sound.ISound"] = titan_api_sound_ISound;
titan_api_sound_ISound.__name__ = "titan.api.sound.ISound";
titan_api_sound_ISound.__isInterface__ = true;
titan_api_sound_ISound.prototype = {
	__class__: titan_api_sound_ISound
};
var titan_api_storage_IStorage = function() { };
$hxClasses["titan.api.storage.IStorage"] = titan_api_storage_IStorage;
titan_api_storage_IStorage.__name__ = "titan.api.storage.IStorage";
titan_api_storage_IStorage.__isInterface__ = true;
titan_api_storage_IStorage.prototype = {
	__class__: titan_api_storage_IStorage
};
var titan_bootstrap_IStartupInfo = function() { };
$hxClasses["titan.bootstrap.IStartupInfo"] = titan_bootstrap_IStartupInfo;
titan_bootstrap_IStartupInfo.__name__ = "titan.bootstrap.IStartupInfo";
titan_bootstrap_IStartupInfo.__isInterface__ = true;
titan_bootstrap_IStartupInfo.prototype = {
	__class__: titan_bootstrap_IStartupInfo
};
function $getIterator(o) { if( o instanceof Array ) return HxOverrides.iter(o); else return o.iterator(); }
function $bind(o,m) { if( m == null ) return null; if( m.__id__ == null ) m.__id__ = $global.$haxeUID++; var f; if( o.hx__closures__ == null ) o.hx__closures__ = {}; else f = o.hx__closures__[m.__id__]; if( f == null ) { f = m.bind(o); o.hx__closures__[m.__id__] = f; } return f; }
if(typeof $global.$haxeUID == "undefined") $global.$haxeUID = 0;
$hxClasses["Math"] = Math;
String.prototype.__class__ = $hxClasses["String"] = String;
String.__name__ = "String";
$hxClasses["Array"] = Array;
Array.__name__ = "Array";
Date.prototype.__class__ = $hxClasses["Date"] = Date;
Date.__name__ = "Date";
var Int = { };
var Dynamic = { };
var Float = Number;
var Bool = Boolean;
var Class = { };
var Enum = { };
var __map_reserved = {};
Object.defineProperty(js__$Boot_HaxeError.prototype,"message",{ get : function() {
	return String(this.val);
}});
js_Boot.__toStr = ({ }).toString;
FilteredGlobalExceptionHandler.NON_FATAL_BROWSER_ERRORS = new EReg("Script error\\.?","");
FilteredGlobalExceptionHandler.QQ_REGEX = new EReg("MQQ","");
FilteredGlobalExceptionHandler.QQ_NONFATAL_ERRORS = new EReg("qbSniffJsVersion|x5onSkinSwitch|qbSniff","");
FilteredGlobalExceptionHandler.VIVO_REGEX = new EReg("vivo","");
FilteredGlobalExceptionHandler.VIVO_NONFATAL_ERRORS = new EReg("vivoNewsDetailPage","");
FilteredGlobalExceptionHandler.HAWK_REGEX = new EReg("Hawk","");
FilteredGlobalExceptionHandler.HAWK_NONFATAL_ERRORS = new EReg("__hawk_browser__","");
FilteredGlobalExceptionHandler.SOGOU_REGEX = new EReg("Sogou","");
FilteredGlobalExceptionHandler.SOGOU_NONFATAL_ERRORS = new EReg("Cannot read property '(highlightRender|playState)' of undefined","");
FilteredGlobalExceptionHandler.NONFATAL_SERVICES_ERRORS = new EReg("SignalR|RichMediaMessages","");
haxe_IMap.__meta__ = { obj : { 'interface' : null}};
hx_event_ISignalType.__meta__ = { obj : { 'interface' : null}};
hx_event_ISignal.__meta__ = { obj : { 'interface' : null}};
hx_event_BaseSignal.count = 0;
hx_event_IBaseSignal.__meta__ = { obj : { 'interface' : null}};
hx_event_ISlot.__meta__ = { obj : { 'interface' : null}};
minject_point_InjectionPoint.__meta__ = { obj : { 'interface' : null}};
minject_provider_DependencyProvider.__meta__ = { obj : { 'interface' : null}};
octane_browser_IDocument.__meta__ = { obj : { 'interface' : null}};
octane_browser_INavigator.__meta__ = { obj : { 'interface' : null}};
octane_browser_IWindow.__meta__ = { obj : { 'interface' : null}};
octane_core_debug_Logger.__meta__ = { obj : { IgnoreCover : null, SuppressWarnings : ["checkstyle:MultipleStringLiterals"]}};
octane_core_debug_Logger.JS_UNTYPED = "__js__";
octane_core_debug_Logger.indent = [];
octane_core_debug_Performance.API_ERROR = "Performance API is not supported.";
octane_core_macro_AbstractEnumTools.__meta__ = { obj : { SuppressWarnings : ["checkstyle:MultipleStringLiterals","checkstyle:UnusedLocalVar"]}};
octane_core_mvc_controller_BaseCommand.__meta__ = { obj : { rtti : [["commandMap","octane.core.mvc.controller.CommandMap",""],["postConstruct","1"]]}};
octane_core_mvc_module_IModule.__meta__ = { obj : { 'interface' : null}};
octane_core_mvc_view_IDisposable.__meta__ = { obj : { 'interface' : null}};
octane_core_mvc_view_IViewWithReadySignal.__meta__ = { obj : { 'interface' : null}};
octane_core_mvc_view_Mediator.__meta__ = { obj : { rtti : [["injector","minject.Injector",""],["postConstruct","1"]]}, fields : { __onRemove : { SuppressWarnings : ["checkstyle:MethodName"]}}};
octane_core_mvc_view_ViewMap.__meta__ = { fields : { __mapView : { SuppressWarnings : ["checkstyle:MethodName"]}}};
octane_core_mvc_view_ViewMap.formFactors = ["desktop","mobile"];
octane_preloader_controller_OnHostInitializedCommand.__meta__ = { obj : { rtti : [["fileLoader","octane.preloader.service.IFileLoadingService",""],["manifest","octane.preloader.model.manifest.IPreloaderManifestModel",""]]}};
octane_preloader_model_IAssetLoadingModel.__meta__ = { obj : { 'interface' : null}};
octane_preloader_model_ILanguageCodeModel.__meta__ = { obj : { 'interface' : null}};
octane_preloader_model_IMultipartBundleModel.__meta__ = { obj : { 'interface' : null}};
octane_preloader_model_IPreloadedFilesModel.__meta__ = { obj : { 'interface' : null}};
octane_preloader_model_asset_profile_IAssetProfilesModel.__meta__ = { obj : { 'interface' : null}};
octane_preloader_model_device_ICrossOriginResourceSharingBlacklistModel.__meta__ = { obj : { 'interface' : null}};
octane_preloader_model_device_IDeviceInformationModel.__meta__ = { obj : { 'interface' : null}};
octane_preloader_model_device_DeviceInformationModel.__meta__ = { obj : { rtti : [["crossOriginResourceSharingBlacklistModel","octane.preloader.model.device.ICrossOriginResourceSharingBlacklistModel",""],["webGLBlacklistModel","octane.preloader.model.device.IWebGLBlacklistModel",""],["webGLReportService","octane.preloader.service.device.IWebGLReportService",""],["navigator","octane.browser.INavigator",""]]}};
octane_preloader_model_device_IWebGLBlacklistModel.__meta__ = { obj : { 'interface' : null}};
octane_preloader_model_host_IHostTypeModel.__meta__ = { obj : { 'interface' : null}};
octane_preloader_model_manifest_IPreloaderManifestModel.__meta__ = { obj : { 'interface' : null}};
octane_preloader_service_IFileLoadingService.__meta__ = { obj : { 'interface' : null}};
octane_preloader_service_FileLoadingService.__meta__ = { obj : { rtti : [["loaderModel","octane.preloader.model.IAssetLoadingModel",""],["preloaderUpdateService","octane.preloader.service.IHostPreloaderUpdateService",""],["progressTimer","octane.preloader.service.timer.ILoadingProgressTimerService",""],["deviceInformationModel","octane.preloader.model.device.IDeviceInformationModel",""],["postConstruct","1"]]}};
octane_preloader_service_FileLoadingService.FIRST_LOAD_BUNDLES_PERCENTAGE_SHARE = 50;
octane_preloader_service_FileLoadingService.FAKE_PROGRESS_CONTINUOUS_MS = 1900;
octane_preloader_service_FileLoadingService.FAKE_PROGRESS_INTERVAL_MIN_MS = 150;
octane_preloader_service_FileLoadingService.FAKE_PROGRESS_INTERVAL_MAX_MS = 750;
octane_preloader_service_FileLoadingService.FAKE_PROGRESS_INCREMENT_MIN = 1;
octane_preloader_service_FileLoadingService.FAKE_PROGRESS_INCREMENT_MAX = 4;
octane_preloader_service_FileLoadingService.STOP_INCREMENTING_AT_PERCENTAGE = 90;
octane_preloader_service_FileLoadingService.DEFAULT_MAX_CONNECTIONS = 10;
octane_preloader_service_IHostPreloaderUpdateService.__meta__ = { obj : { 'interface' : null}};
octane_preloader_service_IPreloaderNotificationService.__meta__ = { obj : { 'interface' : null}};
octane_preloader_service_asset_IAssetPathBuilderService.__meta__ = { obj : { 'interface' : null}};
octane_preloader_service_asset_AssetPathBuilderService.__meta__ = { obj : { rtti : [["imageScaleCalculatorService","octane.preloader.service.asset.IImageScaleCalculatorService",""],["imageFormatSelectionService","octane.preloader.service.asset.format.IImageFormatSelectionService",""],["audioFormatSelectionService","octane.preloader.service.asset.format.IAudioFormatSelectionService",""],["formFactorDetectionService","octane.preloader.service.formfactor.IFormFactorDetectionService",""]]}};
octane_preloader_service_asset_AssetPathBuilderService.imageFormatRegex = new EReg("\\{imageFormat}","g");
octane_preloader_service_asset_AssetPathBuilderService.imageScaleRegex = new EReg("\\{imageScale}","g");
octane_preloader_service_asset_AssetPathBuilderService.audioFormatRegex = new EReg("\\{audioFormat}","g");
octane_preloader_service_asset_AssetPathBuilderService.formFactorRegex = new EReg("\\{formFactor}","g");
octane_preloader_service_asset_IImageScaleCalculatorService.__meta__ = { obj : { 'interface' : null}};
octane_preloader_service_asset_IPerformanceLevelSelectionService.__meta__ = { obj : { 'interface' : null}};
octane_preloader_service_asset_WebImageScaleCalculatorService.__meta__ = { obj : { rtti : [["assetProfilesModel","octane.preloader.model.asset.profile.IAssetProfilesModel",""],["deviceSizeService","octane.preloader.service.device.IDeviceSizeService",""],["platformType","octane.preloader.service.platform.IPlatformDetectionService",""],["deviceInformationModel","octane.preloader.model.device.IDeviceInformationModel",""],["preloaderToggles","octane.preloader.toggle.PreloaderToggleModel",""],["packagedGameDetectionService","octane.preloader.service.packaged.IPackagedGameDetectionService",""]]}};
octane_preloader_service_asset_format_IAssetFormatService.__meta__ = { obj : { 'interface' : null}};
octane_preloader_service_asset_format_AssetFormatService.__meta__ = { obj : { rtti : [["modernizrService","octane.preloader.service.device.ModernizrService",""]]}};
octane_preloader_service_asset_format_IAudioFormatSelectionService.__meta__ = { obj : { 'interface' : null}};
octane_preloader_service_asset_format_AudioFormatSelectionService.__meta__ = { obj : { rtti : [["assetFormatService","octane.preloader.service.asset.format.IAssetFormatService",""],["assetProfilesModel","octane.preloader.model.asset.profile.IAssetProfilesModel",""],["packagedGameDetectionService","octane.preloader.service.packaged.IPackagedGameDetectionService",""]]}};
octane_preloader_service_asset_format_IImageFormatSelectionService.__meta__ = { obj : { 'interface' : null}};
octane_preloader_service_asset_format_ImageFormatSelectionService.__meta__ = { obj : { rtti : [["assetFormatService","octane.preloader.service.asset.format.IAssetFormatService",""],["assetProfilesModel","octane.preloader.model.asset.profile.IAssetProfilesModel",""],["packagedGameDetectionService","octane.preloader.service.packaged.IPackagedGameDetectionService",""]]}};
octane_preloader_service_bundle_IBundleExternalAssetLoadingService.__meta__ = { obj : { 'interface' : null}};
octane_preloader_service_bundle_BundleExternalAssetLoadingService.__meta__ = { obj : { rtti : [["fileLoader","octane.preloader.service.IFileLoadingService",""]]}};
octane_preloader_service_device_IDeviceSizeService.__meta__ = { obj : { 'interface' : null}};
octane_preloader_service_device_ISoundCapabilityService.__meta__ = { obj : { 'interface' : null}};
octane_preloader_service_device_IWebGLReportService.__meta__ = { obj : { 'interface' : null}};
octane_preloader_service_device_ModernizrService.__meta__ = { obj : { rtti : [["deviceInfo","octane.preloader.model.device.IDeviceInformationModel",""]]}};
octane_preloader_service_device_SoundCapabilityService.__meta__ = { obj : { rtti : [["modernizrService","octane.preloader.service.device.ModernizrService",""]]}};
octane_preloader_service_device_WebGLReportService.UNKNOWN = "Unknown";
octane_preloader_service_formfactor_IFormFactorDetectionService.__meta__ = { obj : { 'interface' : null}};
octane_preloader_service_formfactor_FormFactorDetectionService.__meta__ = { obj : { rtti : [["platformDetectionService","octane.preloader.service.platform.IPlatformDetectionService",""],["preloaderToggleModel","octane.preloader.toggle.PreloaderToggleModel",""]]}};
octane_preloader_service_formfactor_FormFactorDetectionService.DEFAULT_FORM_FACTOR = "mobile";
octane_preloader_service_packaged_IPackagedGameDetectionService.__meta__ = { obj : { 'interface' : null}};
octane_preloader_service_packaged_PackagedGameDetectionService.__meta__ = { obj : { rtti : [["preloaderToggleModel","octane.preloader.toggle.PreloaderToggleModel",""],["postConstruct","1"]]}};
octane_preloader_service_performance_IPerformanceTimingService.__meta__ = { obj : { 'interface' : null}};
octane_preloader_service_platform_IPlatformDetectionService.__meta__ = { obj : { 'interface' : null}};
octane_preloader_service_platform_PlatformDetectionService.__meta__ = { obj : { rtti : [["navigator","octane.browser.INavigator",""]]}};
octane_preloader_service_preloader_PreloaderUpdateService.__meta__ = { obj : { rtti : [["document","octane.browser.IDocument",""]]}};
octane_preloader_service_preloader_PreloaderUpdateService.BAR_ID = "octanePreloaderProgress";
octane_preloader_service_preloader_PreloaderUpdateService.TEXT_ID = "octanePreloaderPercent";
octane_preloader_service_preloader_PreloaderUpdateService.BAR_CLASS = "octanePreloaderProgressClass";
octane_preloader_service_timer_ILoadingProgressTimerService.__meta__ = { obj : { 'interface' : null}};
octane_preloader_service_timer_LoadingProgressTimerService.TIMER_NAME = "WebAssetLoadingServiceTimer";
octane_preloader_shell_controller_OnHostAPIAvailableCommand.__meta__ = { obj : { rtti : [["hostType","octane.preloader.model.host.IHostTypeModel",""],["startupStateMachine","octane.preloader.state.StartupStateMachine",""]]}};
octane_preloader_shell_controller_PopulateAssetProfilesCommand.__meta__ = { obj : { rtti : [["preloaderManifest","octane.preloader.model.manifest.IPreloaderManifestModel",""],["assetProfilesModel","octane.preloader.model.asset.profile.IAssetProfilesModel",""],["preloadedFiles","octane.preloader.model.IPreloadedFilesModel",""]]}};
octane_preloader_shell_controller_PopulatePreloaderManifestModelCommand.__meta__ = { obj : { rtti : [["preloaderManifest","octane.preloader.model.manifest.IPreloaderManifestModel",""]]}};
octane_preloader_shell_controller_StartPreloadingBundlesCommand.__meta__ = { obj : { rtti : [["assetLoader","octane.preloader.service.IFileLoadingService",""],["assetPathBuilder","octane.preloader.service.asset.IAssetPathBuilderService",""],["languagesModel","octane.preloader.model.ILanguageCodeModel",""],["manifest","octane.preloader.model.manifest.IPreloaderManifestModel",""],["multipartBundleModel","octane.preloader.model.IMultipartBundleModel",""],["preloadedFilesModel","octane.preloader.model.IPreloadedFilesModel",""]]}};
octane_preloader_shell_controller_StartPreloadingFilesCommand.__meta__ = { obj : { rtti : [["fileLoader","octane.preloader.service.IFileLoadingService",""],["manifest","octane.preloader.model.manifest.IPreloaderManifestModel",""],["languagesModel","octane.preloader.model.ILanguageCodeModel",""],["toggles","octane.preloader.toggle.PreloaderToggleModel",""],["performanceTiming","octane.preloader.service.performance.IPerformanceTimingService",""]]}};
octane_preloader_shell_controller_StartPreloadingScriptsCommand.__meta__ = { obj : { rtti : [["fileLoader","octane.preloader.service.IFileLoadingService",""],["manifest","octane.preloader.model.manifest.IPreloaderManifestModel",""],["formFactorDetectionService","octane.preloader.service.formfactor.IFormFactorDetectionService",""]]}};
octane_preloader_shell_controller_StoreCoalescedMultipartBundleCommand.__meta__ = { obj : { rtti : [["bundleName","String",""],["bundle","octane.core.mvc.controller.DynamicWrapper",""],["files","octane.preloader.model.IPreloadedFilesModel",""]]}};
octane_preloader_shell_controller_StorePreloadedFilesCommand.__meta__ = { obj : { rtti : [["preloadedFiles","octane.preloader.model.IPreloadedFilesModel",""],["multipartBundleModel","octane.preloader.model.IMultipartBundleModel",""],["externalAssetLoader","octane.preloader.service.bundle.IBundleExternalAssetLoadingService",""],["performanceTiming","octane.preloader.service.performance.IPerformanceTimingService",""],["asset","octane.core.mvc.controller.DynamicWrapper",""],["assetName","String",""]]}};
octane_preloader_shell_controller_StorePreloadedFilesCommand.COMMON = "common";
octane_preloader_shell_controller_WaitForHostInitCommand.__meta__ = { obj : { rtti : [["startupStateMachine","octane.preloader.state.StartupStateMachine",""]]}};
octane_preloader_shell_controller_mapping_DetermineHostTypeCommand.__meta__ = { obj : { rtti : [["startupStateMachine","octane.preloader.state.StartupStateMachine",""],["hostType","octane.preloader.model.host.IHostTypeModel",""]]}};
octane_preloader_shell_controller_mapping_MapCommandsCommand.__meta__ = { obj : { rtti : [["fileLoader","octane.preloader.service.IFileLoadingService",""],["multipartBundleModel","octane.preloader.model.IMultipartBundleModel",""]]}};
octane_preloader_shell_scripts_StorePreloadedScriptsCommand.__meta__ = { obj : { rtti : [["preloadedScripts","octane.preloader.shell.scripts.PreloadedScriptsModel",""],["scriptName","String",""]]}};
octane_preloader_shell_scripts_WaitForVendorAvailableCommand.__meta__ = { obj : { rtti : [["startupStateMachine","octane.preloader.state.StartupStateMachine",""],["preloadedScripts","octane.preloader.shell.scripts.PreloadedScriptsModel",""]]}};
octane_preloader_titan_controller_WaitForTitanCommand.__meta__ = { obj : { rtti : [["preloaderNotificationService","octane.preloader.service.IPreloaderNotificationService",""],["startupStateMachine","octane.preloader.state.StartupStateMachine",""],["hostType","octane.preloader.model.host.IHostTypeModel",""]]}};
octane_preloader_titan_model_TitanAssetLoadingModel.__meta__ = { obj : { rtti : [["postConstruct","1"]]}};
octane_preloader_toggle_PreloaderToggleModel.__meta__ = { obj : { rtti : [["urlParameters","octane.preloader.url.model.URLParametersModel",""],["postConstruct","1"]]}};
octane_preloader_v_controller_WaitForVCommand.__meta__ = { obj : { rtti : [["preloaderNotificationService","octane.preloader.service.IPreloaderNotificationService",""],["startupStateMachine","octane.preloader.state.StartupStateMachine",""],["hostType","octane.preloader.model.host.IHostTypeModel",""]]}, fields : { initGame : { SuppressWarnings : ["checkstyle:ParameterNumber"]}}};
octane_preloader_v_model_VLanguageCodeModel.DEFAULT_LANGUAGE_CODE = "en";
promhx_base_EventLoop.queue = new haxe_ds_List();
titan_api_ITitanAPI.__meta__ = { obj : { 'interface' : null}};
titan_api_analytics_IGameAnalytics.__meta__ = { obj : { 'interface' : null}};
titan_api_communication_ICommunication.__meta__ = { obj : { 'interface' : null}};
titan_api_config_IConfig.__meta__ = { obj : { 'interface' : null}};
titan_api_conversion_IConversion.__meta__ = { obj : { 'interface' : null}};
titan_api_navigation_INavigation.__meta__ = { obj : { 'interface' : null}};
titan_api_progress_IProgress.__meta__ = { obj : { 'interface' : null}};
titan_api_sound_ISound.__meta__ = { obj : { 'interface' : null}};
titan_api_storage_IStorage.__meta__ = { obj : { 'interface' : null}};
titan_bootstrap_IStartupInfo.__meta__ = { obj : { 'interface' : null}};
PreloaderMain.main();
})(typeof exports != "undefined" ? exports : typeof window != "undefined" ? window : typeof self != "undefined" ? self : this, typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this);
